{
  "PD": [
    "ABANO TERME",
    "AGNA",
    "ALBIGNASEGO",
    "ANGUILLARA VENETA",
    "ARQUA' PETRARCA",
    "ARRE",
    "ARZERGRANDE",
    "BAGNOLI DI SOPRA",
    "BAONE",
    "BARBONA",
    "BATTAGLIA TERME",
    "BOARA PISANI",
    "BORGO VENETO",
    "BORGORICCO",
    "BOVOLENTA",
    "BRUGINE",
    "CADONEGHE",
    "CAMPO SAN MARTINO",
    "CAMPODARSEGO",
    "CAMPODORO",
    "CAMPOSAMPIERO",
    "CANDIANA",
    "CARCERI",
    "CARMIGNANO DI BRENTA",
    "CARTURA",
    "CASALE DI SCODOSIA",
    "CASALSERUGO",
    "CASTELBALDO",
    "CERVARESE SANTA CROCE",
    "CINTO EUGANEO",
    "CITTADELLA",
    "CODEVIGO",
    "CONSELVE",
    "CORREZZOLA",
    "CURTAROLO",
    "DUE CARRARE",
    "ESTE",
    "FONTANIVA",
    "GALLIERA VENETA",
    "GALZIGNANO TERME",
    "GAZZO",
    "GRANTORTO",
    "GRANZE",
    "LEGNARO",
    "LIMENA",
    "LOREGGIA",
    "LOZZO ATESTINO",
    "MASERA' DI PADOVA",
    "MASI",
    "MASSANZAGO",
    "MEGLIADINO SAN FIDENZIO",
    "MEGLIADINO SAN VITALE",
    "MERLARA",
    "MESTRINO",
    "MONSELICE",
    "MONTAGNANA",
    "MONTEGROTTO TERME",
    "NOVENTA PADOVANA",
    "OSPEDALETTO EUGANEO",
    "PADOVA",
    "PERNUMIA",
    "PIACENZA D'ADIGE",
    "PIAZZOLA SUL BRENTA",
    "PIOMBINO DESE",
    "PIOVE DI SACCO",
    "POLVERARA",
    "PONSO",
    "PONTE SAN NICOLO'",
    "PONTELONGO",
    "POZZONOVO",
    "ROVOLON",
    "RUBANO",
    "SACCOLONGO",
    "SALETTO",
    "SAN GIORGIO DELLE PERTICHE",
    "SAN GIORGIO IN BOSCO",
    "SAN MARTINO DI LUPARI",
    "SAN PIETRO IN GU",
    "SAN PIETRO VIMINARIO",
    "SANTA GIUSTINA IN COLLE",
    "SANTA MARGHERITA D'ADIGE",
    "SANT'ANGELO DI PIOVE DI SACCO",
    "SANT'ELENA",
    "SANT'URBANO",
    "SAONARA",
    "SELVAZZANO DENTRO",
    "SOLESINO",
    "STANGHELLA",
    "TEOLO",
    "TERRASSA PADOVANA",
    "TOMBOLO",
    "TORREGLIA",
    "TREBASELEGHE",
    "TRIBANO",
    "URBANA",
    "VEGGIANO",
    "VESCOVANA",
    "VIGHIZZOLO D'ESTE",
    "VIGODARZERE",
    "VIGONZA",
    "VILLA DEL CONTE",
    "VILLA ESTENSE",
    "VILLAFRANCA PADOVANA",
    "VILLANOVA DI CAMPOSAMPIERO",
    "VO'"
  ],
  "LO": [
    "ABBADIA CERRETO",
    "BERTONICO",
    "BOFFALORA D'ADDA",
    "BORGHETTO LODIGIANO",
    "BORGO SAN GIOVANNI",
    "BREMBIO",
    "CAMAIRAGO",
    "CASALETTO LODIGIANO",
    "CASALMAIOCCO",
    "CASALPUSTERLENGO",
    "CASELLE LANDI",
    "CASELLE LURANI",
    "CASTELGERUNDO",
    "CASTELNUOVO BOCCA D'ADDA",
    "CASTIGLIONE D'ADDA",
    "CASTIRAGA VIDARDO",
    "CAVACURTA",
    "CAVENAGO D'ADDA",
    "CERVIGNANO D'ADDA",
    "CODOGNO",
    "COMAZZO",
    "CORNEGLIANO LAUDENSE",
    "CORNO GIOVINE",
    "CORNOVECCHIO",
    "CORTE PALASIO",
    "CRESPIATICA",
    "FOMBIO",
    "GALGAGNANO",
    "GRAFFIGNANA",
    "GUARDAMIGLIO",
    "LIVRAGA",
    "LODI",
    "LODI VECCHIO",
    "MACCASTORNA",
    "MAIRAGO",
    "MALEO",
    "MARUDO",
    "MASSALENGO",
    "MELETI",
    "MERLINO",
    "MONTANASO LOMBARDO",
    "MULAZZANO",
    "ORIO LITTA",
    "OSPEDALETTO LODIGIANO",
    "OSSAGO LODIGIANO",
    "PIEVE FISSIRAGA",
    "SALERANO SUL LAMBRO",
    "SAN FIORANO",
    "SAN MARTINO IN STRADA",
    "SAN ROCCO AL PORTO",
    "SANT'ANGELO LODIGIANO",
    "SANTO STEFANO LODIGIANO",
    "SECUGNAGO",
    "SENNA LODIGIANA",
    "SOMAGLIA",
    "SORDIO",
    "TAVAZZANO CON VILLAVESCO",
    "TERRANOVA DEI PASSERINI",
    "TURANO LODIGIANO",
    "VALERA FRATTA",
    "VILLANOVA DEL SILLARO",
    "ZELO BUON PERSICO"
  ],
  "LC": [
    "ABBADIA LARIANA",
    "AIRUNO",
    "ANNONE DI BRIANZA",
    "BALLABIO",
    "BARZAGO",
    "BARZANO'",
    "BARZIO",
    "BELLANO",
    "BOSISIO PARINI",
    "BRIVIO",
    "BULCIAGO",
    "CALCO",
    "CALOLZIOCORTE",
    "CARENNO",
    "CASARGO",
    "CASATENOVO",
    "CASSAGO BRIANZA",
    "CASSINA VALSASSINA",
    "CASTELLO DI BRIANZA",
    "CERNUSCO LOMBARDONE",
    "CESANA BRIANZA",
    "CIVATE",
    "COLICO",
    "COLLE BRIANZA",
    "CORTENOVA",
    "COSTA MASNAGA",
    "CRANDOLA VALSASSINA",
    "CREMELLA",
    "CREMENO",
    "DERVIO",
    "DOLZAGO",
    "DORIO",
    "ELLO",
    "ERVE",
    "ESINO LARIO",
    "GALBIATE",
    "GARBAGNATE MONASTERO",
    "GARLATE",
    "IMBERSAGO",
    "INTROBIO",
    "INTROZZO",
    "LA VALLETTA BRIANZA",
    "LECCO",
    "LIERNA",
    "LOMAGNA",
    "MALGRATE",
    "MANDELLO DEL LARIO",
    "MARGNO",
    "MERATE",
    "MISSAGLIA",
    "MOGGIO",
    "MOLTENO",
    "MONTE MARENZO",
    "MONTEVECCHIA",
    "MONTICELLO BRIANZA",
    "MORTERONE",
    "NIBIONNO",
    "OGGIONO",
    "OLGIATE MOLGORA",
    "OLGINATE",
    "OLIVETO LARIO",
    "OSNAGO",
    "PADERNO D'ADDA",
    "PAGNONA",
    "PARLASCO",
    "PASTURO",
    "PEREGO",
    "PERLEDO",
    "PESCATE",
    "PREMANA",
    "PRIMALUNA",
    "ROBBIATE",
    "ROGENO",
    "ROVAGNATE",
    "SANTA MARIA HOE'",
    "SIRONE",
    "SIRTORI",
    "SUEGLIO",
    "SUELLO",
    "TACENO",
    "TREMENICO",
    "VALGREGHENTINO",
    "VALMADRERA",
    "VALVARRONE",
    "VARENNA",
    "VENDROGNO",
    "VERCURAGO",
    "VERDERIO",
    "VERDERIO INFERIORE",
    "VERDERIO SUPERIORE",
    "VESTRENO",
    "VIGANO'"
  ],
  "SI": [
    "ABBADIA SAN SALVATORE",
    "ASCIANO",
    "BUONCONVENTO",
    "CASOLE D'ELSA",
    "CASTELLINA IN CHIANTI",
    "CASTELNUOVO BERARDENGA",
    "CASTIGLIONE D'ORCIA",
    "CETONA",
    "CHIANCIANO TERME",
    "CHIUSDINO",
    "CHIUSI",
    "COLLE DI VAL D'ELSA",
    "GAIOLE IN CHIANTI",
    "MONTALCINO",
    "MONTEPULCIANO",
    "MONTERIGGIONI",
    "MONTERONI D'ARBIA",
    "MONTICIANO",
    "MURLO",
    "PIANCASTAGNAIO",
    "PIENZA",
    "POGGIBONSI",
    "RADDA IN CHIANTI",
    "RADICOFANI",
    "RADICONDOLI",
    "RAPOLANO TERME",
    "SAN CASCIANO DEI BAGNI",
    "SAN GIMIGNANO",
    "SAN GIOVANNI D'ASSO",
    "SAN QUIRICO D'ORCIA",
    "SARTEANO",
    "SIENA",
    "SINALUNGA",
    "SOVICILLE",
    "TORRITA DI SIENA",
    "TREQUANDA"
  ],
  "OR": [
    "ABBASANTA",
    "AIDOMAGGIORE",
    "ALBAGIARA",
    "ALES",
    "ALLAI",
    "ARBOREA",
    "ARDAULI",
    "ASSOLO",
    "ASUNI",
    "BARADILI",
    "BARATILI SAN PIETRO",
    "BARESSA",
    "BAULADU",
    "BIDONI'",
    "BONARCADO",
    "BORONEDDU",
    "BOSA",
    "BUSACHI",
    "CABRAS",
    "CUGLIERI",
    "CURCURIS",
    "FLUSSIO",
    "FORDONGIANUS",
    "GHILARZA",
    "GONNOSCODINA",
    "GONNOSNO'",
    "GONNOSTRAMATZA",
    "LACONI",
    "MAGOMADAS",
    "MARRUBIU",
    "MASULLAS",
    "MILIS",
    "MODOLO",
    "MOGORELLA",
    "MOGORO",
    "MONTRESTA",
    "MORGONGIORI",
    "NARBOLIA",
    "NEONELI",
    "NORBELLO",
    "NUGHEDU SANTA VITTORIA",
    "NURACHI",
    "NURECI",
    "OLLASTRA",
    "ORISTANO",
    "PALMAS ARBOREA",
    "PAU",
    "PAULILATINO",
    "POMPU",
    "RIOLA SARDO",
    "RUINAS",
    "SAGAMA",
    "SAMUGHEO",
    "SAN NICOLO' D'ARCIDANO",
    "SAN VERO MILIS",
    "SANTA GIUSTA",
    "SANTU LUSSURGIU",
    "SCANO DI MONTIFERRO",
    "SEDILO",
    "SENEGHE",
    "SENIS",
    "SENNARIOLO",
    "SIAMAGGIORE",
    "SIAMANNA",
    "SIAPICCIA",
    "SIMALA",
    "SIMAXIS",
    "SINI",
    "SIRIS",
    "SODDI'",
    "SOLARUSSA",
    "SORRADILE",
    "SUNI",
    "TADASUNI",
    "TERRALBA",
    "TINNURA",
    "TRAMATZA",
    "TRESNURAGHES",
    "ULA' TIRSO",
    "URAS",
    "USELLUS",
    "VILLA SANT'ANTONIO",
    "VILLA VERDE",
    "VILLANOVA TRUSCHEDU",
    "VILLAURBANA",
    "ZEDDIANI",
    "ZERFALIU"
  ],
  "PE": [
    "ABBATEGGIO",
    "ALANNO",
    "BOLOGNANO",
    "BRITTOLI",
    "BUSSI SUL TIRINO",
    "CAPPELLE SUL TAVO",
    "CARAMANICO TERME",
    "CARPINETO DELLA NORA",
    "CASTIGLIONE A CASAURIA",
    "CATIGNANO",
    "CEPAGATTI",
    "CITTA' SANT'ANGELO",
    "CIVITAQUANA",
    "CIVITELLA CASANOVA",
    "COLLECORVINO",
    "CORVARA",
    "CUGNOLI",
    "ELICE",
    "FARINDOLA",
    "LETTOMANOPPELLO",
    "LORETO APRUTINO",
    "MANOPPELLO",
    "MONTEBELLO DI BERTONA",
    "MONTESILVANO",
    "MOSCUFO",
    "NOCCIANO",
    "PENNE",
    "PESCARA",
    "PESCOSANSONESCO",
    "PIANELLA",
    "PICCIANO",
    "PIETRANICO",
    "POPOLI",
    "ROCCAMORICE",
    "ROSCIANO",
    "SALLE",
    "SAN VALENTINO IN ABRUZZO CITERIORE",
    "SANT'EUFEMIA A MAIELLA",
    "SCAFA",
    "SERRAMONACESCA",
    "SPOLTORE",
    "TOCCO DA CASAURIA",
    "TORRE DE' PASSERI",
    "TURRIVALIGNANI",
    "VICOLI",
    "VILLA CELIERA"
  ],
  "MI": [
    "ABBIATEGRASSO",
    "ALBAIRATE",
    "ARCONATE",
    "ARESE",
    "ARLUNO",
    "ASSAGO",
    "BARANZATE",
    "BAREGGIO",
    "BASIANO",
    "BASIGLIO",
    "BELLINZAGO LOMBARDO",
    "BERNATE TICINO",
    "BESATE",
    "BINASCO",
    "BOFFALORA SOPRA TICINO",
    "BOLLATE",
    "BRESSO",
    "BUBBIANO",
    "BUCCINASCO",
    "BUSCATE",
    "BUSSERO",
    "BUSTO GAROLFO",
    "CALVIGNASCO",
    "CAMBIAGO",
    "CANEGRATE",
    "CARPIANO",
    "CARUGATE",
    "CASARILE",
    "CASOREZZO",
    "CASSANO D'ADDA",
    "CASSINA DE' PECCHI",
    "CASSINETTA DI LUGAGNANO",
    "CASTANO PRIMO",
    "CERNUSCO SUL NAVIGLIO",
    "CERRO AL LAMBRO",
    "CERRO MAGGIORE",
    "CESANO BOSCONE",
    "CESATE",
    "CINISELLO BALSAMO",
    "CISLIANO",
    "COLOGNO MONZESE",
    "COLTURANO",
    "CORBETTA",
    "CORMANO",
    "CORNAREDO",
    "CORSICO",
    "CUGGIONO",
    "CUSAGO",
    "CUSANO MILANINO",
    "DAIRAGO",
    "DRESANO",
    "GAGGIANO",
    "GARBAGNATE MILANESE",
    "GESSATE",
    "GORGONZOLA",
    "GREZZAGO",
    "GUDO VISCONTI",
    "INVERUNO",
    "INZAGO",
    "LACCHIARELLA",
    "LAINATE",
    "LEGNANO",
    "LISCATE",
    "LOCATE DI TRIULZI",
    "MAGENTA",
    "MAGNAGO",
    "MARCALLO CON CASONE",
    "MASATE",
    "MEDIGLIA",
    "MELEGNANO",
    "MELZO",
    "MESERO",
    "MILANO",
    "MORIMONDO",
    "MOTTA VISCONTI",
    "NERVIANO",
    "NOSATE",
    "NOVATE MILANESE",
    "NOVIGLIO",
    "OPERA",
    "OSSONA",
    "OZZERO",
    "PADERNO DUGNANO",
    "PANTIGLIATE",
    "PARABIAGO",
    "PAULLO",
    "PERO",
    "PESCHIERA BORROMEO",
    "PESSANO CON BORNAGO",
    "PIEVE EMANUELE",
    "PIOLTELLO",
    "POGLIANO MILANESE",
    "POZZO D'ADDA",
    "POZZUOLO MARTESANA",
    "PREGNANA MILANESE",
    "RESCALDINA",
    "RHO",
    "ROBECCHETTO CON INDUNO",
    "ROBECCO SUL NAVIGLIO",
    "RODANO",
    "ROSATE",
    "ROZZANO",
    "SAN COLOMBANO AL LAMBRO",
    "SAN DONATO MILANESE",
    "SAN GIORGIO SU LEGNANO",
    "SAN GIULIANO MILANESE",
    "SAN VITTORE OLONA",
    "SAN ZENONE AL LAMBRO",
    "SANTO STEFANO TICINO",
    "SEDRIANO",
    "SEGRATE",
    "SENAGO",
    "SESTO SAN GIOVANNI",
    "SETTALA",
    "SETTIMO MILANESE",
    "SOLARO",
    "TREZZANO ROSA",
    "TREZZANO SUL NAVIGLIO",
    "TREZZO SULL'ADDA",
    "TRIBIANO",
    "TRUCCAZZANO",
    "TURBIGO",
    "VANZAGHELLO",
    "VANZAGO",
    "VAPRIO D'ADDA",
    "VERMEZZO",
    "VERMEZZO CON ZELO",
    "VERNATE",
    "VIGNATE",
    "VILLA CORTESE",
    "VIMODRONE",
    "VITTUONE",
    "VIZZOLO PREDABISSI",
    "ZELO SURRIGONE",
    "ZIBIDO SAN GIACOMO"
  ],
  "PT": [
    "ABETONE",
    "ABETONE CUTIGLIANO",
    "AGLIANA",
    "BUGGIANO",
    "CHIESINA UZZANESE",
    "CUTIGLIANO",
    "LAMPORECCHIO",
    "LARCIANO",
    "MARLIANA",
    "MASSA E COZZILE",
    "MONSUMMANO TERME",
    "MONTALE",
    "MONTECATINI TERME",
    "PESCIA",
    "PIEVE A NIEVOLE",
    "PISTOIA",
    "PITEGLIO",
    "PONTE BUGGIANESE",
    "QUARRATA",
    "SAMBUCA PISTOIESE",
    "SAN MARCELLO PISTOIESE",
    "SAN MARCELLO PITEGLIO",
    "SERRAVALLE PISTOIESE",
    "UZZANO"
  ],
  "PZ": [
    "ABRIOLA",
    "ACERENZA",
    "ALBANO DI LUCANIA",
    "ANZI",
    "ARMENTO",
    "ATELLA",
    "AVIGLIANO",
    "BALVANO",
    "BANZI",
    "BARAGIANO",
    "BARILE",
    "BELLA",
    "BRIENZA",
    "BRINDISI MONTAGNA",
    "CALVELLO",
    "CALVERA",
    "CAMPOMAGGIORE",
    "CANCELLARA",
    "CARBONE",
    "CASTELGRANDE",
    "CASTELLUCCIO INFERIORE",
    "CASTELLUCCIO SUPERIORE",
    "CASTELMEZZANO",
    "CASTELSARACENO",
    "CASTRONUOVO DI SANT'ANDREA",
    "CERSOSIMO",
    "CHIAROMONTE",
    "CORLETO PERTICARA",
    "EPISCOPIA",
    "FARDELLA",
    "FILIANO",
    "FORENZA",
    "FRANCAVILLA IN SINNI",
    "GALLICCHIO",
    "GENZANO DI LUCANIA",
    "GINESTRA",
    "GRUMENTO NOVA",
    "GUARDIA PERTICARA",
    "LAGONEGRO",
    "LATRONICO",
    "LAURENZANA",
    "LAURIA",
    "LAVELLO",
    "MARATEA",
    "MARSICO NUOVO",
    "MARSICOVETERE",
    "MASCHITO",
    "MELFI",
    "MISSANELLO",
    "MOLITERNO",
    "MONTEMILONE",
    "MONTEMURRO",
    "MURO LUCANO",
    "NEMOLI",
    "NOEPOLI",
    "OPPIDO LUCANO",
    "PALAZZO SAN GERVASIO",
    "PATERNO",
    "PESCOPAGANO",
    "PICERNO",
    "PIETRAGALLA",
    "PIETRAPERTOSA",
    "PIGNOLA",
    "POTENZA",
    "RAPOLLA",
    "RAPONE",
    "RIONERO IN VULTURE",
    "RIPACANDIDA",
    "RIVELLO",
    "ROCCANOVA",
    "ROTONDA",
    "RUOTI",
    "RUVO DEL MONTE",
    "SAN CHIRICO NUOVO",
    "SAN CHIRICO RAPARO",
    "SAN COSTANTINO ALBANESE",
    "SAN FELE",
    "SAN MARTINO D'AGRI",
    "SAN PAOLO ALBANESE",
    "SAN SEVERINO LUCANO",
    "SANT'ANGELO LE FRATTE",
    "SANT'ARCANGELO",
    "SARCONI",
    "SASSO DI CASTALDA",
    "SATRIANO DI LUCANIA",
    "SAVOIA DI LUCANIA",
    "SENISE",
    "SPINOSO",
    "TEANA",
    "TERRANOVA DI POLLINO",
    "TITO",
    "TOLVE",
    "TRAMUTOLA",
    "TRECCHINA",
    "TRIVIGNO",
    "VAGLIO BASILICATA",
    "VENOSA",
    "VIETRI DI POTENZA",
    "VIGGIANELLO",
    "VIGGIANO"
  ],
  "RG": [
    "ACATE",
    "CHIARAMONTE GULFI",
    "COMISO",
    "GIARRATANA",
    "ISPICA",
    "MODICA",
    "MONTEROSSO ALMO",
    "POZZALLO",
    "RAGUSA",
    "SANTA CROCE CAMERINA",
    "SCICLI",
    "VITTORIA"
  ],
  "FG": [
    "ACCADIA",
    "ALBERONA",
    "ANZANO DI PUGLIA",
    "APRICENA",
    "ASCOLI SATRIANO",
    "BICCARI",
    "BOVINO",
    "CAGNANO VARANO",
    "CANDELA",
    "CARAPELLE",
    "CARLANTINO",
    "CARPINO",
    "CASALNUOVO MONTEROTARO",
    "CASALVECCHIO DI PUGLIA",
    "CASTELLUCCIO DEI SAURI",
    "CASTELLUCCIO VALMAGGIORE",
    "CASTELNUOVO DELLA DAUNIA",
    "CELENZA VALFORTORE",
    "CELLE DI SAN VITO",
    "CERIGNOLA",
    "CHIEUTI",
    "DELICETO",
    "FAETO",
    "FOGGIA",
    "ISCHITELLA",
    "ISOLE TREMITI",
    "LESINA",
    "LUCERA",
    "MANFREDONIA",
    "MATTINATA",
    "MONTE SANT'ANGELO",
    "MONTELEONE DI PUGLIA",
    "MOTTA MONTECORVINO",
    "ORDONA",
    "ORSARA DI PUGLIA",
    "ORTA NOVA",
    "PANNI",
    "PESCHICI",
    "PIETRAMONTECORVINO",
    "POGGIO IMPERIALE",
    "RIGNANO GARGANICO",
    "ROCCHETTA SANT'ANTONIO",
    "RODI GARGANICO",
    "ROSETO VALFORTORE",
    "SAN GIOVANNI ROTONDO",
    "SAN MARCO IN LAMIS",
    "SAN MARCO LA CATOLA",
    "SAN NICANDRO GARGANICO",
    "SAN PAOLO DI CIVITATE",
    "SAN SEVERO",
    "SANT'AGATA DI PUGLIA",
    "SERRACAPRIOLA",
    "STORNARA",
    "STORNARELLA",
    "TORREMAGGIORE",
    "TROIA",
    "VICO DEL GARGANO",
    "VIESTE",
    "VOLTURARA APPULA",
    "VOLTURINO",
    "ZAPPONETA"
  ],
  "CN": [
    "ACCEGLIO",
    "AISONE",
    "ALBA",
    "ALBARETTO DELLA TORRE",
    "ALTO",
    "ARGENTERA",
    "ARGUELLO",
    "BAGNASCO",
    "BAGNOLO PIEMONTE",
    "BALDISSERO D'ALBA",
    "BARBARESCO",
    "BARGE",
    "BAROLO",
    "BASTIA MONDOVI'",
    "BATTIFOLLO",
    "BEINETTE",
    "BELLINO",
    "BELVEDERE LANGHE",
    "BENE VAGIENNA",
    "BENEVELLO",
    "BERGOLO",
    "BERNEZZO",
    "BONVICINO",
    "BORGO SAN DALMAZZO",
    "BORGOMALE",
    "BOSIA",
    "BOSSOLASCO",
    "BOVES",
    "BRA",
    "BRIAGLIA",
    "BRIGA ALTA",
    "BRONDELLO",
    "BROSSASCO",
    "BUSCA",
    "CAMERANA",
    "CAMO",
    "CANALE",
    "CANOSIO",
    "CAPRAUNA",
    "CARAGLIO",
    "CARAMAGNA PIEMONTE",
    "CARDE'",
    "CARRU'",
    "CARTIGNANO",
    "CASALGRASSO",
    "CASTAGNITO",
    "CASTELDELFINO",
    "CASTELLAR",
    "CASTELLETTO STURA",
    "CASTELLETTO UZZONE",
    "CASTELLINALDO",
    "CASTELLINO TANARO",
    "CASTELMAGNO",
    "CASTELNUOVO DI CEVA",
    "CASTIGLIONE FALLETTO",
    "CASTIGLIONE TINELLA",
    "CASTINO",
    "CAVALLERLEONE",
    "CAVALLERMAGGIORE",
    "CELLE DI MACRA",
    "CENTALLO",
    "CERESOLE ALBA",
    "CERRETTO LANGHE",
    "CERVASCA",
    "CERVERE",
    "CEVA",
    "CHERASCO",
    "CHIUSA DI PESIO",
    "CIGLIE'",
    "CISSONE",
    "CLAVESANA",
    "CORNELIANO D'ALBA",
    "CORTEMILIA",
    "COSSANO BELBO",
    "COSTIGLIOLE SALUZZO",
    "CRAVANZANA",
    "CRISSOLO",
    "CUNEO",
    "DEMONTE",
    "DIANO D'ALBA",
    "DOGLIANI",
    "DRONERO",
    "ELVA",
    "ENTRACQUE",
    "ENVIE",
    "FARIGLIANO",
    "FAULE",
    "FEISOGLIO",
    "FOSSANO",
    "FRABOSA SOPRANA",
    "FRABOSA SOTTANA",
    "FRASSINO",
    "GAIOLA",
    "GAMBASCA",
    "GARESSIO",
    "GENOLA",
    "GORZEGNO",
    "GOTTASECCA",
    "GOVONE",
    "GRINZANE CAVOUR",
    "GUARENE",
    "IGLIANO",
    "ISASCA",
    "LA MORRA",
    "LAGNASCO",
    "LEQUIO BERRIA",
    "LEQUIO TANARO",
    "LESEGNO",
    "LEVICE",
    "LIMONE PIEMONTE",
    "LISIO",
    "MACRA",
    "MAGLIANO ALFIERI",
    "MAGLIANO ALPI",
    "MANGO",
    "MANTA",
    "MARENE",
    "MARGARITA",
    "MARMORA",
    "MARSAGLIA",
    "MARTINIANA PO",
    "MELLE",
    "MOIOLA",
    "MOMBARCARO",
    "MOMBASIGLIO",
    "MONASTERO DI VASCO",
    "MONASTEROLO CASOTTO",
    "MONASTEROLO DI SAVIGLIANO",
    "MONCHIERO",
    "MONDOVI'",
    "MONESIGLIO",
    "MONFORTE D'ALBA",
    "MONTA'",
    "MONTALDO DI MONDOVI'",
    "MONTALDO ROERO",
    "MONTANERA",
    "MONTELUPO ALBESE",
    "MONTEMALE DI CUNEO",
    "MONTEROSSO GRANA",
    "MONTEU ROERO",
    "MONTEZEMOLO",
    "MONTICELLO D'ALBA",
    "MORETTA",
    "MOROZZO",
    "MURAZZANO",
    "MURELLO",
    "NARZOLE",
    "NEIVE",
    "NEVIGLIE",
    "NIELLA BELBO",
    "NIELLA TANARO",
    "NOVELLO",
    "NUCETTO",
    "ONCINO",
    "ORMEA",
    "OSTANA",
    "PAESANA",
    "PAGNO",
    "PAMPARATO",
    "PAROLDO",
    "PERLETTO",
    "PERLO",
    "PEVERAGNO",
    "PEZZOLO VALLE UZZONE",
    "PIANFEI",
    "PIASCO",
    "PIETRAPORZIO",
    "PIOBESI D'ALBA",
    "PIOZZO",
    "POCAPAGLIA",
    "POLONGHERA",
    "PONTECHIANALE",
    "PRADLEVES",
    "PRAZZO",
    "PRIERO",
    "PRIOCCA",
    "PRIOLA",
    "PRUNETTO",
    "RACCONIGI",
    "REVELLO",
    "RIFREDDO",
    "RITTANA",
    "ROASCHIA",
    "ROASCIO",
    "ROBILANTE",
    "ROBURENT",
    "ROCCA CIGLIE'",
    "ROCCA DE' BALDI",
    "ROCCABRUNA",
    "ROCCAFORTE MONDOVI'",
    "ROCCASPARVERA",
    "ROCCAVIONE",
    "ROCCHETTA BELBO",
    "RODDI",
    "RODDINO",
    "RODELLO",
    "ROSSANA",
    "RUFFIA",
    "SALE DELLE LANGHE",
    "SALE SAN GIOVANNI",
    "SALICETO",
    "SALMOUR",
    "SALUZZO",
    "SAMBUCO",
    "SAMPEYRE",
    "SAN BENEDETTO BELBO",
    "SAN DAMIANO MACRA",
    "SAN MICHELE MONDOVI'",
    "SANFRE'",
    "SANFRONT",
    "SANTA VITTORIA D'ALBA",
    "SANT'ALBANO STURA",
    "SANTO STEFANO BELBO",
    "SANTO STEFANO ROERO",
    "SAVIGLIANO",
    "SCAGNELLO",
    "SCARNAFIGI",
    "SERRALUNGA D'ALBA",
    "SERRAVALLE LANGHE",
    "SINIO",
    "SOMANO",
    "SOMMARIVA DEL BOSCO",
    "SOMMARIVA PERNO",
    "STROPPO",
    "TARANTASCA",
    "TORRE BORMIDA",
    "TORRE MONDOVI'",
    "TORRE SAN GIORGIO",
    "TORRESINA",
    "TREISO",
    "TREZZO TINELLA",
    "TRINITA'",
    "VALDIERI",
    "VALGRANA",
    "VALLORIATE",
    "VALMALA",
    "VENASCA",
    "VERDUNO",
    "VERNANTE",
    "VERZUOLO",
    "VEZZA D'ALBA",
    "VICOFORTE",
    "VIGNOLO",
    "VILLAFALLETTO",
    "VILLANOVA MONDOVI'",
    "VILLANOVA SOLARO",
    "VILLAR SAN COSTANZO",
    "VINADIO",
    "VIOLA",
    "VOTTIGNASCO"
  ],
  "MT": [
    "ACCETTURA",
    "ALIANO",
    "BERNALDA",
    "CALCIANO",
    "CIRIGLIANO",
    "COLOBRARO",
    "CRACO",
    "FERRANDINA",
    "GARAGUSO",
    "GORGOGLIONE",
    "GRASSANO",
    "GROTTOLE",
    "IRSINA",
    "MATERA",
    "MIGLIONICO",
    "MONTALBANO JONICO",
    "MONTESCAGLIOSO",
    "NOVA SIRI",
    "OLIVETO LUCANO",
    "PISTICCI",
    "POLICORO",
    "POMARICO",
    "ROTONDELLA",
    "SALANDRA",
    "SAN GIORGIO LUCANO",
    "SAN MAURO FORTE",
    "SCANZANO JONICO",
    "STIGLIANO",
    "TRICARICO",
    "TURSI",
    "VALSINNI"
  ],
  "AQ": [
    "ACCIANO",
    "AIELLI",
    "ALFEDENA",
    "ANVERSA DEGLI ABRUZZI",
    "ATELETA",
    "AVEZZANO",
    "BALSORANO",
    "BARETE",
    "BARISCIANO",
    "BARREA",
    "BISEGNA",
    "BUGNARA",
    "CAGNANO AMITERNO",
    "CALASCIO",
    "CAMPO DI GIOVE",
    "CAMPOTOSTO",
    "CANISTRO",
    "CANSANO",
    "CAPESTRANO",
    "CAPISTRELLO",
    "CAPITIGNANO",
    "CAPORCIANO",
    "CAPPADOCIA",
    "CARAPELLE CALVISIO",
    "CARSOLI",
    "CASTEL DEL MONTE",
    "CASTEL DI IERI",
    "CASTEL DI SANGRO",
    "CASTELLAFIUME",
    "CASTELVECCHIO CALVISIO",
    "CASTELVECCHIO SUBEQUO",
    "CELANO",
    "CERCHIO",
    "CIVITA D'ANTINO",
    "CIVITELLA ALFEDENA",
    "CIVITELLA ROVETO",
    "COCULLO",
    "COLLARMELE",
    "COLLELONGO",
    "COLLEPIETRO",
    "CORFINIO",
    "FAGNANO ALTO",
    "FONTECCHIO",
    "FOSSA",
    "GAGLIANO ATERNO",
    "GIOIA DEI MARSI",
    "GORIANO SICOLI",
    "INTRODACQUA",
    "L'AQUILA",
    "LECCE NEI MARSI",
    "LUCO DEI MARSI",
    "LUCOLI",
    "MAGLIANO DE' MARSI",
    "MASSA D'ALBE",
    "MOLINA ATERNO",
    "MONTEREALE",
    "MORINO",
    "NAVELLI",
    "OCRE",
    "OFENA",
    "OPI",
    "ORICOLA",
    "ORTONA DEI MARSI",
    "ORTUCCHIO",
    "OVINDOLI",
    "PACENTRO",
    "PERETO",
    "PESCASSEROLI",
    "PESCINA",
    "PESCOCOSTANZO",
    "PETTORANO SUL GIZIO",
    "PIZZOLI",
    "POGGIO PICENZE",
    "PRATA D'ANSIDONIA",
    "PRATOLA PELIGNA",
    "PREZZA",
    "RAIANO",
    "RIVISONDOLI",
    "ROCCA DI BOTTE",
    "ROCCA DI CAMBIO",
    "ROCCA DI MEZZO",
    "ROCCA PIA",
    "ROCCACASALE",
    "ROCCARASO",
    "SAN BENEDETTO DEI MARSI",
    "SAN BENEDETTO IN PERILLIS",
    "SAN DEMETRIO NE' VESTINI",
    "SAN PIO DELLE CAMERE",
    "SAN VINCENZO VALLE ROVETO",
    "SANTE MARIE",
    "SANT'EUSANIO FORCONESE",
    "SANTO STEFANO DI SESSANIO",
    "SCANNO",
    "SCONTRONE",
    "SCOPPITO",
    "SCURCOLA MARSICANA",
    "SECINARO",
    "SULMONA",
    "TAGLIACOZZO",
    "TIONE DEGLI ABRUZZI",
    "TORNIMPARTE",
    "TRASACCO",
    "VILLA SANTA LUCIA DEGLI ABRUZZI",
    "VILLA SANT'ANGELO",
    "VILLALAGO",
    "VILLAVALLELONGA",
    "VILLETTA BARREA",
    "VITTORITO"
  ],
  "RI": [
    "ACCUMOLI",
    "AMATRICE",
    "ANTRODOCO",
    "ASCREA",
    "BELMONTE IN SABINA",
    "BORBONA",
    "BORGO VELINO",
    "BORGOROSE",
    "CANTALICE",
    "CANTALUPO IN SABINA",
    "CASAPROTA",
    "CASPERIA",
    "CASTEL DI TORA",
    "CASTEL SANT'ANGELO",
    "CASTELNUOVO DI FARFA",
    "CITTADUCALE",
    "CITTAREALE",
    "COLLALTO SABINO",
    "COLLE DI TORA",
    "COLLEGIOVE",
    "COLLEVECCHIO",
    "COLLI SUL VELINO",
    "CONCERVIANO",
    "CONFIGNI",
    "CONTIGLIANO",
    "COTTANELLO",
    "FARA IN SABINA",
    "FIAMIGNANO",
    "FORANO",
    "FRASSO SABINO",
    "GRECCIO",
    "LABRO",
    "LEONESSA",
    "LONGONE SABINO",
    "MAGLIANO SABINA",
    "MARCETELLI",
    "MICIGLIANO",
    "MOMPEO",
    "MONTASOLA",
    "MONTE SAN GIOVANNI IN SABINA",
    "MONTEBUONO",
    "MONTELEONE SABINO",
    "MONTENERO SABINO",
    "MONTOPOLI DI SABINA",
    "MORRO REATINO",
    "NESPOLO",
    "ORVINIO",
    "PAGANICO SABINO",
    "PESCOROCCHIANO",
    "PETRELLA SALTO",
    "POGGIO BUSTONE",
    "POGGIO CATINO",
    "POGGIO MIRTETO",
    "POGGIO MOIANO",
    "POGGIO NATIVO",
    "POGGIO SAN LORENZO",
    "POSTA",
    "POZZAGLIA SABINA",
    "RIETI",
    "RIVODUTRI",
    "ROCCA SINIBALDA",
    "ROCCANTICA",
    "SALISANO",
    "SCANDRIGLIA",
    "SELCI",
    "STIMIGLIANO",
    "TARANO",
    "TOFFIA",
    "TORRI IN SABINA",
    "TORRICELLA IN SABINA",
    "TURANIA",
    "VACONE",
    "VARCO SABINO"
  ],
  "SA": [
    "ACERNO",
    "AGROPOLI",
    "ALBANELLA",
    "ALFANO",
    "ALTAVILLA SILENTINA",
    "AMALFI",
    "ANGRI",
    "AQUARA",
    "ASCEA",
    "ATENA LUCANA",
    "ATRANI",
    "AULETTA",
    "BARONISSI",
    "BATTIPAGLIA",
    "BELLIZZI",
    "BELLOSGUARDO",
    "BRACIGLIANO",
    "BUCCINO",
    "BUONABITACOLO",
    "CAGGIANO",
    "CALVANICO",
    "CAMEROTA",
    "CAMPAGNA",
    "CAMPORA",
    "CANNALONGA",
    "CAPACCIO",
    "CASAL VELINO",
    "CASALBUONO",
    "CASALETTO SPARTANO",
    "CASELLE IN PITTARI",
    "CASTEL SAN GIORGIO",
    "CASTEL SAN LORENZO",
    "CASTELCIVITA",
    "CASTELLABATE",
    "CASTELNUOVO CILENTO",
    "CASTELNUOVO DI CONZA",
    "CASTIGLIONE DEL GENOVESI",
    "CAVA DE' TIRRENI",
    "CELLE DI BULGHERIA",
    "CENTOLA",
    "CERASO",
    "CETARA",
    "CICERALE",
    "COLLIANO",
    "CONCA DEI MARINI",
    "CONTRONE",
    "CONTURSI TERME",
    "CORBARA",
    "CORLETO MONFORTE",
    "CUCCARO VETERE",
    "EBOLI",
    "FELITTO",
    "FISCIANO",
    "FURORE",
    "FUTANI",
    "GIFFONI SEI CASALI",
    "GIFFONI VALLE PIANA",
    "GIOI",
    "GIUNGANO",
    "ISPANI",
    "LAUREANA CILENTO",
    "LAURINO",
    "LAURITO",
    "LAVIANO",
    "LUSTRA",
    "MAGLIANO VETERE",
    "MAIORI",
    "MERCATO SAN SEVERINO",
    "MINORI",
    "MOIO DELLA CIVITELLA",
    "MONTANO ANTILIA",
    "MONTE SAN GIACOMO",
    "MONTECORICE",
    "MONTECORVINO PUGLIANO",
    "MONTECORVINO ROVELLA",
    "MONTEFORTE CILENTO",
    "MONTESANO SULLA MARCELLANA",
    "MORIGERATI",
    "NOCERA INFERIORE",
    "NOCERA SUPERIORE",
    "NOVI VELIA",
    "OGLIASTRO CILENTO",
    "OLEVANO SUL TUSCIANO",
    "OLIVETO CITRA",
    "OMIGNANO",
    "ORRIA",
    "OTTATI",
    "PADULA",
    "PAGANI",
    "PALOMONTE",
    "PELLEZZANO",
    "PERDIFUMO",
    "PERITO",
    "PERTOSA",
    "PETINA",
    "PIAGGINE",
    "PISCIOTTA",
    "POLLA",
    "POLLICA",
    "PONTECAGNANO FAIANO",
    "POSITANO",
    "POSTIGLIONE",
    "PRAIANO",
    "PRIGNANO CILENTO",
    "RAVELLO",
    "RICIGLIANO",
    "ROCCADASPIDE",
    "ROCCAGLORIOSA",
    "ROCCAPIEMONTE",
    "ROFRANO",
    "ROMAGNANO AL MONTE",
    "ROSCIGNO",
    "RUTINO",
    "SACCO",
    "SALA CONSILINA",
    "SALENTO",
    "SALERNO",
    "SALVITELLE",
    "SAN CIPRIANO PICENTINO",
    "SAN GIOVANNI A PIRO",
    "SAN GREGORIO MAGNO",
    "SAN MANGO PIEMONTE",
    "SAN MARZANO SUL SARNO",
    "SAN MAURO CILENTO",
    "SAN MAURO LA BRUCA",
    "SAN PIETRO AL TANAGRO",
    "SAN RUFO",
    "SAN VALENTINO TORIO",
    "SANTA MARINA",
    "SANT'ANGELO A FASANELLA",
    "SANT'ARSENIO",
    "SANT'EGIDIO DEL MONTE ALBINO",
    "SANTOMENNA",
    "SANZA",
    "SAPRI",
    "SARNO",
    "SASSANO",
    "SCAFATI",
    "SCALA",
    "SERRAMEZZANA",
    "SERRE",
    "SESSA CILENTO",
    "SIANO",
    "SICIGNANO DEGLI ALBURNI",
    "STELLA CILENTO",
    "STIO",
    "TEGGIANO",
    "TORCHIARA",
    "TORRACA",
    "TORRE ORSAIA",
    "TORTORELLA",
    "TRAMONTI",
    "TRENTINARA",
    "VALLE DELL'ANGELO",
    "VALLO DELLA LUCANIA",
    "VALVA",
    "VIBONATI",
    "VIETRI SUL MARE"
  ],
  "NA": [
    "ACERRA",
    "AFRAGOLA",
    "AGEROLA",
    "ANACAPRI",
    "ARZANO",
    "BACOLI",
    "BARANO D'ISCHIA",
    "BOSCOREALE",
    "BOSCOTRECASE",
    "BRUSCIANO",
    "CAIVANO",
    "CALVIZZANO",
    "CAMPOSANO",
    "CAPRI",
    "CARBONARA DI NOLA",
    "CARDITO",
    "CASALNUOVO DI NAPOLI",
    "CASAMARCIANO",
    "CASAMICCIOLA TERME",
    "CASANDRINO",
    "CASAVATORE",
    "CASOLA DI NAPOLI",
    "CASORIA",
    "CASTELLAMMARE DI STABIA",
    "CASTELLO DI CISTERNA",
    "CERCOLA",
    "CICCIANO",
    "CIMITILE",
    "COMIZIANO",
    "CRISPANO",
    "ERCOLANO",
    "FORIO",
    "FRATTAMAGGIORE",
    "FRATTAMINORE",
    "GIUGLIANO IN CAMPANIA",
    "GRAGNANO",
    "GRUMO NEVANO",
    "ISCHIA",
    "LACCO AMENO",
    "LETTERE",
    "LIVERI",
    "MARANO DI NAPOLI",
    "MARIGLIANELLA",
    "MARIGLIANO",
    "MASSA DI SOMMA",
    "MASSA LUBRENSE",
    "MELITO DI NAPOLI",
    "META",
    "MONTE DI PROCIDA",
    "MUGNANO DI NAPOLI",
    "NAPOLI",
    "NOLA",
    "OTTAVIANO",
    "PALMA CAMPANIA",
    "PIANO DI SORRENTO",
    "PIMONTE",
    "POGGIOMARINO",
    "POLLENA TROCCHIA",
    "POMIGLIANO D'ARCO",
    "POMPEI",
    "PORTICI",
    "POZZUOLI",
    "PROCIDA",
    "QUALIANO",
    "QUARTO",
    "ROCCARAINOLA",
    "SAN GENNARO VESUVIANO",
    "SAN GIORGIO A CREMANO",
    "SAN GIUSEPPE VESUVIANO",
    "SAN PAOLO BEL SITO",
    "SAN SEBASTIANO AL VESUVIO",
    "SAN VITALIANO",
    "SANTA MARIA LA CARITA'",
    "SANT'AGNELLO",
    "SANT'ANASTASIA",
    "SANT'ANTIMO",
    "SANT'ANTONIO ABATE",
    "SAVIANO",
    "SCISCIANO",
    "SERRARA FONTANA",
    "SOMMA VESUVIANA",
    "SORRENTO",
    "STRIANO",
    "TERZIGNO",
    "TORRE ANNUNZIATA",
    "TORRE DEL GRECO",
    "TRECASE",
    "TUFINO",
    "VICO EQUENSE",
    "VILLARICCA",
    "VISCIANO",
    "VOLLA"
  ],
  "CT": [
    "ACI BONACCORSI",
    "ACI CASTELLO",
    "ACI CATENA",
    "ACI SANT'ANTONIO",
    "ACIREALE",
    "ADRANO",
    "BELPASSO",
    "BIANCAVILLA",
    "BRONTE",
    "CALATABIANO",
    "CALTAGIRONE",
    "CAMPOROTONDO ETNEO",
    "CASTEL DI IUDICA",
    "CASTIGLIONE DI SICILIA",
    "CATANIA",
    "FIUMEFREDDO DI SICILIA",
    "GIARRE",
    "GRAMMICHELE",
    "GRAVINA DI CATANIA",
    "LICODIA EUBEA",
    "LINGUAGLOSSA",
    "MALETTO",
    "MANIACE",
    "MASCALI",
    "MASCALUCIA",
    "MAZZARRONE",
    "MILITELLO IN VAL DI CATANIA",
    "MILO",
    "MINEO",
    "MIRABELLA IMBACCARI",
    "MISTERBIANCO",
    "MOTTA SANT'ANASTASIA",
    "NICOLOSI",
    "PALAGONIA",
    "PATERNO'",
    "PEDARA",
    "PIEDIMONTE ETNEO",
    "RADDUSA",
    "RAGALNA",
    "RAMACCA",
    "RANDAZZO",
    "RIPOSTO",
    "SAN CONO",
    "SAN GIOVANNI LA PUNTA",
    "SAN GREGORIO DI CATANIA",
    "SAN MICHELE DI GANZARIA",
    "SAN PIETRO CLARENZA",
    "SANTA MARIA DI LICODIA",
    "SANTA VENERINA",
    "SANT'AGATA LI BATTIATI",
    "SANT'ALFIO",
    "SCORDIA",
    "TRECASTAGNI",
    "TREMESTIERI ETNEO",
    "VALVERDE",
    "VIAGRANDE",
    "VIZZINI",
    "ZAFFERANA ETNEA"
  ],
  "MC": [
    "ACQUACANINA",
    "APIRO",
    "APPIGNANO",
    "BELFORTE DEL CHIENTI",
    "BOLOGNOLA",
    "CALDAROLA",
    "CAMERINO",
    "CAMPOROTONDO DI FIASTRONE",
    "CASTELRAIMONDO",
    "CASTELSANTANGELO SUL NERA",
    "CESSAPALOMBO",
    "CINGOLI",
    "CIVITANOVA MARCHE",
    "COLMURANO",
    "CORRIDONIA",
    "ESANATOGLIA",
    "FIASTRA",
    "FIORDIMONTE",
    "FIUMINATA",
    "GAGLIOLE",
    "GUALDO",
    "LORO PICENO",
    "MACERATA",
    "MATELICA",
    "MOGLIANO",
    "MONTE CAVALLO",
    "MONTE SAN GIUSTO",
    "MONTE SAN MARTINO",
    "MONTECASSIANO",
    "MONTECOSARO",
    "MONTEFANO",
    "MONTELUPONE",
    "MORROVALLE",
    "MUCCIA",
    "PENNA SAN GIOVANNI",
    "PETRIOLO",
    "PIEVE TORINA",
    "PIEVEBOVIGLIANA",
    "PIORACO",
    "POGGIO SAN VICINO",
    "POLLENZA",
    "PORTO RECANATI",
    "POTENZA PICENA",
    "RECANATI",
    "RIPE SAN GINESIO",
    "SAN GINESIO",
    "SAN SEVERINO MARCHE",
    "SANT'ANGELO IN PONTANO",
    "SARNANO",
    "SEFRO",
    "SERRAPETRONA",
    "SERRAVALLE DI CHIENTI",
    "TOLENTINO",
    "TREIA",
    "URBISAGLIA",
    "USSITA",
    "VALFORNACE",
    "VISSO"
  ],
  "FR": [
    "ACQUAFONDATA",
    "ACUTO",
    "ALATRI",
    "ALVITO",
    "AMASENO",
    "ANAGNI",
    "AQUINO",
    "ARCE",
    "ARNARA",
    "ARPINO",
    "ATINA",
    "AUSONIA",
    "BELMONTE CASTELLO",
    "BOVILLE ERNICA",
    "BROCCOSTELLA",
    "CAMPOLI APPENNINO",
    "CASALATTICO",
    "CASALVIERI",
    "CASSINO",
    "CASTELLIRI",
    "CASTELNUOVO PARANO",
    "CASTRO DEI VOLSCI",
    "CASTROCIELO",
    "CECCANO",
    "CEPRANO",
    "CERVARO",
    "COLFELICE",
    "COLLE SAN MAGNO",
    "COLLEPARDO",
    "CORENO AUSONIO",
    "ESPERIA",
    "FALVATERRA",
    "FERENTINO",
    "FILETTINO",
    "FIUGGI",
    "FONTANA LIRI",
    "FONTECHIARI",
    "FROSINONE",
    "FUMONE",
    "GALLINARO",
    "GIULIANO DI ROMA",
    "GUARCINO",
    "ISOLA DEL LIRI",
    "MONTE SAN GIOVANNI CAMPANO",
    "MOROLO",
    "PALIANO",
    "PASTENA",
    "PATRICA",
    "PESCOSOLIDO",
    "PICINISCO",
    "PICO",
    "PIEDIMONTE SAN GERMANO",
    "PIGLIO",
    "PIGNATARO INTERAMNA",
    "POFI",
    "PONTECORVO",
    "POSTA FIBRENO",
    "RIPI",
    "ROCCADARCE",
    "ROCCASECCA",
    "SAN BIAGIO SARACINISCO",
    "SAN DONATO VAL DI COMINO",
    "SAN GIORGIO A LIRI",
    "SAN GIOVANNI INCARICO",
    "SAN VITTORE DEL LAZIO",
    "SANT'AMBROGIO SUL GARIGLIANO",
    "SANT'ANDREA DEL GARIGLIANO",
    "SANT'APOLLINARE",
    "SANT'ELIA FIUMERAPIDO",
    "SANTOPADRE",
    "SERRONE",
    "SETTEFRATI",
    "SGURGOLA",
    "SORA",
    "STRANGOLAGALLI",
    "SUPINO",
    "TERELLE",
    "TORRE CAJETANI",
    "TORRICE",
    "TREVI NEL LAZIO",
    "TRIVIGLIANO",
    "VALLECORSA",
    "VALLEMAIO",
    "VALLEROTONDA",
    "VEROLI",
    "VICALVI",
    "VICO NEL LAZIO",
    "VILLA LATINA",
    "VILLA SANTA LUCIA",
    "VILLA SANTO STEFANO",
    "VITICUSO"
  ],
  "CS": [
    "ACQUAFORMOSA",
    "ACQUAPPESA",
    "ACRI",
    "AIELLO CALABRO",
    "AIETA",
    "ALBIDONA",
    "ALESSANDRIA DEL CARRETTO",
    "ALTILIA",
    "ALTOMONTE",
    "AMANTEA",
    "AMENDOLARA",
    "APRIGLIANO",
    "BELMONTE CALABRO",
    "BELSITO",
    "BELVEDERE MARITTIMO",
    "BIANCHI",
    "BISIGNANO",
    "BOCCHIGLIERO",
    "BONIFATI",
    "BUONVICINO",
    "CALOPEZZATI",
    "CALOVETO",
    "CAMPANA",
    "CANNA",
    "CARIATI",
    "CAROLEI",
    "CARPANZANO",
    "CASALI DEL MANCO",
    "CASOLE BRUZIO",
    "CASSANO ALL'IONIO",
    "CASTIGLIONE COSENTINO",
    "CASTROLIBERO",
    "CASTROREGIO",
    "CASTROVILLARI",
    "CELICO",
    "CELLARA",
    "CERCHIARA DI CALABRIA",
    "CERISANO",
    "CERVICATI",
    "CERZETO",
    "CETRARO",
    "CIVITA",
    "CLETO",
    "COLOSIMI",
    "CORIGLIANO CALABRO",
    "CORIGLIANO-ROSSANO",
    "COSENZA",
    "CROPALATI",
    "CROSIA",
    "DIAMANTE",
    "DIPIGNANO",
    "DOMANICO",
    "FAGNANO CASTELLO",
    "FALCONARA ALBANESE",
    "FIGLINE VEGLIATURO",
    "FIRMO",
    "FIUMEFREDDO BRUZIO",
    "FRANCAVILLA MARITTIMA",
    "FRASCINETO",
    "FUSCALDO",
    "GRIMALDI",
    "GRISOLIA",
    "GUARDIA PIEMONTESE",
    "LAGO",
    "LAINO BORGO",
    "LAINO CASTELLO",
    "LAPPANO",
    "LATTARICO",
    "LONGOBARDI",
    "LONGOBUCCO",
    "LUNGRO",
    "LUZZI",
    "MAIERA'",
    "MALITO",
    "MALVITO",
    "MANDATORICCIO",
    "MANGONE",
    "MARANO MARCHESATO",
    "MARANO PRINCIPATO",
    "MARZI",
    "MENDICINO",
    "MONGRASSANO",
    "MONTALTO UFFUGO",
    "MONTEGIORDANO",
    "MORANO CALABRO",
    "MORMANNO",
    "MOTTAFOLLONE",
    "NOCARA",
    "ORIOLO",
    "ORSOMARSO",
    "PALUDI",
    "PANETTIERI",
    "PAOLA",
    "PAPASIDERO",
    "PARENTI",
    "PATERNO CALABRO",
    "PEDACE",
    "PEDIVIGLIANO",
    "PIANE CRATI",
    "PIETRAFITTA",
    "PIETRAPAOLA",
    "PLATACI",
    "PRAIA A MARE",
    "RENDE",
    "ROCCA IMPERIALE",
    "ROGGIANO GRAVINA",
    "ROGLIANO",
    "ROSE",
    "ROSETO CAPO SPULICO",
    "ROSSANO",
    "ROTA GRECA",
    "ROVITO",
    "SAN BASILE",
    "SAN BENEDETTO ULLANO",
    "SAN COSMO ALBANESE",
    "SAN DEMETRIO CORONE",
    "SAN DONATO DI NINEA",
    "SAN FILI",
    "SAN GIORGIO ALBANESE",
    "SAN GIOVANNI IN FIORE",
    "SAN LORENZO BELLIZZI",
    "SAN LORENZO DEL VALLO",
    "SAN LUCIDO",
    "SAN MARCO ARGENTANO",
    "SAN MARTINO DI FINITA",
    "SAN NICOLA ARCELLA",
    "SAN PIETRO IN AMANTEA",
    "SAN PIETRO IN GUARANO",
    "SAN SOSTI",
    "SAN VINCENZO LA COSTA",
    "SANGINETO",
    "SANTA CATERINA ALBANESE",
    "SANTA DOMENICA TALAO",
    "SANTA MARIA DEL CEDRO",
    "SANTA SOFIA D'EPIRO",
    "SANT'AGATA DI ESARO",
    "SANTO STEFANO DI ROGLIANO",
    "SARACENA",
    "SCALA COELI",
    "SCALEA",
    "SCIGLIANO",
    "SERRA D'AIELLO",
    "SERRA PEDACE",
    "SPEZZANO ALBANESE",
    "SPEZZANO DELLA SILA",
    "SPEZZANO PICCOLO",
    "TARSIA",
    "TERRANOVA DA SIBARI",
    "TERRAVECCHIA",
    "TORANO CASTELLO",
    "TORTORA",
    "TREBISACCE",
    "TRENTA",
    "VACCARIZZO ALBANESE",
    "VERBICARO",
    "VILLAPIANA",
    "ZUMPANO"
  ],
  "BS": [
    "ACQUAFREDDA",
    "ADRO",
    "AGNOSINE",
    "ALFIANELLO",
    "ANFO",
    "ANGOLO TERME",
    "ARTOGNE",
    "AZZANO MELLA",
    "BAGNOLO MELLA",
    "BAGOLINO",
    "BARBARIGA",
    "BARGHE",
    "BASSANO BRESCIANO",
    "BEDIZZOLE",
    "BERLINGO",
    "BERZO DEMO",
    "BERZO INFERIORE",
    "BIENNO",
    "BIONE",
    "BORGO SAN GIACOMO",
    "BORGOSATOLLO",
    "BORNO",
    "BOTTICINO",
    "BOVEGNO",
    "BOVEZZO",
    "BRANDICO",
    "BRAONE",
    "BRENO",
    "BRESCIA",
    "BRIONE",
    "CAINO",
    "CALCINATO",
    "CALVAGESE DELLA RIVIERA",
    "CALVISANO",
    "CAPO DI PONTE",
    "CAPOVALLE",
    "CAPRIANO DEL COLLE",
    "CAPRIOLO",
    "CARPENEDOLO",
    "CASTEGNATO",
    "CASTEL MELLA",
    "CASTELCOVATI",
    "CASTENEDOLO",
    "CASTO",
    "CASTREZZATO",
    "CAZZAGO SAN MARTINO",
    "CEDEGOLO",
    "CELLATICA",
    "CERVENO",
    "CETO",
    "CEVO",
    "CHIARI",
    "CIGOLE",
    "CIMBERGO",
    "CIVIDATE CAMUNO",
    "COCCAGLIO",
    "COLLEBEATO",
    "COLLIO",
    "COLOGNE",
    "COMEZZANO-CIZZAGO",
    "CONCESIO",
    "CORTE FRANCA",
    "CORTENO GOLGI",
    "CORZANO",
    "DARFO BOARIO TERME",
    "DELLO",
    "DESENZANO DEL GARDA",
    "EDOLO",
    "ERBUSCO",
    "ESINE",
    "FIESSE",
    "FLERO",
    "GAMBARA",
    "GARDONE RIVIERA",
    "GARDONE VAL TROMPIA",
    "GARGNANO",
    "GAVARDO",
    "GHEDI",
    "GIANICO",
    "GOTTOLENGO",
    "GUSSAGO",
    "IDRO",
    "INCUDINE",
    "IRMA",
    "ISEO",
    "ISORELLA",
    "LAVENONE",
    "LENO",
    "LIMONE SUL GARDA",
    "LODRINO",
    "LOGRATO",
    "LONATO",
    "LONATO DEL GARDA",
    "LONGHENA",
    "LOSINE",
    "LOZIO",
    "LUMEZZANE",
    "MACLODIO",
    "MAGASA",
    "MAIRANO",
    "MALEGNO",
    "MALONNO",
    "MANERBA DEL GARDA",
    "MANERBIO",
    "MARCHENO",
    "MARMENTINO",
    "MARONE",
    "MAZZANO",
    "MILZANO",
    "MONIGA DEL GARDA",
    "MONNO",
    "MONTE ISOLA",
    "MONTICELLI BRUSATI",
    "MONTICHIARI",
    "MONTIRONE",
    "MURA",
    "MUSCOLINE",
    "NAVE",
    "NIARDO",
    "NUVOLENTO",
    "NUVOLERA",
    "ODOLO",
    "OFFLAGA",
    "OME",
    "ONO SAN PIETRO",
    "ORZINUOVI",
    "ORZIVECCHI",
    "OSPITALETTO",
    "OSSIMO",
    "PADENGHE SUL GARDA",
    "PADERNO FRANCIACORTA",
    "PAISCO LOVENO",
    "PAITONE",
    "PALAZZOLO SULL'OGLIO",
    "PARATICO",
    "PASPARDO",
    "PASSIRANO",
    "PAVONE DEL MELLA",
    "PERTICA ALTA",
    "PERTICA BASSA",
    "PEZZAZE",
    "PIAN CAMUNO",
    "PIANCOGNO",
    "PISOGNE",
    "POLAVENO",
    "POLPENAZZE DEL GARDA",
    "POMPIANO",
    "PONCARALE",
    "PONTE DI LEGNO",
    "PONTEVICO",
    "PONTOGLIO",
    "POZZOLENGO",
    "PRALBOINO",
    "PRESEGLIE",
    "PRESTINE",
    "PREVALLE",
    "PROVAGLIO D'ISEO",
    "PROVAGLIO VAL SABBIA",
    "PUEGNAGO DEL GARDA",
    "QUINZANO D'OGLIO",
    "REMEDELLO",
    "REZZATO",
    "ROCCAFRANCA",
    "RODENGO SAIANO",
    "ROE' VOLCIANO",
    "RONCADELLE",
    "ROVATO",
    "RUDIANO",
    "SABBIO CHIESE",
    "SALE MARASINO",
    "SALO'",
    "SAN FELICE DEL BENACO",
    "SAN GERVASIO BRESCIANO",
    "SAN PAOLO",
    "SAN ZENO NAVIGLIO",
    "SAREZZO",
    "SAVIORE DELL'ADAMELLO",
    "SELLERO",
    "SENIGA",
    "SERLE",
    "SIRMIONE",
    "SOIANO DEL LAGO",
    "SONICO",
    "SULZANO",
    "TAVERNOLE SUL MELLA",
    "TEMU'",
    "TIGNALE",
    "TORBOLE CASAGLIA",
    "TOSCOLANO MADERNO",
    "TRAVAGLIATO",
    "TREMOSINE",
    "TRENZANO",
    "TREVISO BRESCIANO",
    "URAGO D'OGLIO",
    "VALLIO TERME",
    "VALVESTINO",
    "VEROLANUOVA",
    "VEROLAVECCHIA",
    "VESTONE",
    "VEZZA D'OGLIO",
    "VILLA CARCINA",
    "VILLACHIARA",
    "VILLANUOVA SUL CLISI",
    "VIONE",
    "VISANO",
    "VOBARNO",
    "ZONE"
  ],
  "PU": [
    "ACQUALAGNA",
    "APECCHIO",
    "AUDITORE",
    "BARCHI",
    "BELFORTE ALL'ISAURO",
    "BORGO PACE",
    "CAGLI",
    "CANTIANO",
    "CARPEGNA",
    "CARTOCETO",
    "COLBORDOLO",
    "COLLI AL METAURO",
    "FANO",
    "FERMIGNANO",
    "FOSSOMBRONE",
    "FRATTE ROSA",
    "FRONTINO",
    "FRONTONE",
    "GABICCE MARE",
    "GRADARA",
    "ISOLA DEL PIANO",
    "LUNANO",
    "MACERATA FELTRIA",
    "MERCATELLO SUL METAURO",
    "MERCATINO CONCA",
    "MOMBAROCCIO",
    "MONDAVIO",
    "MONDOLFO",
    "MONTE CERIGNONE",
    "MONTE GRIMANO TERME",
    "MONTE PORZIO",
    "MONTECALVO IN FOGLIA",
    "MONTECICCARDO",
    "MONTECOPIOLO",
    "MONTEFELCINO",
    "MONTELABBATE",
    "MONTEMAGGIORE AL METAURO",
    "ORCIANO DI PESARO",
    "PEGLIO",
    "PERGOLA",
    "PESARO",
    "PETRIANO",
    "PIAGGE",
    "PIANDIMELETO",
    "PIETRARUBBIA",
    "PIOBBICO",
    "SALTARA",
    "SAN COSTANZO",
    "SAN GIORGIO DI PESARO",
    "SAN LORENZO IN CAMPO",
    "SANT'ANGELO IN LIZZOLA",
    "SANT'ANGELO IN VADO",
    "SANT'IPPOLITO",
    "SASSOCORVARO",
    "SASSOCORVARO AUDITORE",
    "SASSOFELTRIO",
    "SERRA SANT'ABBONDIO",
    "SERRUNGARINA",
    "TAVOLETO",
    "TAVULLIA",
    "TERRE ROVERESCHE",
    "URBANIA",
    "URBINO",
    "VALLEFOGLIA"
  ],
  "CR": [
    "ACQUANEGRA CREMONESE",
    "AGNADELLO",
    "ANNICCO",
    "AZZANELLO",
    "BAGNOLO CREMASCO",
    "BONEMERSE",
    "BORDOLANO",
    "CA' D'ANDREA",
    "CALVATONE",
    "CAMISANO",
    "CAMPAGNOLA CREMASCA",
    "CAPERGNANICA",
    "CAPPELLA CANTONE",
    "CAPPELLA DE' PICENARDI",
    "CAPRALBA",
    "CASALBUTTANO ED UNITI",
    "CASALE CREMASCO-VIDOLASCO",
    "CASALETTO CEREDANO",
    "CASALETTO DI SOPRA",
    "CASALETTO VAPRIO",
    "CASALMAGGIORE",
    "CASALMORANO",
    "CASTEL GABBIANO",
    "CASTELDIDONE",
    "CASTELLEONE",
    "CASTELVERDE",
    "CASTELVISCONTI",
    "CELLA DATI",
    "CHIEVE",
    "CICOGNOLO",
    "CINGIA DE' BOTTI",
    "CORTE DE' CORTESI CON CIGNONE",
    "CORTE DE' FRATI",
    "CREDERA RUBBIANO",
    "CREMA",
    "CREMONA",
    "CREMOSANO",
    "CROTTA D'ADDA",
    "CUMIGNANO SUL NAVIGLIO",
    "DEROVERE",
    "DOVERA",
    "DRIZZONA",
    "FIESCO",
    "FORMIGARA",
    "GABBIONETA BINANUOVA",
    "GADESCO PIEVE DELMONA",
    "GENIVOLTA",
    "GERRE DE' CAPRIOLI",
    "GOMBITO",
    "GRONTARDO",
    "GRUMELLO CREMONESE ED UNITI",
    "GUSSOLA",
    "ISOLA DOVARESE",
    "IZANO",
    "MADIGNANO",
    "MALAGNINO",
    "MARTIGNANA DI PO",
    "MONTE CREMASCO",
    "MONTODINE",
    "MOSCAZZANO",
    "MOTTA BALUFFI",
    "OFFANENGO",
    "OLMENETA",
    "OSTIANO",
    "PADERNO PONCHIELLI",
    "PALAZZO PIGNANO",
    "PANDINO",
    "PERSICO DOSIMO",
    "PESCAROLO ED UNITI",
    "PESSINA CREMONESE",
    "PIADENA",
    "PIADENA DRIZZONA",
    "PIANENGO",
    "PIERANICA",
    "PIEVE D'OLMI",
    "PIEVE SAN GIACOMO",
    "PIZZIGHETTONE",
    "POZZAGLIO ED UNITI",
    "QUINTANO",
    "RICENGO",
    "RIPALTA ARPINA",
    "RIPALTA CREMASCA",
    "RIPALTA GUERINA",
    "RIVAROLO DEL RE ED UNITI",
    "RIVOLTA D'ADDA",
    "ROBECCO D'OGLIO",
    "ROMANENGO",
    "SALVIROLA",
    "SAN BASSANO",
    "SAN DANIELE PO",
    "SAN GIOVANNI IN CROCE",
    "SAN MARTINO DEL LAGO",
    "SCANDOLARA RAVARA",
    "SCANDOLARA RIPA D'OGLIO",
    "SERGNANO",
    "SESTO ED UNITI",
    "SOLAROLO RAINERIO",
    "SONCINO",
    "SORESINA",
    "SOSPIRO",
    "SPINADESCO",
    "SPINEDA",
    "SPINO D'ADDA",
    "STAGNO LOMBARDO",
    "TICENGO",
    "TORLINO VIMERCATI",
    "TORNATA",
    "TORRE DE' PICENARDI",
    "TORRICELLA DEL PIZZO",
    "TRESCORE CREMASCO",
    "TRIGOLO",
    "VAIANO CREMASCO",
    "VAILATE",
    "VESCOVATO",
    "VOLONGO",
    "VOLTIDO"
  ],
  "MN": [
    "ACQUANEGRA SUL CHIESE",
    "ASOLA",
    "BAGNOLO SAN VITO",
    "BIGARELLO",
    "BORGO MANTOVANO",
    "BORGO VIRGILIO",
    "BORGOCARBONARA",
    "BORGOFORTE",
    "BORGOFRANCO SUL PO",
    "BOZZOLO",
    "CANNETO SULL'OGLIO",
    "CARBONARA DI PO",
    "CASALMORO",
    "CASALOLDO",
    "CASALROMANO",
    "CASTEL D'ARIO",
    "CASTEL GOFFREDO",
    "CASTELBELFORTE",
    "CASTELLUCCHIO",
    "CASTIGLIONE DELLE STIVIERE",
    "CAVRIANA",
    "CERESARA",
    "COMMESSAGGIO",
    "CURTATONE",
    "DOSOLO",
    "FELONICA",
    "GAZOLDO DEGLI IPPOLITI",
    "GAZZUOLO",
    "GOITO",
    "GONZAGA",
    "GUIDIZZOLO",
    "MAGNACAVALLO",
    "MANTOVA",
    "MARCARIA",
    "MARIANA MANTOVANA",
    "MARMIROLO",
    "MEDOLE",
    "MOGLIA",
    "MONZAMBANO",
    "MOTTEGGIANA",
    "OSTIGLIA",
    "PEGOGNAGA",
    "PIEVE DI CORIANO",
    "PIUBEGA",
    "POGGIO RUSCO",
    "POMPONESCO",
    "PONTI SUL MINCIO",
    "PORTO MANTOVANO",
    "QUINGENTOLE",
    "QUISTELLO",
    "REDONDESCO",
    "REVERE",
    "RIVAROLO MANTOVANO",
    "RODIGO",
    "RONCOFERRARO",
    "ROVERBELLA",
    "SABBIONETA",
    "SAN BENEDETTO PO",
    "SAN GIACOMO DELLE SEGNATE",
    "SAN GIORGIO BIGARELLO",
    "SAN GIOVANNI DEL DOSSO",
    "SAN MARTINO DALL'ARGINE",
    "SCHIVENOGLIA",
    "SERMIDE E FELONICA",
    "SERRAVALLE A PO",
    "SOLFERINO",
    "SUSTINENTE",
    "SUZZARA",
    "VIADANA",
    "VILLA POMA",
    "VILLIMPENTA",
    "VIRGILIO",
    "VOLTA MANTOVANA"
  ],
  "VT": [
    "ACQUAPENDENTE",
    "ARLENA DI CASTRO",
    "BAGNOREGIO",
    "BARBARANO ROMANO",
    "BASSANO IN TEVERINA",
    "BASSANO ROMANO",
    "BLERA",
    "BOLSENA",
    "BOMARZO",
    "CALCATA",
    "CANEPINA",
    "CANINO",
    "CAPODIMONTE",
    "CAPRANICA",
    "CAPRAROLA",
    "CARBOGNANO",
    "CASTEL SANT'ELIA",
    "CASTIGLIONE IN TEVERINA",
    "CELLENO",
    "CELLERE",
    "CIVITA CASTELLANA",
    "CIVITELLA D'AGLIANO",
    "CORCHIANO",
    "FABRICA DI ROMA",
    "FALERIA",
    "FARNESE",
    "GALLESE",
    "GRADOLI",
    "GRAFFIGNANO",
    "GROTTE DI CASTRO",
    "ISCHIA DI CASTRO",
    "LATERA",
    "LUBRIANO",
    "MARTA",
    "MONTALTO DI CASTRO",
    "MONTE ROMANO",
    "MONTEFIASCONE",
    "MONTEROSI",
    "NEPI",
    "ONANO",
    "ORIOLO ROMANO",
    "ORTE",
    "PIANSANO",
    "PROCENO",
    "RONCIGLIONE",
    "SAN LORENZO NUOVO",
    "SORIANO NEL CIMINO",
    "SUTRI",
    "TARQUINIA",
    "TESSENNANO",
    "TUSCANIA",
    "VALENTANO",
    "VALLERANO",
    "VASANELLO",
    "VEJANO",
    "VETRALLA",
    "VIGNANELLO",
    "VILLA SAN GIOVANNI IN TUSCIA",
    "VITERBO",
    "VITORCHIANO"
  ],
  "LE": [
    "ACQUARICA DEL CAPO",
    "ALESSANO",
    "ALEZIO",
    "ALLISTE",
    "ANDRANO",
    "ARADEO",
    "ARNESANO",
    "BAGNOLO DEL SALENTO",
    "BOTRUGNO",
    "CALIMERA",
    "CAMPI SALENTINA",
    "CANNOLE",
    "CAPRARICA DI LECCE",
    "CARMIANO",
    "CARPIGNANO SALENTINO",
    "CASARANO",
    "CASTRI DI LECCE",
    "CASTRIGNANO DE' GRECI",
    "CASTRIGNANO DEL CAPO",
    "CASTRO",
    "CAVALLINO",
    "COLLEPASSO",
    "COPERTINO",
    "CORIGLIANO D'OTRANTO",
    "CORSANO",
    "CURSI",
    "CUTROFIANO",
    "DISO",
    "GAGLIANO DEL CAPO",
    "GALATINA",
    "GALATONE",
    "GALLIPOLI",
    "GIUGGIANELLO",
    "GIURDIGNANO",
    "GUAGNANO",
    "LECCE",
    "LEQUILE",
    "LEVERANO",
    "LIZZANELLO",
    "MAGLIE",
    "MARTANO",
    "MARTIGNANO",
    "MATINO",
    "MELENDUGNO",
    "MELISSANO",
    "MELPIGNANO",
    "MIGGIANO",
    "MINERVINO DI LECCE",
    "MONTERONI DI LECCE",
    "MONTESANO SALENTINO",
    "MORCIANO DI LEUCA",
    "MURO LECCESE",
    "NARDO'",
    "NEVIANO",
    "NOCIGLIA",
    "NOVOLI",
    "ORTELLE",
    "OTRANTO",
    "PALMARIGGI",
    "PARABITA",
    "PATU'",
    "POGGIARDO",
    "PORTO CESAREO",
    "PRESICCE",
    "PRESICCE-ACQUARICA",
    "RACALE",
    "RUFFANO",
    "SALICE SALENTINO",
    "SALVE",
    "SAN CASSIANO",
    "SAN CESARIO DI LECCE",
    "SAN DONATO DI LECCE",
    "SAN PIETRO IN LAMA",
    "SANARICA",
    "SANNICOLA",
    "SANTA CESAREA TERME",
    "SCORRANO",
    "SECLI'",
    "SOGLIANO CAVOUR",
    "SOLETO",
    "SPECCHIA",
    "SPONGANO",
    "SQUINZANO",
    "STERNATIA",
    "SUPERSANO",
    "SURANO",
    "SURBO",
    "TAURISANO",
    "TAVIANO",
    "TIGGIANO",
    "TREPUZZI",
    "TRICASE",
    "TUGLIE",
    "UGENTO",
    "UGGIANO LA CHIESA",
    "VEGLIE",
    "VERNOLE",
    "ZOLLINO"
  ],
  "VV": [
    "ACQUARO",
    "ARENA",
    "BRIATICO",
    "BROGNATURO",
    "CAPISTRANO",
    "CESSANITI",
    "DASA'",
    "DINAMI",
    "DRAPIA",
    "FABRIZIA",
    "FILADELFIA",
    "FILANDARI",
    "FILOGASO",
    "FRANCAVILLA ANGITOLA",
    "FRANCICA",
    "GEROCARNE",
    "IONADI",
    "JOPPOLO",
    "LIMBADI",
    "MAIERATO",
    "MILETO",
    "MONGIANA",
    "MONTEROSSO CALABRO",
    "NARDODIPACE",
    "NICOTERA",
    "PARGHELIA",
    "PIZZO",
    "PIZZONI",
    "POLIA",
    "RICADI",
    "ROMBIOLO",
    "SAN CALOGERO",
    "SAN COSTANTINO CALABRO",
    "SAN GREGORIO D'IPPONA",
    "SAN NICOLA DA CRISSA",
    "SANT'ONOFRIO",
    "SERRA SAN BRUNO",
    "SIMBARIO",
    "SORIANELLO",
    "SORIANO CALABRO",
    "SPADOLA",
    "SPILINGA",
    "STEFANACONI",
    "TROPEA",
    "VALLELONGA",
    "VAZZANO",
    "VIBO VALENTIA",
    "ZACCANOPOLI",
    "ZAMBRONE",
    "ZUNGRI"
  ],
  "AP": [
    "ACQUASANTA TERME",
    "ACQUAVIVA PICENA",
    "APPIGNANO DEL TRONTO",
    "ARQUATA DEL TRONTO",
    "ASCOLI PICENO",
    "CARASSAI",
    "CASTEL DI LAMA",
    "CASTIGNANO",
    "CASTORANO",
    "COLLI DEL TRONTO",
    "COMUNANZA",
    "COSSIGNANO",
    "CUPRA MARITTIMA",
    "FOLIGNANO",
    "FORCE",
    "GROTTAMMARE",
    "MALTIGNANO",
    "MASSIGNANO",
    "MONSAMPOLO DEL TRONTO",
    "MONTALTO DELLE MARCHE",
    "MONTEDINOVE",
    "MONTEFIORE DELL'ASO",
    "MONTEGALLO",
    "MONTEMONACO",
    "MONTEPRANDONE",
    "OFFIDA",
    "PALMIANO",
    "RIPATRANSONE",
    "ROCCAFLUVIONE",
    "ROTELLA",
    "SAN BENEDETTO DEL TRONTO",
    "SPINETOLI",
    "VENAROTTA"
  ],
  "TR": [
    "ACQUASPARTA",
    "ALLERONA",
    "ALVIANO",
    "AMELIA",
    "ARRONE",
    "ATTIGLIANO",
    "AVIGLIANO UMBRO",
    "BASCHI",
    "CALVI DELL'UMBRIA",
    "CASTEL GIORGIO",
    "CASTEL VISCARDO",
    "FABRO",
    "FERENTILLO",
    "FICULLE",
    "GIOVE",
    "GUARDEA",
    "LUGNANO IN TEVERINA",
    "MONTECASTRILLI",
    "MONTECCHIO",
    "MONTEFRANCO",
    "MONTEGABBIONE",
    "MONTELEONE D'ORVIETO",
    "NARNI",
    "ORVIETO",
    "OTRICOLI",
    "PARRANO",
    "PENNA IN TEVERINA",
    "POLINO",
    "PORANO",
    "SAN GEMINI",
    "SAN VENANZO",
    "STRONCONE",
    "TERNI"
  ],
  "CB": [
    "ACQUAVIVA COLLECROCE",
    "BARANELLO",
    "BOJANO",
    "BONEFRO",
    "BUSSO",
    "CAMPOBASSO",
    "CAMPOCHIARO",
    "CAMPODIPIETRA",
    "CAMPOLIETO",
    "CAMPOMARINO",
    "CASACALENDA",
    "CASALCIPRANO",
    "CASTELBOTTACCIO",
    "CASTELLINO DEL BIFERNO",
    "CASTELMAURO",
    "CASTROPIGNANO",
    "CERCEMAGGIORE",
    "CERCEPICCOLA",
    "CIVITACAMPOMARANO",
    "COLLE D'ANCHISE",
    "COLLETORTO",
    "DURONIA",
    "FERRAZZANO",
    "FOSSALTO",
    "GAMBATESA",
    "GILDONE",
    "GUARDIALFIERA",
    "GUARDIAREGIA",
    "GUGLIONESI",
    "JELSI",
    "LARINO",
    "LIMOSANO",
    "LUCITO",
    "LUPARA",
    "MACCHIA VALFORTORE",
    "MAFALDA",
    "MATRICE",
    "MIRABELLO SANNITICO",
    "MOLISE",
    "MONACILIONI",
    "MONTAGANO",
    "MONTECILFONE",
    "MONTEFALCONE NEL SANNIO",
    "MONTELONGO",
    "MONTEMITRO",
    "MONTENERO DI BISACCIA",
    "MONTORIO NEI FRENTANI",
    "MORRONE DEL SANNIO",
    "ORATINO",
    "PALATA",
    "PETACCIATO",
    "PETRELLA TIFERNINA",
    "PIETRACATELLA",
    "PIETRACUPA",
    "PORTOCANNONE",
    "PROVVIDENTI",
    "RICCIA",
    "RIPABOTTONI",
    "RIPALIMOSANI",
    "ROCCAVIVARA",
    "ROTELLO",
    "SALCITO",
    "SAN BIASE",
    "SAN FELICE DEL MOLISE",
    "SAN GIACOMO DEGLI SCHIAVONI",
    "SAN GIOVANNI IN GALDO",
    "SAN GIULIANO DEL SANNIO",
    "SAN GIULIANO DI PUGLIA",
    "SAN MARTINO IN PENSILIS",
    "SAN MASSIMO",
    "SAN POLO MATESE",
    "SANTA CROCE DI MAGLIANO",
    "SANT'ANGELO LIMOSANO",
    "SANT'ELIA A PIANISI",
    "SEPINO",
    "SPINETE",
    "TAVENNA",
    "TERMOLI",
    "TORELLA DEL SANNIO",
    "TORO",
    "TRIVENTO",
    "TUFARA",
    "URURI",
    "VINCHIATURO"
  ],
  "BA": [
    "ACQUAVIVA DELLE FONTI",
    "ADELFIA",
    "ALBEROBELLO",
    "ALTAMURA",
    "BARI",
    "BINETTO",
    "BITETTO",
    "BITONTO",
    "BITRITTO",
    "CAPURSO",
    "CASAMASSIMA",
    "CASSANO DELLE MURGE",
    "CASTELLANA GROTTE",
    "CELLAMARE",
    "CONVERSANO",
    "CORATO",
    "GIOIA DEL COLLE",
    "GIOVINAZZO",
    "GRAVINA IN PUGLIA",
    "GRUMO APPULA",
    "LOCOROTONDO",
    "MODUGNO",
    "MOLA DI BARI",
    "MOLFETTA",
    "MONOPOLI",
    "NOCI",
    "NOICATTARO",
    "PALO DEL COLLE",
    "POGGIORSINI",
    "POLIGNANO A MARE",
    "PUTIGNANO",
    "RUTIGLIANO",
    "RUVO DI PUGLIA",
    "SAMMICHELE DI BARI",
    "SANNICANDRO DI BARI",
    "SANTERAMO IN COLLE",
    "TERLIZZI",
    "TORITTO",
    "TRIGGIANO",
    "TURI",
    "VALENZANO"
  ],
  "IS": [
    "ACQUAVIVA D'ISERNIA",
    "AGNONE",
    "BAGNOLI DEL TRIGNO",
    "BELMONTE DEL SANNIO",
    "CANTALUPO NEL SANNIO",
    "CAPRACOTTA",
    "CAROVILLI",
    "CARPINONE",
    "CASTEL DEL GIUDICE",
    "CASTEL SAN VINCENZO",
    "CASTELPETROSO",
    "CASTELPIZZUTO",
    "CASTELVERRINO",
    "CERRO AL VOLTURNO",
    "CHIAUCI",
    "CIVITANOVA DEL SANNIO",
    "COLLI A VOLTURNO",
    "CONCA CASALE",
    "FILIGNANO",
    "FORLI' DEL SANNIO",
    "FORNELLI",
    "FROSOLONE",
    "ISERNIA",
    "LONGANO",
    "MACCHIA D'ISERNIA",
    "MACCHIAGODENA",
    "MIRANDA",
    "MONTAQUILA",
    "MONTENERO VAL COCCHIARA",
    "MONTERODUNI",
    "PESCHE",
    "PESCOLANCIANO",
    "PESCOPENNATARO",
    "PETTORANELLO DEL MOLISE",
    "PIETRABBONDANTE",
    "PIZZONE",
    "POGGIO SANNITA",
    "POZZILLI",
    "RIONERO SANNITICO",
    "ROCCAMANDOLFI",
    "ROCCASICURA",
    "ROCCHETTA A VOLTURNO",
    "SAN PIETRO AVELLANA",
    "SANTA MARIA DEL MOLISE",
    "SANT'AGAPITO",
    "SANT'ANGELO DEL PESCO",
    "SANT'ELENA SANNITA",
    "SCAPOLI",
    "SESSANO DEL MOLISE",
    "SESTO CAMPANO",
    "VASTOGIRARDI",
    "VENAFRO"
  ],
  "CL": [
    "ACQUAVIVA PLATANI",
    "BOMPENSIERE",
    "BUTERA",
    "CALTANISSETTA",
    "CAMPOFRANCO",
    "DELIA",
    "GELA",
    "MARIANOPOLI",
    "MAZZARINO",
    "MILENA",
    "MONTEDORO",
    "MUSSOMELI",
    "NISCEMI",
    "RESUTTANO",
    "RIESI",
    "SAN CATALDO",
    "SANTA CATERINA VILLARMOSA",
    "SERRADIFALCO",
    "SOMMATINO",
    "SUTERA",
    "VALLELUNGA PRATAMENO",
    "VILLALBA"
  ],
  "ME": [
    "ACQUEDOLCI",
    "ALCARA LI FUSI",
    "ALI'",
    "ALI' TERME",
    "ANTILLO",
    "BARCELLONA POZZO DI GOTTO",
    "BASICO'",
    "BROLO",
    "CAPIZZI",
    "CAPO D'ORLANDO",
    "CAPRI LEONE",
    "CARONIA",
    "CASALVECCHIO SICULO",
    "CASTEL DI LUCIO",
    "CASTELL'UMBERTO",
    "CASTELMOLA",
    "CASTROREALE",
    "CESARO'",
    "CONDRO'",
    "FALCONE",
    "FICARRA",
    "FIUMEDINISI",
    "FLORESTA",
    "FONDACHELLI-FANTINA",
    "FORZA D'AGRO'",
    "FRANCAVILLA DI SICILIA",
    "FRAZZANO'",
    "FURCI SICULO",
    "FURNARI",
    "GAGGI",
    "GALATI MAMERTINO",
    "GALLODORO",
    "GIARDINI-NAXOS",
    "GIOIOSA MAREA",
    "GRANITI",
    "GUALTIERI SICAMINO'",
    "ITALA",
    "LENI",
    "LETOJANNI",
    "LIBRIZZI",
    "LIMINA",
    "LIPARI",
    "LONGI",
    "MALFA",
    "MALVAGNA",
    "MANDANICI",
    "MAZZARRA' SANT'ANDREA",
    "MERI'",
    "MESSINA",
    "MILAZZO",
    "MILITELLO ROSMARINO",
    "MIRTO",
    "MISTRETTA",
    "MOIO ALCANTARA",
    "MONFORTE SAN GIORGIO",
    "MONGIUFFI MELIA",
    "MONTAGNAREALE",
    "MONTALBANO ELICONA",
    "MOTTA CAMASTRA",
    "MOTTA D'AFFERMO",
    "NASO",
    "NIZZA DI SICILIA",
    "NOVARA DI SICILIA",
    "OLIVERI",
    "PACE DEL MELA",
    "PAGLIARA",
    "PATTI",
    "PETTINEO",
    "PIRAINO",
    "RACCUJA",
    "REITANO",
    "ROCCAFIORITA",
    "ROCCALUMERA",
    "ROCCAVALDINA",
    "ROCCELLA VALDEMONE",
    "RODI' MILICI",
    "ROMETTA",
    "SAN FILIPPO DEL MELA",
    "SAN FRATELLO",
    "SAN MARCO D'ALUNZIO",
    "SAN PIER NICETO",
    "SAN PIERO PATTI",
    "SAN SALVATORE DI FITALIA",
    "SAN TEODORO",
    "SANTA DOMENICA VITTORIA",
    "SANTA LUCIA DEL MELA",
    "SANTA MARINA SALINA",
    "SANTA TERESA DI RIVA",
    "SANT'AGATA DI MILITELLO",
    "SANT'ALESSIO SICULO",
    "SANT'ANGELO DI BROLO",
    "SANTO STEFANO DI CAMASTRA",
    "SAPONARA",
    "SAVOCA",
    "SCALETTA ZANCLEA",
    "SINAGRA",
    "SPADAFORA",
    "TAORMINA",
    "TERME VIGLIATORE",
    "TORREGROTTA",
    "TORRENOVA",
    "TORTORICI",
    "TRIPI",
    "TUSA",
    "UCRIA",
    "VALDINA",
    "VENETICO",
    "VILLAFRANCA TIRRENA"
  ],
  "AL": [
    "ACQUI TERME",
    "ALBERA LIGURE",
    "ALESSANDRIA",
    "ALFIANO NATTA",
    "ALICE BEL COLLE",
    "ALLUVIONI CAMBIO'",
    "ALLUVIONI PIOVERA",
    "ALTAVILLA MONFERRATO",
    "ALZANO SCRIVIA",
    "ARQUATA SCRIVIA",
    "AVOLASCA",
    "BALZOLA",
    "BASALUZZO",
    "BASSIGNANA",
    "BELFORTE MONFERRATO",
    "BERGAMASCO",
    "BERZANO DI TORTONA",
    "BISTAGNO",
    "BORGHETTO DI BORBERA",
    "BORGO SAN MARTINO",
    "BORGORATTO ALESSANDRINO",
    "BOSCO MARENGO",
    "BOSIO",
    "BOZZOLE",
    "BRIGNANO-FRASCATA",
    "CABELLA LIGURE",
    "CAMAGNA MONFERRATO",
    "CAMINO",
    "CANTALUPO LIGURE",
    "CAPRIATA D'ORBA",
    "CARBONARA SCRIVIA",
    "CARENTINO",
    "CAREZZANO",
    "CARPENETO",
    "CARREGA LIGURE",
    "CARROSIO",
    "CARTOSIO",
    "CASAL CERMELLI",
    "CASALE MONFERRATO",
    "CASALEGGIO BOIRO",
    "CASALNOCETO",
    "CASASCO",
    "CASSANO SPINOLA",
    "CASSINE",
    "CASSINELLE",
    "CASTELLANIA",
    "CASTELLAR GUIDOBONO",
    "CASTELLAZZO BORMIDA",
    "CASTELLETTO D'ERRO",
    "CASTELLETTO D'ORBA",
    "CASTELLETTO MERLI",
    "CASTELLETTO MONFERRATO",
    "CASTELNUOVO BORMIDA",
    "CASTELNUOVO SCRIVIA",
    "CASTELSPINA",
    "CAVATORE",
    "CELLA MONTE",
    "CERESETO",
    "CERRETO GRUE",
    "CERRINA MONFERRATO",
    "CONIOLO",
    "CONZANO",
    "COSTA VESCOVATO",
    "CREMOLINO",
    "CUCCARO MONFERRATO",
    "DENICE",
    "DERNICE",
    "FABBRICA CURONE",
    "FELIZZANO",
    "FRACONALTO",
    "FRANCAVILLA BISIO",
    "FRASCARO",
    "FRASSINELLO MONFERRATO",
    "FRASSINETO PO",
    "FRESONARA",
    "FRUGAROLO",
    "FUBINE MONFERRATO",
    "GABIANO",
    "GAMALERO",
    "GARBAGNA",
    "GAVAZZANA",
    "GAVI",
    "GIAROLE",
    "GREMIASCO",
    "GROGNARDO",
    "GRONDONA",
    "GUAZZORA",
    "ISOLA SANT'ANTONIO",
    "LERMA",
    "LU",
    "LU E CUCCARO",
    "MALVICINO",
    "MASIO",
    "MELAZZO",
    "MERANA",
    "MIRABELLO MONFERRATO",
    "MOLARE",
    "MOLINO DEI TORTI",
    "MOMBELLO MONFERRATO",
    "MOMPERONE",
    "MONCESTINO",
    "MONGIARDINO LIGURE",
    "MONLEALE",
    "MONTACUTO",
    "MONTALDEO",
    "MONTALDO BORMIDA",
    "MONTECASTELLO",
    "MONTECHIARO D'ACQUI",
    "MONTEGIOCO",
    "MONTEMARZINO",
    "MORANO SUL PO",
    "MORBELLO",
    "MORNESE",
    "MORSASCO",
    "MURISENGO",
    "NOVI LIGURE",
    "OCCIMIANO",
    "ODALENGO GRANDE",
    "ODALENGO PICCOLO",
    "OLIVOLA",
    "ORSARA BORMIDA",
    "OTTIGLIO",
    "OVADA",
    "OVIGLIO",
    "OZZANO MONFERRATO",
    "PADERNA",
    "PARETO",
    "PARODI LIGURE",
    "PASTURANA",
    "PECETTO DI VALENZA",
    "PIETRA MARAZZI",
    "PIOVERA",
    "POMARO MONFERRATO",
    "PONTECURONE",
    "PONTESTURA",
    "PONTI",
    "PONZANO MONFERRATO",
    "PONZONE",
    "POZZOL GROPPO",
    "POZZOLO FORMIGARO",
    "PRASCO",
    "PREDOSA",
    "QUARGNENTO",
    "QUATTORDIO",
    "RICALDONE",
    "RIVALTA BORMIDA",
    "RIVARONE",
    "ROCCA GRIMALDA",
    "ROCCAFORTE LIGURE",
    "ROCCHETTA LIGURE",
    "ROSIGNANO MONFERRATO",
    "SALA MONFERRATO",
    "SALE",
    "SAN CRISTOFORO",
    "SAN GIORGIO MONFERRATO",
    "SAN SALVATORE MONFERRATO",
    "SAN SEBASTIANO CURONE",
    "SANT'AGATA FOSSILI",
    "SARDIGLIANO",
    "SAREZZANO",
    "SERRALUNGA DI CREA",
    "SERRAVALLE SCRIVIA",
    "SEZZADIO",
    "SILVANO D'ORBA",
    "SOLERO",
    "SOLONGHELLO",
    "SPIGNO MONFERRATO",
    "SPINETO SCRIVIA",
    "STAZZANO",
    "STREVI",
    "TAGLIOLO MONFERRATO",
    "TASSAROLO",
    "TERRUGGIA",
    "TERZO",
    "TICINETO",
    "TORTONA",
    "TREVILLE",
    "TRISOBBIO",
    "VALENZA",
    "VALMACCA",
    "VIGNALE MONFERRATO",
    "VIGNOLE BORBERA",
    "VIGUZZOLO",
    "VILLADEATI",
    "VILLALVERNIA",
    "VILLAMIROGLIO",
    "VILLANOVA MONFERRATO",
    "VILLAROMAGNANO",
    "VISONE",
    "VOLPEDO",
    "VOLPEGLINO",
    "VOLTAGGIO"
  ],
  "BG": [
    "ADRARA SAN MARTINO",
    "ADRARA SAN ROCCO",
    "ALBANO SANT'ALESSANDRO",
    "ALBINO",
    "ALGUA",
    "ALME'",
    "ALMENNO SAN BARTOLOMEO",
    "ALMENNO SAN SALVATORE",
    "ALZANO LOMBARDO",
    "AMBIVERE",
    "ANTEGNATE",
    "ARCENE",
    "ARDESIO",
    "ARZAGO D'ADDA",
    "AVERARA",
    "AVIATICO",
    "AZZANO SAN PAOLO",
    "AZZONE",
    "BAGNATICA",
    "BARBATA",
    "BARIANO",
    "BARZANA",
    "BEDULITA",
    "BERBENNO",
    "BERGAMO",
    "BERZO SAN FERMO",
    "BIANZANO",
    "BLELLO",
    "BOLGARE",
    "BOLTIERE",
    "BONATE SOPRA",
    "BONATE SOTTO",
    "BORGO DI TERZO",
    "BOSSICO",
    "BOTTANUCO",
    "BRACCA",
    "BRANZI",
    "BREMBATE",
    "BREMBATE DI SOPRA",
    "BREMBILLA",
    "BRIGNANO GERA D'ADDA",
    "BRUMANO",
    "BRUSAPORTO",
    "CALCINATE",
    "CALCIO",
    "CALUSCO D'ADDA",
    "CALVENZANO",
    "CAMERATA CORNELLO",
    "CANONICA D'ADDA",
    "CAPIZZONE",
    "CAPRIATE SAN GERVASIO",
    "CAPRINO BERGAMASCO",
    "CARAVAGGIO",
    "CAROBBIO DEGLI ANGELI",
    "CARONA",
    "CARVICO",
    "CASAZZA",
    "CASIRATE D'ADDA",
    "CASNIGO",
    "CASSIGLIO",
    "CASTEL ROZZONE",
    "CASTELLI CALEPIO",
    "CASTIONE DELLA PRESOLANA",
    "CASTRO",
    "CAVERNAGO",
    "CAZZANO SANT'ANDREA",
    "CENATE SOPRA",
    "CENATE SOTTO",
    "CENE",
    "CERETE",
    "CHIGNOLO D'ISOLA",
    "CHIUDUNO",
    "CISANO BERGAMASCO",
    "CISERANO",
    "CIVIDATE AL PIANO",
    "CLUSONE",
    "COLERE",
    "COLOGNO AL SERIO",
    "COLZATE",
    "COMUN NUOVO",
    "CORNA IMAGNA",
    "CORNALBA",
    "CORTENUOVA",
    "COSTA DI MEZZATE",
    "COSTA SERINA",
    "COSTA VALLE IMAGNA",
    "COSTA VOLPINO",
    "COVO",
    "CREDARO",
    "CURNO",
    "CUSIO",
    "DALMINE",
    "DOSSENA",
    "ENDINE GAIANO",
    "ENTRATICO",
    "FARA GERA D'ADDA",
    "FARA OLIVANA CON SOLA",
    "FILAGO",
    "FINO DEL MONTE",
    "FIORANO AL SERIO",
    "FONTANELLA",
    "FONTENO",
    "FOPPOLO",
    "FORESTO SPARSO",
    "FORNOVO SAN GIOVANNI",
    "FUIPIANO VALLE IMAGNA",
    "GANDELLINO",
    "GANDINO",
    "GANDOSSO",
    "GAVERINA TERME",
    "GAZZANIGA",
    "GEROSA",
    "GHISALBA",
    "GORLAGO",
    "GORLE",
    "GORNO",
    "GRASSOBBIO",
    "GROMO",
    "GRONE",
    "GRUMELLO DEL MONTE",
    "ISOLA DI FONDRA",
    "ISSO",
    "LALLIO",
    "LEFFE",
    "LENNA",
    "LEVATE",
    "LOCATELLO",
    "LOVERE",
    "LURANO",
    "LUZZANA",
    "MADONE",
    "MAPELLO",
    "MARTINENGO",
    "MEDOLAGO",
    "MEZZOLDO",
    "MISANO DI GERA D'ADDA",
    "MOIO DE' CALVI",
    "MONASTEROLO DEL CASTELLO",
    "MONTELLO",
    "MORENGO",
    "MORNICO AL SERIO",
    "MOZZANICA",
    "MOZZO",
    "NEMBRO",
    "OLMO AL BREMBO",
    "OLTRE IL COLLE",
    "OLTRESSENDA ALTA",
    "ONETA",
    "ONORE",
    "ORIO AL SERIO",
    "ORNICA",
    "OSIO SOPRA",
    "OSIO SOTTO",
    "PAGAZZANO",
    "PALADINA",
    "PALAZZAGO",
    "PALOSCO",
    "PARRE",
    "PARZANICA",
    "PEDRENGO",
    "PEIA",
    "PIANICO",
    "PIARIO",
    "PIAZZA BREMBANA",
    "PIAZZATORRE",
    "PIAZZOLO",
    "POGNANO",
    "PONTE NOSSA",
    "PONTE SAN PIETRO",
    "PONTERANICA",
    "PONTIDA",
    "PONTIROLO NUOVO",
    "PRADALUNGA",
    "PREDORE",
    "PREMOLO",
    "PRESEZZO",
    "PUMENENGO",
    "RANICA",
    "RANZANICO",
    "RIVA DI SOLTO",
    "ROGNO",
    "ROMANO DI LOMBARDIA",
    "RONCOBELLO",
    "RONCOLA",
    "ROTA D'IMAGNA",
    "ROVETTA",
    "SAN GIOVANNI BIANCO",
    "SAN PAOLO D'ARGON",
    "SAN PELLEGRINO TERME",
    "SANTA BRIGIDA",
    "SANT'OMOBONO TERME",
    "SARNICO",
    "SCANZOROSCIATE",
    "SCHILPARIO",
    "SEDRINA",
    "SELVINO",
    "SERIATE",
    "SERINA",
    "SOLTO COLLINA",
    "SOLZA",
    "SONGAVAZZO",
    "SORISOLE",
    "SOTTO IL MONTE GIOVANNI XXIII",
    "SOVERE",
    "SPINONE AL LAGO",
    "SPIRANO",
    "STEZZANO",
    "STROZZA",
    "SUISIO",
    "TALEGGIO",
    "TAVERNOLA BERGAMASCA",
    "TELGATE",
    "TERNO D'ISOLA",
    "TORRE BOLDONE",
    "TORRE DE' BUSI",
    "TORRE DE' ROVERI",
    "TORRE PALLAVICINA",
    "TRESCORE BALNEARIO",
    "TREVIGLIO",
    "TREVIOLO",
    "UBIALE CLANEZZO",
    "URGNANO",
    "VAL BREMBILLA",
    "VALBONDIONE",
    "VALBREMBO",
    "VALGOGLIO",
    "VALLEVE",
    "VALNEGRA",
    "VALSECCA",
    "VALTORTA",
    "VEDESETA",
    "VERDELLINO",
    "VERDELLO",
    "VERTOVA",
    "VIADANICA",
    "VIGANO SAN MARTINO",
    "VIGOLO",
    "VILLA D'ADDA",
    "VILLA D'ALME'",
    "VILLA DI SERIO",
    "VILLA D'OGNA",
    "VILLONGO",
    "VILMINORE DI SCALVE",
    "ZANDOBBIO",
    "ZANICA",
    "ZOGNO"
  ],
  "RO": [
    "ADRIA",
    "ARIANO NEL POLESINE",
    "ARQUA' POLESINE",
    "BADIA POLESINE",
    "BAGNOLO DI PO",
    "BERGANTINO",
    "BOSARO",
    "CALTO",
    "CANARO",
    "CANDA",
    "CASTELGUGLIELMO",
    "CASTELMASSA",
    "CASTELNOVO BARIANO",
    "CENESELLI",
    "CEREGNANO",
    "CORBOLA",
    "COSTA DI ROVIGO",
    "CRESPINO",
    "FICAROLO",
    "FIESSO UMBERTIANO",
    "FRASSINELLE POLESINE",
    "FRATTA POLESINE",
    "GAIBA",
    "GAVELLO",
    "GIACCIANO CON BARUCHELLA",
    "GUARDA VENETA",
    "LENDINARA",
    "LOREO",
    "LUSIA",
    "MELARA",
    "OCCHIOBELLO",
    "PAPOZZE",
    "PETTORAZZA GRIMANI",
    "PINCARA",
    "POLESELLA",
    "PONTECCHIO POLESINE",
    "PORTO TOLLE",
    "PORTO VIRO",
    "ROSOLINA",
    "ROVIGO",
    "SALARA",
    "SAN BELLINO",
    "SAN MARTINO DI VENEZZE",
    "STIENTA",
    "TAGLIO DI PO",
    "TRECENTA",
    "VILLADOSE",
    "VILLAMARZANA",
    "VILLANOVA DEL GHEBBO",
    "VILLANOVA MARCHESANA"
  ],
  "VR": [
    "AFFI",
    "ALBAREDO D'ADIGE",
    "ANGIARI",
    "ARCOLE",
    "BADIA CALAVENA",
    "BARDOLINO",
    "BELFIORE",
    "BEVILACQUA",
    "BONAVIGO",
    "BOSCHI SANT'ANNA",
    "BOSCO CHIESANUOVA",
    "BOVOLONE",
    "BRENTINO BELLUNO",
    "BRENZONE",
    "BUSSOLENGO",
    "BUTTAPIETRA",
    "CALDIERO",
    "CAPRINO VERONESE",
    "CASALEONE",
    "CASTAGNARO",
    "CASTEL D'AZZANO",
    "CASTELNUOVO DEL GARDA",
    "CAVAION VERONESE",
    "CAZZANO DI TRAMIGNA",
    "CEREA",
    "CERRO VERONESE",
    "COLOGNA VENETA",
    "COLOGNOLA AI COLLI",
    "CONCAMARISE",
    "COSTERMANO",
    "DOLCE'",
    "ERBE'",
    "ERBEZZO",
    "FERRARA DI MONTE BALDO",
    "FUMANE",
    "GARDA",
    "GAZZO VERONESE",
    "GREZZANA",
    "ILLASI",
    "ISOLA DELLA SCALA",
    "ISOLA RIZZA",
    "LAVAGNO",
    "LAZISE",
    "LEGNAGO",
    "MALCESINE",
    "MARANO DI VALPOLICELLA",
    "MEZZANE DI SOTTO",
    "MINERBE",
    "MONTECCHIA DI CROSARA",
    "MONTEFORTE D'ALPONE",
    "MOZZECANE",
    "NEGRAR DI VALPOLICELLA",
    "NOGARA",
    "NOGAROLE ROCCA",
    "OPPEANO",
    "PALU'",
    "PASTRENGO",
    "PESCANTINA",
    "PESCHIERA DEL GARDA",
    "POVEGLIANO VERONESE",
    "PRESSANA",
    "RIVOLI VERONESE",
    "RONCA'",
    "RONCO ALL'ADIGE",
    "ROVERCHIARA",
    "ROVERE' VERONESE",
    "ROVEREDO DI GUA'",
    "SALIZZOLE",
    "SAN BONIFACIO",
    "SAN GIOVANNI ILARIONE",
    "SAN GIOVANNI LUPATOTO",
    "SAN MARTINO BUON ALBERGO",
    "SAN MAURO DI SALINE",
    "SAN PIETRO DI MORUBIO",
    "SAN PIETRO IN CARIANO",
    "SAN ZENO DI MONTAGNA",
    "SANGUINETTO",
    "SANT'AMBROGIO DI VALPOLICELLA",
    "SANT'ANNA D'ALFAEDO",
    "SELVA DI PROGNO",
    "SOAVE",
    "SOMMACAMPAGNA",
    "SONA",
    "SORGA'",
    "TERRAZZO",
    "TORRI DEL BENACO",
    "TREGNAGO",
    "TREVENZUOLO",
    "VALEGGIO SUL MINCIO",
    "VELO VERONESE",
    "VERONA",
    "VERONELLA",
    "VESTENANOVA",
    "VIGASIO",
    "VILLA BARTOLOMEA",
    "VILLAFRANCA DI VERONA",
    "ZEVIO",
    "ZIMELLA"
  ],
  "RM": [
    "AFFILE",
    "AGOSTA",
    "ALBANO LAZIALE",
    "ALLUMIERE",
    "ANGUILLARA SABAZIA",
    "ANTICOLI CORRADO",
    "ANZIO",
    "ARCINAZZO ROMANO",
    "ARDEA",
    "ARICCIA",
    "ARSOLI",
    "ARTENA",
    "BELLEGRA",
    "BRACCIANO",
    "CAMERATA NUOVA",
    "CAMPAGNANO DI ROMA",
    "CANALE MONTERANO",
    "CANTERANO",
    "CAPENA",
    "CAPRANICA PRENESTINA",
    "CARPINETO ROMANO",
    "CASAPE",
    "CASTEL GANDOLFO",
    "CASTEL MADAMA",
    "CASTEL SAN PIETRO ROMANO",
    "CASTELNUOVO DI PORTO",
    "CAVE",
    "CERRETO LAZIALE",
    "CERVARA DI ROMA",
    "CERVETERI",
    "CIAMPINO",
    "CICILIANO",
    "CINETO ROMANO",
    "CIVITAVECCHIA",
    "CIVITELLA SAN PAOLO",
    "COLLEFERRO",
    "COLONNA",
    "FIANO ROMANO",
    "FILACCIANO",
    "FIUMICINO",
    "FONTE NUOVA",
    "FORMELLO",
    "FRASCATI",
    "GALLICANO NEL LAZIO",
    "GAVIGNANO",
    "GENAZZANO",
    "GENZANO DI ROMA",
    "GERANO",
    "GORGA",
    "GROTTAFERRATA",
    "GUIDONIA MONTECELIO",
    "JENNE",
    "LABICO",
    "LADISPOLI",
    "LANUVIO",
    "LARIANO",
    "LICENZA",
    "MAGLIANO ROMANO",
    "MANDELA",
    "MANZIANA",
    "MARANO EQUO",
    "MARCELLINA",
    "MARINO",
    "MAZZANO ROMANO",
    "MENTANA",
    "MONTE COMPATRI",
    "MONTE PORZIO CATONE",
    "MONTEFLAVIO",
    "MONTELANICO",
    "MONTELIBRETTI",
    "MONTEROTONDO",
    "MONTORIO ROMANO",
    "MORICONE",
    "MORLUPO",
    "NAZZANO",
    "NEMI",
    "NEROLA",
    "NETTUNO",
    "OLEVANO ROMANO",
    "PALESTRINA",
    "PALOMBARA SABINA",
    "PERCILE",
    "PISONIANO",
    "POLI",
    "POMEZIA",
    "PONZANO ROMANO",
    "RIANO",
    "RIGNANO FLAMINIO",
    "RIOFREDDO",
    "ROCCA CANTERANO",
    "ROCCA DI CAVE",
    "ROCCA DI PAPA",
    "ROCCA PRIORA",
    "ROCCA SANTO STEFANO",
    "ROCCAGIOVINE",
    "ROIATE",
    "ROMA",
    "ROVIANO",
    "SACROFANO",
    "SAMBUCI",
    "SAN CESAREO",
    "SAN GREGORIO DA SASSOLA",
    "SAN POLO DEI CAVALIERI",
    "SAN VITO ROMANO",
    "SANTA MARINELLA",
    "SANT'ANGELO ROMANO",
    "SANT'ORESTE",
    "SARACINESCO",
    "SEGNI",
    "SUBIACO",
    "TIVOLI",
    "TOLFA",
    "TORRITA TIBERINA",
    "TREVIGNANO ROMANO",
    "VALLEPIETRA",
    "VALLINFREDA",
    "VALMONTONE",
    "VELLETRI",
    "VICOVARO",
    "VIVARO ROMANO",
    "ZAGAROLO"
  ],
  "RC": [
    "AFRICO",
    "AGNANA CALABRA",
    "ANOIA",
    "ANTONIMINA",
    "ARDORE",
    "BAGALADI",
    "BAGNARA CALABRA",
    "BENESTARE",
    "BIANCO",
    "BIVONGI",
    "BOVA",
    "BOVA MARINA",
    "BOVALINO",
    "BRANCALEONE",
    "BRUZZANO ZEFFIRIO",
    "CALANNA",
    "CAMINI",
    "CAMPO CALABRO",
    "CANDIDONI",
    "CANOLO",
    "CARAFFA DEL BIANCO",
    "CARDETO",
    "CARERI",
    "CASIGNANA",
    "CAULONIA",
    "CIMINA'",
    "CINQUEFRONDI",
    "CITTANOVA",
    "CONDOFURI",
    "COSOLETO",
    "DELIANUOVA",
    "FEROLETO DELLA CHIESA",
    "FERRUZZANO",
    "FIUMARA",
    "GALATRO",
    "GERACE",
    "GIFFONE",
    "GIOIA TAURO",
    "GIOIOSA IONICA",
    "GROTTERIA",
    "LAGANADI",
    "LAUREANA DI BORRELLO",
    "LOCRI",
    "MAMMOLA",
    "MARINA DI GIOIOSA IONICA",
    "MAROPATI",
    "MARTONE",
    "MELICUCCA'",
    "MELICUCCO",
    "MELITO DI PORTO SALVO",
    "MOLOCHIO",
    "MONASTERACE",
    "MONTEBELLO IONICO",
    "MOTTA SAN GIOVANNI",
    "OPPIDO MAMERTINA",
    "PALIZZI",
    "PALMI",
    "PAZZANO",
    "PLACANICA",
    "PLATI'",
    "POLISTENA",
    "PORTIGLIOLA",
    "REGGIO DI CALABRIA",
    "RIACE",
    "RIZZICONI",
    "ROCCAFORTE DEL GRECO",
    "ROCCELLA IONICA",
    "ROGHUDI",
    "ROSARNO",
    "SAMO",
    "SAN FERDINANDO",
    "SAN GIORGIO MORGETO",
    "SAN GIOVANNI DI GERACE",
    "SAN LORENZO",
    "SAN LUCA",
    "SAN PIETRO DI CARIDA'",
    "SAN PROCOPIO",
    "SAN ROBERTO",
    "SANTA CRISTINA D'ASPROMONTE",
    "SANT'AGATA DEL BIANCO",
    "SANT'ALESSIO IN ASPROMONTE",
    "SANT'EUFEMIA D'ASPROMONTE",
    "SANT'ILARIO DELLO IONIO",
    "SANTO STEFANO IN ASPROMONTE",
    "SCIDO",
    "SCILLA",
    "SEMINARA",
    "SERRATA",
    "SIDERNO",
    "SINOPOLI",
    "STAITI",
    "STIGNANO",
    "STILO",
    "TAURIANOVA",
    "TERRANOVA SAPPO MINULIO",
    "VARAPODIO",
    "VILLA SAN GIOVANNI"
  ],
  "PC": [
    "AGAZZANO",
    "ALSENO",
    "ALTA VAL TIDONE",
    "BESENZONE",
    "BETTOLA",
    "BOBBIO",
    "BORGONOVO VAL TIDONE",
    "CADEO",
    "CALENDASCO",
    "CAMINATA",
    "CAORSO",
    "CARPANETO PIACENTINO",
    "CASTEL SAN GIOVANNI",
    "CASTELL'ARQUATO",
    "CASTELVETRO PIACENTINO",
    "CERIGNALE",
    "COLI",
    "CORTE BRUGNATELLA",
    "CORTEMAGGIORE",
    "FARINI",
    "FERRIERE",
    "FIORENZUOLA D'ARDA",
    "GAZZOLA",
    "GOSSOLENGO",
    "GRAGNANO TREBBIENSE",
    "GROPPARELLO",
    "LUGAGNANO VAL D'ARDA",
    "MONTICELLI D'ONGINA",
    "MORFASSO",
    "NIBBIANO",
    "OTTONE",
    "PECORARA",
    "PIACENZA",
    "PIANELLO VAL TIDONE",
    "PIOZZANO",
    "PODENZANO",
    "PONTE DELL'OLIO",
    "PONTENURE",
    "RIVERGARO",
    "ROTTOFRENO",
    "SAN GIORGIO PIACENTINO",
    "SAN PIETRO IN CERRO",
    "SARMATO",
    "TRAVO",
    "VERNASCA",
    "VIGOLZONE",
    "VILLANOVA SULL'ARDA",
    "ZERBA",
    "ZIANO PIACENTINO"
  ],
  "SS": [
    "AGGIUS",
    "AGLIENTU",
    "ALA' DEI SARDI",
    "ALGHERO",
    "ANELA",
    "ARDARA",
    "ARZACHENA",
    "BADESI",
    "BANARI",
    "BENETUTTI",
    "BERCHIDDA",
    "BESSUDE",
    "BONNANARO",
    "BONO",
    "BONORVA",
    "BORTIGIADAS",
    "BORUTTA",
    "BOTTIDDA",
    "BUDDUSO'",
    "BUDONI",
    "BULTEI",
    "BULZI",
    "BURGOS",
    "CALANGIANUS",
    "CARGEGHE",
    "CASTELSARDO",
    "CHEREMULE",
    "CHIARAMONTI",
    "CODRONGIANOS",
    "COSSOINE",
    "ERULA",
    "ESPORLATU",
    "FLORINAS",
    "GIAVE",
    "GOLFO ARANCI",
    "ILLORAI",
    "ITTIREDDU",
    "ITTIRI",
    "LA MADDALENA",
    "LAERRU",
    "LOIRI PORTO SAN PAOLO",
    "LUOGOSANTO",
    "LURAS",
    "MARA",
    "MARTIS",
    "MONTELEONE ROCCA DORIA",
    "MONTI",
    "MORES",
    "MUROS",
    "NUGHEDU SAN NICOLO'",
    "NULE",
    "NULVI",
    "OLBIA",
    "OLMEDO",
    "OSCHIRI",
    "OSILO",
    "OSSI",
    "OZIERI",
    "PADRIA",
    "PADRU",
    "PALAU",
    "PATTADA",
    "PERFUGAS",
    "PLOAGHE",
    "PORTO TORRES",
    "POZZOMAGGIORE",
    "PUTIFIGARI",
    "ROMANA",
    "SAN TEODORO",
    "SANTA MARIA COGHINAS",
    "SANTA TERESA GALLURA",
    "SANT'ANTONIO DI GALLURA",
    "SASSARI",
    "SEDINI",
    "SEMESTENE",
    "SENNORI",
    "SILIGO",
    "SORSO",
    "STINTINO",
    "TELTI",
    "TEMPIO PAUSANIA",
    "TERGU",
    "THIESI",
    "TISSI",
    "TORRALBA",
    "TRINITA' D'AGULTU E VIGNOLA",
    "TULA",
    "URI",
    "USINI",
    "VALLEDORIA",
    "VIDDALBA",
    "VILLANOVA MONTELEONE"
  ],
  "EN": [
    "AGIRA",
    "AIDONE",
    "ASSORO",
    "BARRAFRANCA",
    "CALASCIBETTA",
    "CATENANUOVA",
    "CENTURIPE",
    "CERAMI",
    "ENNA",
    "GAGLIANO CASTELFERRATO",
    "LEONFORTE",
    "NICOSIA",
    "NISSORIA",
    "PIAZZA ARMERINA",
    "PIETRAPERZIA",
    "REGALBUTO",
    "SPERLINGA",
    "TROINA",
    "VALGUARNERA CAROPEPE",
    "VILLAROSA"
  ],
  "AT": [
    "AGLIANO TERME",
    "ALBUGNANO",
    "ANTIGNANO",
    "ARAMENGO",
    "ASTI",
    "AZZANO D'ASTI",
    "BALDICHIERI D'ASTI",
    "BELVEGLIO",
    "BERZANO DI SAN PIETRO",
    "BRUNO",
    "BUBBIO",
    "BUTTIGLIERA D'ASTI",
    "CALAMANDRANA",
    "CALLIANO",
    "CALOSSO",
    "CAMERANO CASASCO",
    "CANELLI",
    "CANTARANA",
    "CAPRIGLIO",
    "CASORZO",
    "CASSINASCO",
    "CASTAGNOLE DELLE LANZE",
    "CASTAGNOLE MONFERRATO",
    "CASTEL BOGLIONE",
    "CASTEL ROCCHERO",
    "CASTELL'ALFERO",
    "CASTELLERO",
    "CASTELLETTO MOLINA",
    "CASTELLO DI ANNONE",
    "CASTELNUOVO BELBO",
    "CASTELNUOVO CALCEA",
    "CASTELNUOVO DON BOSCO",
    "CELLARENGO",
    "CELLE ENOMONDO",
    "CERRETO D'ASTI",
    "CERRO TANARO",
    "CESSOLE",
    "CHIUSANO D'ASTI",
    "CINAGLIO",
    "CISTERNA D'ASTI",
    "COAZZOLO",
    "COCCONATO",
    "CORSIONE",
    "CORTANDONE",
    "CORTANZE",
    "CORTAZZONE",
    "CORTIGLIONE",
    "COSSOMBRATO",
    "COSTIGLIOLE D'ASTI",
    "CUNICO",
    "DUSINO SAN MICHELE",
    "FERRERE",
    "FONTANILE",
    "FRINCO",
    "GRANA",
    "GRAZZANO BADOGLIO",
    "INCISA SCAPACCINO",
    "ISOLA D'ASTI",
    "LOAZZOLO",
    "MARANZANA",
    "MARETTO",
    "MOASCA",
    "MOMBALDONE",
    "MOMBARUZZO",
    "MOMBERCELLI",
    "MONALE",
    "MONASTERO BORMIDA",
    "MONCALVO",
    "MONCUCCO TORINESE",
    "MONGARDINO",
    "MONTABONE",
    "MONTAFIA",
    "MONTALDO SCARAMPI",
    "MONTECHIARO D'ASTI",
    "MONTEGROSSO D'ASTI",
    "MONTEMAGNO",
    "MONTIGLIO MONFERRATO",
    "MORANSENGO",
    "NIZZA MONFERRATO",
    "OLMO GENTILE",
    "PASSERANO MARMORITO",
    "PENANGO",
    "PIEA",
    "PINO D'ASTI",
    "PIOVA' MASSAIA",
    "PORTACOMARO",
    "QUARANTI",
    "REFRANCORE",
    "REVIGLIASCO D'ASTI",
    "ROATTO",
    "ROBELLA",
    "ROCCA D'ARAZZO",
    "ROCCAVERANO",
    "ROCCHETTA PALAFEA",
    "ROCCHETTA TANARO",
    "SAN DAMIANO D'ASTI",
    "SAN GIORGIO SCARAMPI",
    "SAN MARTINO ALFIERI",
    "SAN MARZANO OLIVETO",
    "SAN PAOLO SOLBRITO",
    "SCURZOLENGO",
    "SEROLE",
    "SESSAME",
    "SETTIME",
    "SOGLIO",
    "TIGLIOLE",
    "TONCO",
    "TONENGO",
    "VAGLIO SERRA",
    "VALFENERA",
    "VESIME",
    "VIALE",
    "VIARIGI",
    "VIGLIANO D'ASTI",
    "VILLA SAN SECONDO",
    "VILLAFRANCA D'ASTI",
    "VILLANOVA D'ASTI",
    "VINCHIO"
  ],
  "TO": [
    "AGLIE'",
    "AIRASCA",
    "ALA DI STURA",
    "ALBIANO D'IVREA",
    "ALICE SUPERIORE",
    "ALMESE",
    "ALPETTE",
    "ALPIGNANO",
    "ANDEZENO",
    "ANDRATE",
    "ANGROGNA",
    "ARIGNANO",
    "AVIGLIANA",
    "AZEGLIO",
    "BAIRO",
    "BALANGERO",
    "BALDISSERO CANAVESE",
    "BALDISSERO TORINESE",
    "BALME",
    "BANCHETTE",
    "BARBANIA",
    "BARDONECCHIA",
    "BARONE CANAVESE",
    "BEINASCO",
    "BIBIANA",
    "BOBBIO PELLICE",
    "BOLLENGO",
    "BORGARO TORINESE",
    "BORGIALLO",
    "BORGOFRANCO D'IVREA",
    "BORGOMASINO",
    "BORGONE SUSA",
    "BOSCONERO",
    "BRANDIZZO",
    "BRICHERASIO",
    "BROSSO",
    "BROZOLO",
    "BRUINO",
    "BRUSASCO",
    "BRUZOLO",
    "BURIASCO",
    "BUROLO",
    "BUSANO",
    "BUSSOLENO",
    "BUTTIGLIERA ALTA",
    "CAFASSE",
    "CALUSO",
    "CAMBIANO",
    "CAMPIGLIONE FENILE",
    "CANDIA CANAVESE",
    "CANDIOLO",
    "CANISCHIO",
    "CANTALUPA",
    "CANTOIRA",
    "CAPRIE",
    "CARAVINO",
    "CAREMA",
    "CARIGNANO",
    "CARMAGNOLA",
    "CASALBORGONE",
    "CASCINETTE D'IVREA",
    "CASELETTE",
    "CASELLE TORINESE",
    "CASTAGNETO PO",
    "CASTAGNOLE PIEMONTE",
    "CASTELLAMONTE",
    "CASTELNUOVO NIGRA",
    "CASTIGLIONE TORINESE",
    "CAVAGNOLO",
    "CAVOUR",
    "CERCENASCO",
    "CERES",
    "CERESOLE REALE",
    "CESANA TORINESE",
    "CHIALAMBERTO",
    "CHIANOCCO",
    "CHIAVERANO",
    "CHIERI",
    "CHIESANUOVA",
    "CHIOMONTE",
    "CHIUSA DI SAN MICHELE",
    "CHIVASSO",
    "CICONIO",
    "CINTANO",
    "CINZANO",
    "CIRIE'",
    "CLAVIERE",
    "COASSOLO TORINESE",
    "COAZZE",
    "COLLEGNO",
    "COLLERETTO CASTELNUOVO",
    "COLLERETTO GIACOSA",
    "CONDOVE",
    "CORIO",
    "COSSANO CANAVESE",
    "CUCEGLIO",
    "CUMIANA",
    "CUORGNE'",
    "DRUENTO",
    "EXILLES",
    "FAVRIA",
    "FELETTO",
    "FENESTRELLE",
    "FIANO",
    "FIORANO CANAVESE",
    "FOGLIZZO",
    "FORNO CANAVESE",
    "FRASSINETTO",
    "FRONT",
    "FROSSASCO",
    "GARZIGLIANA",
    "GASSINO TORINESE",
    "GERMAGNANO",
    "GIAGLIONE",
    "GIAVENO",
    "GIVOLETTO",
    "GRAVERE",
    "GROSCAVALLO",
    "GROSSO",
    "GRUGLIASCO",
    "INGRIA",
    "INVERSO PINASCA",
    "ISOLABELLA",
    "ISSIGLIO",
    "IVREA",
    "LA CASSA",
    "LA LOGGIA",
    "LANZO TORINESE",
    "LAURIANO",
    "LEINI",
    "LEMIE",
    "LESSOLO",
    "LEVONE",
    "LOCANA",
    "LOMBARDORE",
    "LOMBRIASCO",
    "LORANZE'",
    "LUGNACCO",
    "LUSERNA SAN GIOVANNI",
    "LUSERNETTA",
    "LUSIGLIE'",
    "MACELLO",
    "MAGLIONE",
    "MAPPANO",
    "MARENTINO",
    "MASSELLO",
    "MATHI",
    "MATTIE",
    "MAZZE'",
    "MEANA DI SUSA",
    "MERCENASCO",
    "MEUGLIANO",
    "MEZZENILE",
    "MOMBELLO DI TORINO",
    "MOMPANTERO",
    "MONASTERO DI LANZO",
    "MONCALIERI",
    "MONCENISIO",
    "MONTALDO TORINESE",
    "MONTALENGHE",
    "MONTALTO DORA",
    "MONTANARO",
    "MONTEU DA PO",
    "MORIONDO TORINESE",
    "NICHELINO",
    "NOASCA",
    "NOLE",
    "NOMAGLIO",
    "NONE",
    "NOVALESA",
    "OGLIANICO",
    "ORBASSANO",
    "ORIO CANAVESE",
    "OSASCO",
    "OSASIO",
    "OULX",
    "OZEGNA",
    "PALAZZO CANAVESE",
    "PANCALIERI",
    "PARELLA",
    "PAVAROLO",
    "PAVONE CANAVESE",
    "PECCO",
    "PECETTO TORINESE",
    "PEROSA ARGENTINA",
    "PEROSA CANAVESE",
    "PERRERO",
    "PERTUSIO",
    "PESSINETTO",
    "PIANEZZA",
    "PINASCA",
    "PINEROLO",
    "PINO TORINESE",
    "PIOBESI TORINESE",
    "PIOSSASCO",
    "PISCINA",
    "PIVERONE",
    "POIRINO",
    "POMARETTO",
    "PONT CANAVESE",
    "PORTE",
    "PRAGELATO",
    "PRALI",
    "PRALORMO",
    "PRAMOLLO",
    "PRAROSTINO",
    "PRASCORSANO",
    "PRATIGLIONE",
    "QUAGLIUZZO",
    "QUASSOLO",
    "QUINCINETTO",
    "REANO",
    "RIBORDONE",
    "RIVA PRESSO CHIERI",
    "RIVALBA",
    "RIVALTA DI TORINO",
    "RIVARA",
    "RIVAROLO CANAVESE",
    "RIVAROSSA",
    "RIVOLI",
    "ROBASSOMERO",
    "ROCCA CANAVESE",
    "ROLETTO",
    "ROMANO CANAVESE",
    "RONCO CANAVESE",
    "RONDISSONE",
    "RORA'",
    "ROSTA",
    "ROURE",
    "RUBIANA",
    "RUEGLIO",
    "SALASSA",
    "SALBERTRAND",
    "SALERANO CANAVESE",
    "SALZA DI PINEROLO",
    "SAMONE",
    "SAN BENIGNO CANAVESE",
    "SAN CARLO CANAVESE",
    "SAN COLOMBANO BELMONTE",
    "SAN DIDERO",
    "SAN FRANCESCO AL CAMPO",
    "SAN GERMANO CHISONE",
    "SAN GILLIO",
    "SAN GIORGIO CANAVESE",
    "SAN GIORIO DI SUSA",
    "SAN GIUSTO CANAVESE",
    "SAN MARTINO CANAVESE",
    "SAN MAURIZIO CANAVESE",
    "SAN MAURO TORINESE",
    "SAN PIETRO VAL LEMINA",
    "SAN PONSO",
    "SAN RAFFAELE CIMENA",
    "SAN SEBASTIANO DA PO",
    "SAN SECONDO DI PINEROLO",
    "SANGANO",
    "SANT'AMBROGIO DI TORINO",
    "SANT'ANTONINO DI SUSA",
    "SANTENA",
    "SAUZE DI CESANA",
    "SAUZE D'OULX",
    "SCALENGHE",
    "SCARMAGNO",
    "SCIOLZE",
    "SESTRIERE",
    "SETTIMO ROTTARO",
    "SETTIMO TORINESE",
    "SETTIMO VITTONE",
    "SPARONE",
    "STRAMBINELLO",
    "STRAMBINO",
    "SUSA",
    "TAVAGNASCO",
    "TORINO",
    "TORRAZZA PIEMONTE",
    "TORRE CANAVESE",
    "TORRE PELLICE",
    "TRANA",
    "TRAUSELLA",
    "TRAVERSELLA",
    "TRAVES",
    "TROFARELLO",
    "USSEAUX",
    "USSEGLIO",
    "VAIE",
    "VAL DELLA TORRE",
    "VAL DI CHY",
    "VALCHIUSA",
    "VALGIOIE",
    "VALLO TORINESE",
    "VALPERGA",
    "VALPRATO SOANA",
    "VARISELLA",
    "VAUDA CANAVESE",
    "VENARIA REALE",
    "VENAUS",
    "VEROLENGO",
    "VERRUA SAVOIA",
    "VESTIGNE'",
    "VIALFRE'",
    "VICO CANAVESE",
    "VIDRACCO",
    "VIGONE",
    "VILLAFRANCA PIEMONTE",
    "VILLANOVA CANAVESE",
    "VILLAR DORA",
    "VILLAR FOCCHIARDO",
    "VILLAR PELLICE",
    "VILLAR PEROSA",
    "VILLARBASSE",
    "VILLAREGGIA",
    "VILLASTELLONE",
    "VINOVO",
    "VIRLE PIEMONTE",
    "VISCHE",
    "VISTRORIO",
    "VIU'",
    "VOLPIANO",
    "VOLVERA"
  ],
  "BL": [
    "AGORDO",
    "ALANO DI PIAVE",
    "ALLEGHE",
    "ALPAGO",
    "ARSIE'",
    "AURONZO DI CADORE",
    "BELLUNO",
    "BORCA DI CADORE",
    "BORGO VALBELLUNA",
    "CALALZO DI CADORE",
    "CANALE D'AGORDO",
    "CASTELLAVAZZO",
    "CENCENIGHE AGORDINO",
    "CESIOMAGGIORE",
    "CHIES D'ALPAGO",
    "CIBIANA DI CADORE",
    "COLLE SANTA LUCIA",
    "COMELICO SUPERIORE",
    "CORTINA D'AMPEZZO",
    "DANTA DI CADORE",
    "DOMEGGE DI CADORE",
    "FALCADE",
    "FARRA D'ALPAGO",
    "FELTRE",
    "FONZASO",
    "FORNO DI ZOLDO",
    "GOSALDO",
    "LA VALLE AGORDINA",
    "LAMON",
    "LENTIAI",
    "LIMANA",
    "LIVINALLONGO DEL COL DI LANA",
    "LONGARONE",
    "LORENZAGO DI CADORE",
    "LOZZO DI CADORE",
    "MEL",
    "OSPITALE DI CADORE",
    "PEDAVENA",
    "PERAROLO DI CADORE",
    "PIEVE D'ALPAGO",
    "PIEVE DI CADORE",
    "PONTE NELLE ALPI",
    "PUOS D'ALPAGO",
    "QUERO",
    "QUERO VAS",
    "RIVAMONTE AGORDINO",
    "ROCCA PIETORE",
    "SAN GREGORIO NELLE ALPI",
    "SAN NICOLO' DI COMELICO",
    "SAN PIETRO DI CADORE",
    "SAN TOMASO AGORDINO",
    "SAN VITO DI CADORE",
    "SANTA GIUSTINA",
    "SANTO STEFANO DI CADORE",
    "SEDICO",
    "SELVA DI CADORE",
    "SEREN DEL GRAPPA",
    "SOSPIROLO",
    "SOVERZENE",
    "SOVRAMONTE",
    "TAIBON AGORDINO",
    "TAMBRE",
    "TRICHIANA",
    "VAL DI ZOLDO",
    "VALLADA AGORDINA",
    "VALLE DI CADORE",
    "VAS",
    "VIGO DI CADORE",
    "VODO CADORE",
    "VOLTAGO AGORDINO",
    "ZOLDO ALTO",
    "ZOPPE' DI CADORE"
  ],
  "VA": [
    "AGRA",
    "ALBIZZATE",
    "ANGERA",
    "ARCISATE",
    "ARSAGO SEPRIO",
    "AZZATE",
    "AZZIO",
    "BARASSO",
    "BARDELLO",
    "BEDERO VALCUVIA",
    "BESANO",
    "BESNATE",
    "BESOZZO",
    "BIANDRONNO",
    "BISUSCHIO",
    "BODIO LOMNAGO",
    "BREBBIA",
    "BREGANO",
    "BRENTA",
    "BREZZO DI BEDERO",
    "BRINZIO",
    "BRISSAGO-VALTRAVAGLIA",
    "BRUNELLO",
    "BRUSIMPIANO",
    "BUGUGGIATE",
    "BUSTO ARSIZIO",
    "CADEGLIANO-VICONAGO",
    "CADREZZATE",
    "CADREZZATE CON OSMATE",
    "CAIRATE",
    "CANTELLO",
    "CARAVATE",
    "CARDANO AL CAMPO",
    "CARNAGO",
    "CARONNO PERTUSELLA",
    "CARONNO VARESINO",
    "CASALE LITTA",
    "CASALZUIGNO",
    "CASCIAGO",
    "CASORATE SEMPIONE",
    "CASSANO MAGNAGO",
    "CASSANO VALCUVIA",
    "CASTELLANZA",
    "CASTELLO CABIAGLIO",
    "CASTELSEPRIO",
    "CASTELVECCANA",
    "CASTIGLIONE OLONA",
    "CASTRONNO",
    "CAVARIA CON PREMEZZO",
    "CAZZAGO BRABBIA",
    "CISLAGO",
    "CITTIGLIO",
    "CLIVIO",
    "COCQUIO-TREVISAGO",
    "COMABBIO",
    "COMERIO",
    "CREMENAGA",
    "CROSIO DELLA VALLE",
    "CUASSO AL MONTE",
    "CUGLIATE-FABIASCO",
    "CUNARDO",
    "CURIGLIA CON MONTEVIASCO",
    "CUVEGLIO",
    "CUVIO",
    "DAVERIO",
    "DUMENZA",
    "DUNO",
    "FAGNANO OLONA",
    "FERNO",
    "FERRERA DI VARESE",
    "GALLARATE",
    "GALLIATE LOMBARDO",
    "GAVIRATE",
    "GAZZADA SCHIANNO",
    "GEMONIO",
    "GERENZANO",
    "GERMIGNAGA",
    "GOLASECCA",
    "GORLA MAGGIORE",
    "GORLA MINORE",
    "GORNATE-OLONA",
    "GRANTOLA",
    "INARZO",
    "INDUNO OLONA",
    "ISPRA",
    "JERAGO CON ORAGO",
    "LAVENA PONTE TRESA",
    "LAVENO MOMBELLO",
    "LEGGIUNO",
    "LONATE CEPPINO",
    "LONATE POZZOLO",
    "LOZZA",
    "LUINO",
    "LUVINATE",
    "MACCAGNO",
    "MACCAGNO CON PINO E VEDDASCA",
    "MALGESSO",
    "MALNATE",
    "MARCHIROLO",
    "MARNATE",
    "MARZIO",
    "MASCIAGO PRIMO",
    "MERCALLO",
    "MESENZANA",
    "MONTEGRINO VALTRAVAGLIA",
    "MONVALLE",
    "MORAZZONE",
    "MORNAGO",
    "OGGIONA CON SANTO STEFANO",
    "OLGIATE OLONA",
    "ORIGGIO",
    "ORINO",
    "OSMATE",
    "PINO SULLA SPONDA DEL LAGO MAGGIORE",
    "PORTO CERESIO",
    "PORTO VALTRAVAGLIA",
    "RANCIO VALCUVIA",
    "RANCO",
    "SALTRIO",
    "SAMARATE",
    "SANGIANO",
    "SARONNO",
    "SESTO CALENDE",
    "SOLBIATE ARNO",
    "SOLBIATE OLONA",
    "SOMMA LOMBARDO",
    "SUMIRAGO",
    "TAINO",
    "TERNATE",
    "TRADATE",
    "TRAVEDONA-MONATE",
    "TRONZANO LAGO MAGGIORE",
    "UBOLDO",
    "VALGANNA",
    "VARANO BORGHI",
    "VARESE",
    "VEDANO OLONA",
    "VEDDASCA",
    "VENEGONO INFERIORE",
    "VENEGONO SUPERIORE",
    "VERGIATE",
    "VIGGIU'",
    "VIZZOLA TICINO"
  ],
  "MB": [
    "AGRATE BRIANZA",
    "AICURZIO",
    "ALBIATE",
    "ARCORE",
    "BARLASSINA",
    "BELLUSCO",
    "BERNAREGGIO",
    "BESANA IN BRIANZA",
    "BIASSONO",
    "BOVISIO-MASCIAGO",
    "BRIOSCO",
    "BRUGHERIO",
    "BURAGO DI MOLGORA",
    "BUSNAGO",
    "CAMPARADA",
    "CAPONAGO",
    "CARATE BRIANZA",
    "CARNATE",
    "CAVENAGO DI BRIANZA",
    "CERIANO LAGHETTO",
    "CESANO MADERNO",
    "COGLIATE",
    "CONCOREZZO",
    "CORNATE D'ADDA",
    "CORREZZANA",
    "DESIO",
    "GIUSSANO",
    "LAZZATE",
    "LENTATE SUL SEVESO",
    "LESMO",
    "LIMBIATE",
    "LISSONE",
    "MACHERIO",
    "MEDA",
    "MEZZAGO",
    "MISINTO",
    "MONZA",
    "MUGGIO'",
    "NOVA MILANESE",
    "ORNAGO",
    "RENATE",
    "RONCELLO",
    "RONCO BRIANTINO",
    "SEREGNO",
    "SEVESO",
    "SOVICO",
    "SULBIATE",
    "TRIUGGIO",
    "USMATE VELATE",
    "VAREDO",
    "VEDANO AL LAMBRO",
    "VEDUGGIO CON COLZANO",
    "VERANO BRIANZA",
    "VILLASANTA",
    "VIMERCATE"
  ],
  "NO": [
    "AGRATE CONTURBIA",
    "AMENO",
    "ARMENO",
    "ARONA",
    "BARENGO",
    "BELLINZAGO NOVARESE",
    "BIANDRATE",
    "BOCA",
    "BOGOGNO",
    "BOLZANO NOVARESE",
    "BORGO TICINO",
    "BORGOLAVEZZARO",
    "BORGOMANERO",
    "BRIGA NOVARESE",
    "BRIONA",
    "CALTIGNAGA",
    "CAMERI",
    "CARPIGNANO SESIA",
    "CASALBELTRAME",
    "CASALEGGIO NOVARA",
    "CASALINO",
    "CASALVOLONE",
    "CASTELLAZZO NOVARESE",
    "CASTELLETTO SOPRA TICINO",
    "CAVAGLIETTO",
    "CAVAGLIO D'AGOGNA",
    "CAVALLIRIO",
    "CERANO",
    "COLAZZA",
    "COMIGNAGO",
    "CRESSA",
    "CUREGGIO",
    "DIVIGNANO",
    "DORMELLETTO",
    "FARA NOVARESE",
    "FONTANETO D'AGOGNA",
    "GALLIATE",
    "GARBAGNA NOVARESE",
    "GARGALLO",
    "GATTICO",
    "GATTICO-VERUNO",
    "GHEMME",
    "GOZZANO",
    "GRANOZZO CON MONTICELLO",
    "GRIGNASCO",
    "INVORIO",
    "LANDIONA",
    "LESA",
    "MAGGIORA",
    "MANDELLO VITTA",
    "MARANO TICINO",
    "MASSINO VISCONTI",
    "MEINA",
    "MEZZOMERICO",
    "MIASINO",
    "MOMO",
    "NEBBIUNO",
    "NIBBIOLA",
    "NOVARA",
    "OLEGGIO",
    "OLEGGIO CASTELLO",
    "ORTA SAN GIULIO",
    "PARUZZARO",
    "PELLA",
    "PETTENASCO",
    "PISANO",
    "POGNO",
    "POMBIA",
    "PRATO SESIA",
    "RECETTO",
    "ROMAGNANO SESIA",
    "ROMENTINO",
    "SAN MAURIZIO D'OPAGLIO",
    "SAN NAZZARO SESIA",
    "SAN PIETRO MOSEZZO",
    "SILLAVENGO",
    "SIZZANO",
    "SORISO",
    "SOZZAGO",
    "SUNO",
    "TERDOBBIATE",
    "TORNACO",
    "TRECATE",
    "VAPRIO D'AGOGNA",
    "VARALLO POMBIA",
    "VERUNO",
    "VESPOLATE",
    "VICOLUNGO",
    "VINZAGLIO"
  ],
  "AG": [
    "AGRIGENTO",
    "ALESSANDRIA DELLA ROCCA",
    "ARAGONA",
    "BIVONA",
    "BURGIO",
    "CALAMONACI",
    "CALTABELLOTTA",
    "CAMASTRA",
    "CAMMARATA",
    "CAMPOBELLO DI LICATA",
    "CANICATTI'",
    "CASTELTERMINI",
    "CASTROFILIPPO",
    "CATTOLICA ERACLEA",
    "CIANCIANA",
    "COMITINI",
    "FAVARA",
    "GROTTE",
    "JOPPOLO GIANCAXIO",
    "LAMPEDUSA E LINOSA",
    "LICATA",
    "LUCCA SICULA",
    "MENFI",
    "MONTALLEGRO",
    "MONTEVAGO",
    "NARO",
    "PALMA DI MONTECHIARO",
    "PORTO EMPEDOCLE",
    "RACALMUTO",
    "RAFFADALI",
    "RAVANUSA",
    "REALMONTE",
    "RIBERA",
    "SAMBUCA DI SICILIA",
    "SAN BIAGIO PLATANI",
    "SAN GIOVANNI GEMINI",
    "SANTA ELISABETTA",
    "SANTA MARGHERITA DI BELICE",
    "SANT'ANGELO MUXARO",
    "SANTO STEFANO QUISQUINA",
    "SCIACCA",
    "SICULIANA",
    "VILLAFRANCA SICULA"
  ],
  "AN": [
    "AGUGLIANO",
    "ANCONA",
    "ARCEVIA",
    "BARBARA",
    "BELVEDERE OSTRENSE",
    "CAMERANO",
    "CAMERATA PICENA",
    "CASTEL COLONNA",
    "CASTELBELLINO",
    "CASTELFIDARDO",
    "CASTELLEONE DI SUASA",
    "CASTELPLANIO",
    "CERRETO D'ESI",
    "CHIARAVALLE",
    "CORINALDO",
    "CUPRAMONTANA",
    "FABRIANO",
    "FALCONARA MARITTIMA",
    "FILOTTRANO",
    "GENGA",
    "JESI",
    "LORETO",
    "MAIOLATI SPONTINI",
    "MERGO",
    "MONSANO",
    "MONTE ROBERTO",
    "MONTE SAN VITO",
    "MONTECAROTTO",
    "MONTEMARCIANO",
    "MONTERADO",
    "MORRO D'ALBA",
    "NUMANA",
    "OFFAGNA",
    "OSIMO",
    "OSTRA",
    "OSTRA VETERE",
    "POGGIO SAN MARCELLO",
    "POLVERIGI",
    "RIPE",
    "ROSORA",
    "SAN MARCELLO",
    "SAN PAOLO DI JESI",
    "SANTA MARIA NUOVA",
    "SASSOFERRATO",
    "SENIGALLIA",
    "SERRA DE' CONTI",
    "SERRA SAN QUIRICO",
    "SIROLO",
    "STAFFOLO",
    "TRECASTELLI"
  ],
  "VI": [
    "AGUGLIARO",
    "ALBETTONE",
    "ALONTE",
    "ALTAVILLA VICENTINA",
    "ALTISSIMO",
    "ARCUGNANO",
    "ARSIERO",
    "ARZIGNANO",
    "ASIAGO",
    "ASIGLIANO VENETO",
    "BARBARANO MOSSANO",
    "BARBARANO VICENTINO",
    "BASSANO DEL GRAPPA",
    "BOLZANO VICENTINO",
    "BREGANZE",
    "BRENDOLA",
    "BRESSANVIDO",
    "BROGLIANO",
    "CALDOGNO",
    "CALTRANO",
    "CALVENE",
    "CAMISANO VICENTINO",
    "CAMPIGLIA DEI BERICI",
    "CAMPOLONGO SUL BRENTA",
    "CARRE'",
    "CARTIGLIANO",
    "CASSOLA",
    "CASTEGNERO",
    "CASTELGOMBERTO",
    "CHIAMPO",
    "CHIUPPANO",
    "CISMON DEL GRAPPA",
    "COGOLLO DEL CENGIO",
    "COLCERESA",
    "CONCO",
    "CORNEDO VICENTINO",
    "COSTABISSARA",
    "CREAZZO",
    "CRESPADORO",
    "DUEVILLE",
    "ENEGO",
    "FARA VICENTINO",
    "FOZA",
    "GALLIO",
    "GAMBELLARA",
    "GAMBUGLIANO",
    "GRANCONA",
    "GRISIGNANO DI ZOCCO",
    "GRUMOLO DELLE ABBADESSE",
    "ISOLA VICENTINA",
    "LAGHI",
    "LASTEBASSE",
    "LONGARE",
    "LONIGO",
    "LUGO DI VICENZA",
    "LUSIANA",
    "LUSIANA CONCO",
    "MALO",
    "MARANO VICENTINO",
    "MAROSTICA",
    "MASON VICENTINO",
    "MOLVENA",
    "MONTE DI MALO",
    "MONTEBELLO VICENTINO",
    "MONTECCHIO MAGGIORE",
    "MONTECCHIO PRECALCINO",
    "MONTEGALDA",
    "MONTEGALDELLA",
    "MONTEVIALE",
    "MONTICELLO CONTE OTTO",
    "MONTORSO VICENTINO",
    "MOSSANO",
    "MUSSOLENTE",
    "NANTO",
    "NOGAROLE VICENTINO",
    "NOVE",
    "NOVENTA VICENTINA",
    "ORGIANO",
    "PEDEMONTE",
    "PIANEZZE",
    "PIOVENE ROCCHETTE",
    "POJANA MAGGIORE",
    "POSINA",
    "POVE DEL GRAPPA",
    "POZZOLEONE",
    "QUINTO VICENTINO",
    "RECOARO TERME",
    "ROANA",
    "ROMANO D'EZZELINO",
    "ROSA'",
    "ROSSANO VENETO",
    "ROTZO",
    "SALCEDO",
    "SAN GERMANO DEI BERICI",
    "SAN NAZARIO",
    "SAN PIETRO MUSSOLINO",
    "SAN VITO DI LEGUZZANO",
    "SANDRIGO",
    "SANTORSO",
    "SARCEDO",
    "SAREGO",
    "SCHIAVON",
    "SCHIO",
    "SOLAGNA",
    "SOSSANO",
    "SOVIZZO",
    "TEZZE SUL BRENTA",
    "THIENE",
    "TONEZZA DEL CIMONE",
    "TORREBELVICINO",
    "TORRI DI QUARTESOLO",
    "TRISSINO",
    "VAL LIONA",
    "VALBRENTA",
    "VALDAGNO",
    "VALDASTICO",
    "VALLI DEL PASUBIO",
    "VALSTAGNA",
    "VELO D'ASTICO",
    "VICENZA",
    "VILLAGA",
    "VILLAVERLA",
    "ZANE'",
    "ZERMEGHEDO",
    "ZOVENCEDO",
    "ZUGLIANO"
  ],
  "UD": [
    "AIELLO DEL FRIULI",
    "AMARO",
    "AMPEZZO",
    "AQUILEIA",
    "ARTA TERME",
    "ARTEGNA",
    "ATTIMIS",
    "BAGNARIA ARSA",
    "BASILIANO",
    "BERTIOLO",
    "BICINICCO",
    "BORDANO",
    "BUJA",
    "BUTTRIO",
    "CAMINO AL TAGLIAMENTO",
    "CAMPOFORMIDO",
    "CAMPOLONGO AL TORRE",
    "CAMPOLONGO TAPOGLIANO",
    "CARLINO",
    "CASSACCO",
    "CASTIONS DI STRADA",
    "CAVAZZO CARNICO",
    "CERCIVENTO",
    "CERVIGNANO DEL FRIULI",
    "CHIOPRIS VISCONE",
    "CHIUSAFORTE",
    "CIVIDALE DEL FRIULI",
    "CODROIPO",
    "COLLOREDO DI MONTE ALBANO",
    "COMEGLIANS",
    "CORNO DI ROSAZZO",
    "COSEANO",
    "DIGNANO",
    "DOGNA",
    "DRENCHIA",
    "ENEMONZO",
    "FAEDIS",
    "FAGAGNA",
    "FIUMICELLO",
    "FIUMICELLO VILLA VICENTINA",
    "FLAIBANO",
    "FORGARIA NEL FRIULI",
    "FORNI AVOLTRI",
    "FORNI DI SOPRA",
    "FORNI DI SOTTO",
    "GEMONA DEL FRIULI",
    "GONARS",
    "GRIMACCO",
    "LATISANA",
    "LAUCO",
    "LESTIZZA",
    "LIGNANO SABBIADORO",
    "LIGOSULLO",
    "LUSEVERA",
    "MAGNANO IN RIVIERA",
    "MAJANO",
    "MALBORGHETTO-VALBRUNA",
    "MANZANO",
    "MARANO LAGUNARE",
    "MARTIGNACCO",
    "MERETO DI TOMBA",
    "MOGGIO UDINESE",
    "MOIMACCO",
    "MONTENARS",
    "MORTEGLIANO",
    "MORUZZO",
    "MUZZANA DEL TURGNANO",
    "NIMIS",
    "OSOPPO",
    "OVARO",
    "PAGNACCO",
    "PALAZZOLO DELLO STELLA",
    "PALMANOVA",
    "PALUZZA",
    "PASIAN DI PRATO",
    "PAULARO",
    "PAVIA DI UDINE",
    "POCENIA",
    "PONTEBBA",
    "PORPETTO",
    "POVOLETTO",
    "POZZUOLO DEL FRIULI",
    "PRADAMANO",
    "PRATO CARNICO",
    "PRECENICCO",
    "PREMARIACCO",
    "PREONE",
    "PREPOTTO",
    "PULFERO",
    "RAGOGNA",
    "RAVASCLETTO",
    "RAVEO",
    "REANA DEL ROJALE",
    "REMANZACCO",
    "RESIA",
    "RESIUTTA",
    "RIGOLATO",
    "RIVE D'ARCANO",
    "RIVIGNANO",
    "RIVIGNANO TEOR",
    "RONCHIS",
    "RUDA",
    "SAN DANIELE DEL FRIULI",
    "SAN GIORGIO DI NOGARO",
    "SAN GIOVANNI AL NATISONE",
    "SAN LEONARDO",
    "SAN PIETRO AL NATISONE",
    "SAN VITO AL TORRE",
    "SAN VITO DI FAGAGNA",
    "SANTA MARIA LA LONGA",
    "SAPPADA",
    "SAURIS",
    "SAVOGNA",
    "SEDEGLIANO",
    "SOCCHIEVE",
    "STREGNA",
    "SUTRIO",
    "TAIPANA",
    "TALMASSONS",
    "TAPOGLIANO",
    "TARCENTO",
    "TARVISIO",
    "TAVAGNACCO",
    "TEOR",
    "TERZO DI AQUILEIA",
    "TOLMEZZO",
    "TORREANO",
    "TORVISCOSA",
    "TRASAGHIS",
    "TREPPO CARNICO",
    "TREPPO GRANDE",
    "TREPPO LIGOSULLO",
    "TRICESIMO",
    "TRIVIGNANO UDINESE",
    "UDINE",
    "VARMO",
    "VENZONE",
    "VERZEGNIS",
    "VILLA SANTINA",
    "VILLA VICENTINA",
    "VISCO",
    "ZUGLIO"
  ],
  "AV": [
    "AIELLO DEL SABATO",
    "ALTAVILLA IRPINA",
    "ANDRETTA",
    "AQUILONIA",
    "ARIANO IRPINO",
    "ATRIPALDA",
    "AVELLA",
    "AVELLINO",
    "BAGNOLI IRPINO",
    "BAIANO",
    "BISACCIA",
    "BONITO",
    "CAIRANO",
    "CALABRITTO",
    "CALITRI",
    "CANDIDA",
    "CAPOSELE",
    "CAPRIGLIA IRPINA",
    "CARIFE",
    "CASALBORE",
    "CASSANO IRPINO",
    "CASTEL BARONIA",
    "CASTELFRANCI",
    "CASTELVETERE SUL CALORE",
    "CERVINARA",
    "CESINALI",
    "CHIANCHE",
    "CHIUSANO DI SAN DOMENICO",
    "CONTRADA",
    "CONZA DELLA CAMPANIA",
    "DOMICELLA",
    "FLUMERI",
    "FONTANAROSA",
    "FORINO",
    "FRIGENTO",
    "GESUALDO",
    "GRECI",
    "GROTTAMINARDA",
    "GROTTOLELLA",
    "GUARDIA LOMBARDI",
    "LACEDONIA",
    "LAPIO",
    "LAURO",
    "LIONI",
    "LUOGOSANO",
    "MANOCALZATI",
    "MARZANO DI NOLA",
    "MELITO IRPINO",
    "MERCOGLIANO",
    "MIRABELLA ECLANO",
    "MONTAGUTO",
    "MONTECALVO IRPINO",
    "MONTEFALCIONE",
    "MONTEFORTE IRPINO",
    "MONTEFREDANE",
    "MONTEFUSCO",
    "MONTELLA",
    "MONTEMARANO",
    "MONTEMILETTO",
    "MONTEVERDE",
    "MONTORO",
    "MONTORO INFERIORE",
    "MONTORO SUPERIORE",
    "MORRA DE SANCTIS",
    "MOSCHIANO",
    "MUGNANO DEL CARDINALE",
    "NUSCO",
    "OSPEDALETTO D'ALPINOLO",
    "PAGO DEL VALLO DI LAURO",
    "PAROLISE",
    "PATERNOPOLI",
    "PETRURO IRPINO",
    "PIETRADEFUSI",
    "PIETRASTORNINA",
    "PRATA DI PRINCIPATO ULTRA",
    "PRATOLA SERRA",
    "QUADRELLE",
    "QUINDICI",
    "ROCCA SAN FELICE",
    "ROCCABASCERANA",
    "ROTONDI",
    "SALZA IRPINA",
    "SAN MANGO SUL CALORE",
    "SAN MARTINO VALLE CAUDINA",
    "SAN MICHELE DI SERINO",
    "SAN NICOLA BARONIA",
    "SAN POTITO ULTRA",
    "SAN SOSSIO BARONIA",
    "SANTA LUCIA DI SERINO",
    "SANTA PAOLINA",
    "SANT'ANDREA DI CONZA",
    "SANT'ANGELO A SCALA",
    "SANT'ANGELO ALL'ESCA",
    "SANT'ANGELO DEI LOMBARDI",
    "SANTO STEFANO DEL SOLE",
    "SAVIGNANO IRPINO",
    "SCAMPITELLA",
    "SENERCHIA",
    "SERINO",
    "SIRIGNANO",
    "SOLOFRA",
    "SORBO SERPICO",
    "SPERONE",
    "STURNO",
    "SUMMONTE",
    "TAURANO",
    "TAURASI",
    "TEORA",
    "TORELLA DEI LOMBARDI",
    "TORRE LE NOCELLE",
    "TORRIONI",
    "TREVICO",
    "TUFO",
    "VALLATA",
    "VALLESACCARDA",
    "VENTICANO",
    "VILLAMAINA",
    "VILLANOVA DEL BATTISTA",
    "VOLTURARA IRPINA",
    "ZUNGOLI"
  ],
  "CE": [
    "AILANO",
    "ALIFE",
    "ALVIGNANO",
    "ARIENZO",
    "AVERSA",
    "BAIA E LATINA",
    "BELLONA",
    "CAIANELLO",
    "CAIAZZO",
    "CALVI RISORTA",
    "CAMIGLIANO",
    "CANCELLO ED ARNONE",
    "CAPODRISE",
    "CAPRIATI A VOLTURNO",
    "CAPUA",
    "CARINARO",
    "CARINOLA",
    "CASAGIOVE",
    "CASAL DI PRINCIPE",
    "CASALUCE",
    "CASAPESENNA",
    "CASAPULLA",
    "CASERTA",
    "CASTEL CAMPAGNANO",
    "CASTEL DI SASSO",
    "CASTEL MORRONE",
    "CASTEL VOLTURNO",
    "CASTELLO DEL MATESE",
    "CELLOLE",
    "CERVINO",
    "CESA",
    "CIORLANO",
    "CONCA DELLA CAMPANIA",
    "CURTI",
    "DRAGONI",
    "FALCIANO DEL MASSICO",
    "FONTEGRECA",
    "FORMICOLA",
    "FRANCOLISE",
    "FRIGNANO",
    "GALLO MATESE",
    "GALLUCCIO",
    "GIANO VETUSTO",
    "GIOIA SANNITICA",
    "GRAZZANISE",
    "GRICIGNANO DI AVERSA",
    "LETINO",
    "LIBERI",
    "LUSCIANO",
    "MACERATA CAMPANIA",
    "MADDALONI",
    "MARCIANISE",
    "MARZANO APPIO",
    "MIGNANO MONTE LUNGO",
    "MONDRAGONE",
    "ORTA DI ATELLA",
    "PARETE",
    "PASTORANO",
    "PIANA DI MONTE VERNA",
    "PIEDIMONTE MATESE",
    "PIETRAMELARA",
    "PIETRAVAIRANO",
    "PIGNATARO MAGGIORE",
    "PONTELATONE",
    "PORTICO DI CASERTA",
    "PRATA SANNITA",
    "PRATELLA",
    "PRESENZANO",
    "RAVISCANINA",
    "RECALE",
    "RIARDO",
    "ROCCA D'EVANDRO",
    "ROCCAMONFINA",
    "ROCCAROMANA",
    "ROCCHETTA E CROCE",
    "RUVIANO",
    "SAN CIPRIANO D'AVERSA",
    "SAN FELICE A CANCELLO",
    "SAN GREGORIO MATESE",
    "SAN MARCELLINO",
    "SAN MARCO EVANGELISTA",
    "SAN NICOLA LA STRADA",
    "SAN PIETRO INFINE",
    "SAN POTITO SANNITICO",
    "SAN PRISCO",
    "SAN TAMMARO",
    "SANTA MARIA A VICO",
    "SANTA MARIA CAPUA VETERE",
    "SANTA MARIA LA FOSSA",
    "SANT'ANGELO D'ALIFE",
    "SANT'ARPINO",
    "SESSA AURUNCA",
    "SPARANISE",
    "SUCCIVO",
    "TEANO",
    "TEVEROLA",
    "TORA E PICCILLI",
    "TRENTOLA DUCENTA",
    "VAIRANO PATENORA",
    "VALLE AGRICOLA",
    "VALLE DI MADDALONI",
    "VILLA DI BRIANO",
    "VILLA LITERNO",
    "VITULAZIO"
  ],
  "BI": [
    "AILOCHE",
    "ANDORNO MICCA",
    "BENNA",
    "BIELLA",
    "BIOGLIO",
    "BORRIANA",
    "BRUSNENGO",
    "CALLABIANA",
    "CAMANDONA",
    "CAMBURZANO",
    "CAMPIGLIA CERVO",
    "CANDELO",
    "CAPRILE",
    "CASAPINTA",
    "CASTELLETTO CERVO",
    "CAVAGLIA'",
    "CERRETO CASTELLO",
    "CERRIONE",
    "COGGIOLA",
    "COSSATO",
    "CREVACUORE",
    "CROSA",
    "CURINO",
    "DONATO",
    "DORZANO",
    "GAGLIANICO",
    "GIFFLENGA",
    "GRAGLIA",
    "LESSONA",
    "MAGNANO",
    "MASSAZZA",
    "MASSERANO",
    "MEZZANA MORTIGLIENGO",
    "MIAGLIANO",
    "MONGRANDO",
    "MOSSO",
    "MOTTALCIATA",
    "MUZZANO",
    "NETRO",
    "OCCHIEPPO INFERIORE",
    "OCCHIEPPO SUPERIORE",
    "PETTINENGO",
    "PIATTO",
    "PIEDICAVALLO",
    "POLLONE",
    "PONDERANO",
    "PORTULA",
    "PRALUNGO",
    "PRAY",
    "QUAREGNA",
    "QUAREGNA CERRETO",
    "QUITTENGO",
    "RONCO BIELLESE",
    "ROPPOLO",
    "ROSAZZA",
    "SAGLIANO MICCA",
    "SALA BIELLESE",
    "SALUSSOLA",
    "SAN PAOLO CERVO",
    "SANDIGLIANO",
    "SELVE MARCONE",
    "SOPRANA",
    "SORDEVOLO",
    "SOSTEGNO",
    "STRONA",
    "TAVIGLIANO",
    "TERNENGO",
    "TOLLEGNO",
    "TORRAZZO",
    "TRIVERO",
    "VALDENGO",
    "VALDILANA",
    "VALLANZENGO",
    "VALLE MOSSO",
    "VALLE SAN NICOLAO",
    "VEGLIO",
    "VERRONE",
    "VIGLIANO BIELLESE",
    "VILLA DEL BOSCO",
    "VILLANOVA BIELLESE",
    "VIVERONE",
    "ZIMONE",
    "ZUBIENA",
    "ZUMAGLIA"
  ],
  "BN": [
    "AIROLA",
    "AMOROSI",
    "APICE",
    "APOLLOSA",
    "ARPAIA",
    "ARPAISE",
    "BASELICE",
    "BENEVENTO",
    "BONEA",
    "BUCCIANO",
    "BUONALBERGO",
    "CALVI",
    "CAMPOLATTARO",
    "CAMPOLI DEL MONTE TABURNO",
    "CASALDUNI",
    "CASTELFRANCO IN MISCANO",
    "CASTELPAGANO",
    "CASTELPOTO",
    "CASTELVENERE",
    "CASTELVETERE IN VAL FORTORE",
    "CAUTANO",
    "CEPPALONI",
    "CERRETO SANNITA",
    "CIRCELLO",
    "COLLE SANNITA",
    "CUSANO MUTRI",
    "DUGENTA",
    "DURAZZANO",
    "FAICCHIO",
    "FOGLIANISE",
    "FOIANO DI VAL FORTORE",
    "FORCHIA",
    "FRAGNETO L'ABATE",
    "FRAGNETO MONFORTE",
    "FRASSO TELESINO",
    "GINESTRA DEGLI SCHIAVONI",
    "GUARDIA SANFRAMONDI",
    "LIMATOLA",
    "MELIZZANO",
    "MOIANO",
    "MOLINARA",
    "MONTEFALCONE DI VAL FORTORE",
    "MONTESARCHIO",
    "MORCONE",
    "PADULI",
    "PAGO VEIANO",
    "PANNARANO",
    "PAOLISI",
    "PAUPISI",
    "PESCO SANNITA",
    "PIETRAROJA",
    "PIETRELCINA",
    "PONTE",
    "PONTELANDOLFO",
    "PUGLIANELLO",
    "REINO",
    "SAN BARTOLOMEO IN GALDO",
    "SAN GIORGIO DEL SANNIO",
    "SAN GIORGIO LA MOLARA",
    "SAN LEUCIO DEL SANNIO",
    "SAN LORENZELLO",
    "SAN LORENZO MAGGIORE",
    "SAN LUPO",
    "SAN MARCO DEI CAVOTI",
    "SAN MARTINO SANNITA",
    "SAN NAZZARO",
    "SAN NICOLA MANFREDI",
    "SAN SALVATORE TELESINO",
    "SANTA CROCE DEL SANNIO",
    "SANT'AGATA DE' GOTI",
    "SANT'ANGELO A CUPOLO",
    "SANT'ARCANGELO TRIMONTE",
    "SASSINORO",
    "SOLOPACA",
    "TELESE TERME",
    "TOCCO CAUDIO",
    "TORRECUSO",
    "VITULANO"
  ],
  "IM": [
    "AIROLE",
    "APRICALE",
    "AQUILA D'ARROSCIA",
    "ARMO",
    "AURIGO",
    "BADALUCCO",
    "BAIARDO",
    "BORDIGHERA",
    "BORGHETTO D'ARROSCIA",
    "BORGOMARO",
    "CAMPOROSSO",
    "CARAVONICA",
    "CARPASIO",
    "CASTEL VITTORIO",
    "CASTELLARO",
    "CERIANA",
    "CERVO",
    "CESIO",
    "CHIUSANICO",
    "CHIUSAVECCHIA",
    "CIPRESSA",
    "CIVEZZA",
    "COSIO D'ARROSCIA",
    "COSTARAINERA",
    "DIANO ARENTINO",
    "DIANO CASTELLO",
    "DIANO MARINA",
    "DIANO SAN PIETRO",
    "DOLCEACQUA",
    "DOLCEDO",
    "IMPERIA",
    "ISOLABONA",
    "LUCINASCO",
    "MENDATICA",
    "MOLINI DI TRIORA",
    "MONTALTO CARPASIO",
    "MONTALTO LIGURE",
    "MONTEGROSSO PIAN LATTE",
    "OLIVETTA SAN MICHELE",
    "OSPEDALETTI",
    "PERINALDO",
    "PIETRABRUNA",
    "PIEVE DI TECO",
    "PIGNA",
    "POMPEIANA",
    "PONTEDASSIO",
    "PORNASSIO",
    "PRELA'",
    "RANZO",
    "REZZO",
    "RIVA LIGURE",
    "ROCCHETTA NERVINA",
    "SAN BARTOLOMEO AL MARE",
    "SAN BIAGIO DELLA CIMA",
    "SAN LORENZO AL MARE",
    "SANREMO",
    "SANTO STEFANO AL MARE",
    "SEBORGA",
    "SOLDANO",
    "TAGGIA",
    "TERZORIO",
    "TRIORA",
    "VALLEBONA",
    "VALLECROSIA",
    "VASIA",
    "VENTIMIGLIA",
    "VESSALICO",
    "VILLA FARALDI"
  ],
  "TN": [
    "ALA",
    "ALBIANO",
    "ALDENO",
    "ALTAVALLE",
    "ALTOPIANO DELLA VIGOLANA",
    "AMBLAR",
    "AMBLAR-DON",
    "ANDALO",
    "ARCO",
    "AVIO",
    "BASELGA DI PINE'",
    "BEDOLLO",
    "BERSONE",
    "BESENELLO",
    "BEZZECCA",
    "BIENO",
    "BLEGGIO INFERIORE",
    "BLEGGIO SUPERIORE",
    "BOCENAGO",
    "BOLBENO",
    "BONDO",
    "BONDONE",
    "BORGO CHIESE",
    "BORGO D'ANAUNIA",
    "BORGO LARES",
    "BORGO VALSUGANA",
    "BOSENTINO",
    "BREGUZZO",
    "BRENTONICO",
    "BRESIMO",
    "BREZ",
    "BRIONE",
    "CADERZONE TERME",
    "CAGNO'",
    "CALAVINO",
    "CALCERANICA AL LAGO",
    "CALDES",
    "CALDONAZZO",
    "CALLIANO",
    "CAMPITELLO DI FASSA",
    "CAMPODENNO",
    "CANAL SAN BOVO",
    "CANAZEI",
    "CAPRIANA",
    "CARANO",
    "CARISOLO",
    "CARZANO",
    "CASTEL CONDINO",
    "CASTEL IVANO",
    "CASTELFONDO",
    "CASTELLO TESINO",
    "CASTELLO-MOLINA DI FIEMME",
    "CASTELNUOVO",
    "CAVALESE",
    "CAVARENO",
    "CAVEDAGO",
    "CAVEDINE",
    "CAVIZZANA",
    "CEMBRA",
    "CEMBRA LISIGNAGO",
    "CENTA SAN NICOLO'",
    "CIMEGO",
    "CIMONE",
    "CINTE TESINO",
    "CIS",
    "CIVEZZANO",
    "CLES",
    "CLOZ",
    "COMANO TERME",
    "COMMEZZADURA",
    "CONCEI",
    "CONDINO",
    "CONTA'",
    "COREDO",
    "CROVIANA",
    "CUNEVO",
    "DAIANO",
    "DAMBEL",
    "DAONE",
    "DARE'",
    "DENNO",
    "DIMARO",
    "DIMARO FOLGARIDA",
    "DON",
    "DORSINO",
    "DRENA",
    "DRO",
    "FAEDO",
    "FAI DELLA PAGANELLA",
    "FAVER",
    "FIAVE'",
    "FIERA DI PRIMIERO",
    "FIEROZZO",
    "FLAVON",
    "FOLGARIA",
    "FONDO",
    "FORNACE",
    "FRASSILONGO",
    "GARNIGA TERME",
    "GIOVO",
    "GIUSTINO",
    "GRAUNO",
    "GRIGNO",
    "GRUMES",
    "IMER",
    "ISERA",
    "IVANO FRACENA",
    "LARDARO",
    "LASINO",
    "LAVARONE",
    "LAVIS",
    "LEDRO",
    "LEVICO TERME",
    "LISIGNAGO",
    "LIVO",
    "LOMASO",
    "LONA LASES",
    "LUSERNA",
    "MADRUZZO",
    "MALE'",
    "MALOSCO",
    "MASSIMENO",
    "MAZZIN",
    "MEZZANA",
    "MEZZANO",
    "MEZZOCORONA",
    "MEZZOLOMBARDO",
    "MOENA",
    "MOLINA DI LEDRO",
    "MOLVENO",
    "MONCLASSICO",
    "MONTAGNE",
    "MORI",
    "NAGO-TORBOLE",
    "NANNO",
    "NAVE SAN ROCCO",
    "NOGAREDO",
    "NOMI",
    "NOVALEDO",
    "NOVELLA",
    "OSPEDALETTO",
    "OSSANA",
    "PADERGNONE",
    "PALU' DEL FERSINA",
    "PANCHIA'",
    "PEIO",
    "PELLIZZANO",
    "PELUGO",
    "PERGINE VALSUGANA",
    "PIEVE DI BONO",
    "PIEVE DI BONO-PREZZO",
    "PIEVE DI LEDRO",
    "PIEVE TESINO",
    "PINZOLO",
    "POMAROLO",
    "PORTE DI RENDENA",
    "POZZA DI FASSA",
    "PRASO",
    "PREDAIA",
    "PREDAZZO",
    "PREORE",
    "PREZZO",
    "PRIMIERO SAN MARTINO DI CASTROZZA",
    "RABBI",
    "RAGOLI",
    "REVO'",
    "RIVA DEL GARDA",
    "ROMALLO",
    "ROMENO",
    "RONCEGNO TERME",
    "RONCHI VALSUGANA",
    "RONCONE",
    "RONZO-CHIENIS",
    "RONZONE",
    "ROVERE' DELLA LUNA",
    "ROVERETO",
    "RUFFRE'-MENDOLA",
    "RUMO",
    "SAGRON MIS",
    "SAMONE",
    "SAN GIOVANNI DI FASSA",
    "SAN LORENZO DORSINO",
    "SAN LORENZO IN BANALE",
    "SAN MICHELE ALL'ADIGE",
    "SANT'ORSOLA TERME",
    "SANZENO",
    "SARNONICO",
    "SCURELLE",
    "SEGONZANO",
    "SELLA GIUDICARIE",
    "SFRUZ",
    "SIROR",
    "SMARANO",
    "SORAGA DI FASSA",
    "SOVER",
    "SPERA",
    "SPIAZZO",
    "SPORMAGGIORE",
    "SPORMINORE",
    "STENICO",
    "STORO",
    "STREMBO",
    "STRIGNO",
    "TAIO",
    "TASSULLO",
    "TELVE",
    "TELVE DI SOPRA",
    "TENNA",
    "TENNO",
    "TERLAGO",
    "TERRAGNOLO",
    "TERRE D'ADIGE",
    "TERRES",
    "TERZOLAS",
    "TESERO",
    "TIARNO DI SOPRA",
    "TIARNO DI SOTTO",
    "TIONE DI TRENTO",
    "TON",
    "TONADICO",
    "TORCEGNO",
    "TRAMBILENO",
    "TRANSACQUA",
    "TRE VILLE",
    "TRENTO",
    "TRES",
    "TUENNO",
    "VALDA",
    "VALDAONE",
    "VALFLORIANA",
    "VALLARSA",
    "VALLELAGHI",
    "VARENA",
    "VATTARO",
    "VERMIGLIO",
    "VERVO'",
    "VEZZANO",
    "VIGNOLA FALESINA",
    "VIGO DI FASSA",
    "VIGO RENDENA",
    "VIGOLO VATTARO",
    "VILLA AGNEDO",
    "VILLA LAGARINA",
    "VILLA RENDENA",
    "VILLE D'ANAUNIA",
    "VILLE DI FIEMME",
    "VOLANO",
    "ZAMBANA",
    "ZIANO DI FIEMME",
    "ZUCLO"
  ],
  "PV": [
    "ALAGNA",
    "ALBAREDO ARNABOLDI",
    "ALBONESE",
    "ALBUZZANO",
    "ARENA PO",
    "BADIA PAVESE",
    "BAGNARIA",
    "BARBIANELLO",
    "BASCAPE'",
    "BASTIDA DE' DOSSI",
    "BASTIDA PANCARANA",
    "BATTUDA",
    "BELGIOIOSO",
    "BEREGUARDO",
    "BORGARELLO",
    "BORGO PRIOLO",
    "BORGO SAN SIRO",
    "BORGORATTO MORMOROLO",
    "BORNASCO",
    "BOSNASCO",
    "BRALLO DI PREGOLA",
    "BREME",
    "BRESSANA BOTTARONE",
    "BRONI",
    "CALVIGNANO",
    "CAMPOSPINOSO",
    "CANDIA LOMELLINA",
    "CANEVINO",
    "CANNETO PAVESE",
    "CARBONARA AL TICINO",
    "CASANOVA LONATI",
    "CASATISMA",
    "CASEI GEROLA",
    "CASORATE PRIMO",
    "CASSOLNOVO",
    "CASTANA",
    "CASTEGGIO",
    "CASTELLETTO DI BRANDUZZO",
    "CASTELLO D'AGOGNA",
    "CASTELNOVETTO",
    "CAVA MANARA",
    "CECIMA",
    "CERANOVA",
    "CERETTO LOMELLINA",
    "CERGNAGO",
    "CERTOSA DI PAVIA",
    "CERVESINA",
    "CHIGNOLO PO",
    "CIGOGNOLA",
    "CILAVEGNA",
    "CODEVILLA",
    "COLLI VERDI",
    "CONFIENZA",
    "COPIANO",
    "CORANA",
    "CORNALE",
    "CORNALE E BASTIDA",
    "CORTEOLONA",
    "CORTEOLONA E GENZONE",
    "CORVINO SAN QUIRICO",
    "COSTA DE' NOBILI",
    "COZZO",
    "CURA CARPIGNANO",
    "DORNO",
    "FERRERA ERBOGNONE",
    "FILIGHERA",
    "FORTUNAGO",
    "FRASCAROLO",
    "GALLIAVOLA",
    "GAMBARANA",
    "GAMBOLO'",
    "GARLASCO",
    "GENZONE",
    "GERENZAGO",
    "GIUSSAGO",
    "GODIASCO",
    "GOLFERENZO",
    "GRAVELLONA LOMELLINA",
    "GROPELLO CAIROLI",
    "INVERNO E MONTELEONE",
    "LANDRIANO",
    "LANGOSCO",
    "LARDIRAGO",
    "LINAROLO",
    "LIRIO",
    "LOMELLO",
    "LUNGAVILLA",
    "MAGHERNO",
    "MARCIGNAGO",
    "MARZANO",
    "MEDE",
    "MENCONICO",
    "MEZZANA BIGLI",
    "MEZZANA RABATTONE",
    "MEZZANINO",
    "MIRADOLO TERME",
    "MONTALTO PAVESE",
    "MONTEBELLO DELLA BATTAGLIA",
    "MONTECALVO VERSIGGIA",
    "MONTESCANO",
    "MONTESEGALE",
    "MONTICELLI PAVESE",
    "MONTU' BECCARIA",
    "MORNICO LOSANA",
    "MORTARA",
    "NICORVO",
    "OLEVANO DI LOMELLINA",
    "OLIVA GESSI",
    "OTTOBIANO",
    "PALESTRO",
    "PANCARANA",
    "PARONA",
    "PAVIA",
    "PIETRA DE' GIORGI",
    "PIEVE ALBIGNOLA",
    "PIEVE DEL CAIRO",
    "PIEVE PORTO MORONE",
    "PINAROLO PO",
    "PIZZALE",
    "PONTE NIZZA",
    "PORTALBERA",
    "REA",
    "REDAVALLE",
    "RETORBIDO",
    "RIVANAZZANO TERME",
    "ROBBIO",
    "ROBECCO PAVESE",
    "ROCCA DE' GIORGI",
    "ROCCA SUSELLA",
    "ROGNANO",
    "ROMAGNESE",
    "RONCARO",
    "ROSASCO",
    "ROVESCALA",
    "RUINO",
    "SAN CIPRIANO PO",
    "SAN DAMIANO AL COLLE",
    "SAN GENESIO ED UNITI",
    "SAN GIORGIO DI LOMELLINA",
    "SAN MARTINO SICCOMARIO",
    "SAN ZENONE AL PO",
    "SANNAZZARO DE' BURGONDI",
    "SANTA CRISTINA E BISSONE",
    "SANTA GIULETTA",
    "SANTA MARGHERITA DI STAFFORA",
    "SANTA MARIA DELLA VERSA",
    "SANT'ALESSIO CON VIALONE",
    "SANT'ANGELO LOMELLINA",
    "SARTIRANA LOMELLINA",
    "SCALDASOLE",
    "SEMIANA",
    "SILVANO PIETRA",
    "SIZIANO",
    "SOMMO",
    "SPESSA",
    "STRADELLA",
    "SUARDI",
    "TORRAZZA COSTE",
    "TORRE BERETTI E CASTELLARO",
    "TORRE D'ARESE",
    "TORRE DE' NEGRI",
    "TORRE D'ISOLA",
    "TORREVECCHIA PIA",
    "TORRICELLA VERZATE",
    "TRAVACO' SICCOMARIO",
    "TRIVOLZIO",
    "TROMELLO",
    "TROVO",
    "VAL DI NIZZA",
    "VALEGGIO",
    "VALLE LOMELLINA",
    "VALLE SALIMBENE",
    "VALVERDE",
    "VARZI",
    "VELEZZO LOMELLINA",
    "VELLEZZO BELLINI",
    "VERRETTO",
    "VERRUA PO",
    "VIDIGULFO",
    "VIGEVANO",
    "VILLA BISCOSSI",
    "VILLANOVA D'ARDENGHI",
    "VILLANTERIO",
    "VISTARINO",
    "VOGHERA",
    "VOLPARA",
    "ZAVATTARELLO",
    "ZECCONE",
    "ZEME",
    "ZENEVREDO",
    "ZERBO",
    "ZERBOLO'",
    "ZINASCO"
  ],
  "VC": [
    "ALAGNA VALSESIA",
    "ALBANO VERCELLESE",
    "ALICE CASTELLO",
    "ALTO SERMENZA",
    "ARBORIO",
    "ASIGLIANO VERCELLESE",
    "BALMUCCIA",
    "BALOCCO",
    "BIANZE'",
    "BOCCIOLETO",
    "BORGO D'ALE",
    "BORGO VERCELLI",
    "BORGOSESIA",
    "BREIA",
    "BURONZO",
    "CAMPERTOGNO",
    "CARCOFORO",
    "CARESANA",
    "CARESANABLOT",
    "CARISIO",
    "CASANOVA ELVO",
    "CELLIO",
    "CELLIO CON BREIA",
    "CERVATTO",
    "CIGLIANO",
    "CIVIASCO",
    "COLLOBIANO",
    "COSTANZANA",
    "CRAVAGLIANA",
    "CRESCENTINO",
    "CROVA",
    "DESANA",
    "FOBELLO",
    "FONTANETTO PO",
    "FORMIGLIANA",
    "GATTINARA",
    "GHISLARENGO",
    "GREGGIO",
    "GUARDABOSONE",
    "LAMPORO",
    "LENTA",
    "LIGNANA",
    "LIVORNO FERRARIS",
    "LOZZOLO",
    "MOLLIA",
    "MONCRIVELLO",
    "MOTTA DE' CONTI",
    "OLCENENGO",
    "OLDENICO",
    "PALAZZOLO VERCELLESE",
    "PERTENGO",
    "PEZZANA",
    "PILA",
    "PIODE",
    "POSTUA",
    "PRAROLO",
    "QUARONA",
    "QUINTO VERCELLESE",
    "RASSA",
    "RIMA SAN GIUSEPPE",
    "RIMASCO",
    "RIMELLA",
    "RIVA VALDOBBIA",
    "RIVE",
    "ROASIO",
    "RONSECCO",
    "ROSSA",
    "ROVASENDA",
    "SABBIA",
    "SALASCO",
    "SALI VERCELLESE",
    "SALUGGIA",
    "SAN GERMANO VERCELLESE",
    "SAN GIACOMO VERCELLESE",
    "SANTHIA'",
    "SCOPA",
    "SCOPELLO",
    "SERRAVALLE SESIA",
    "STROPPIANA",
    "TRICERRO",
    "TRINO",
    "TRONZANO VERCELLESE",
    "VALDUGGIA",
    "VARALLO",
    "VERCELLI",
    "VILLARBOIT",
    "VILLATA",
    "VOCCA"
  ],
  "SV": [
    "ALASSIO",
    "ALBENGA",
    "ALBISOLA SUPERIORE",
    "ALBISSOLA MARINA",
    "ALTARE",
    "ANDORA",
    "ARNASCO",
    "BALESTRINO",
    "BARDINETO",
    "BERGEGGI",
    "BOISSANO",
    "BORGHETTO SANTO SPIRITO",
    "BORGIO VEREZZI",
    "BORMIDA",
    "CAIRO MONTENOTTE",
    "CALICE LIGURE",
    "CALIZZANO",
    "CARCARE",
    "CASANOVA LERRONE",
    "CASTELBIANCO",
    "CASTELVECCHIO DI ROCCA BARBENA",
    "CELLE LIGURE",
    "CENGIO",
    "CERIALE",
    "CISANO SUL NEVA",
    "COSSERIA",
    "DEGO",
    "ERLI",
    "FINALE LIGURE",
    "GARLENDA",
    "GIUSTENICE",
    "GIUSVALLA",
    "LAIGUEGLIA",
    "LOANO",
    "MAGLIOLO",
    "MALLARE",
    "MASSIMINO",
    "MILLESIMO",
    "MIOGLIA",
    "MURIALDO",
    "NASINO",
    "NOLI",
    "ONZO",
    "ORCO FEGLINO",
    "ORTOVERO",
    "OSIGLIA",
    "PALLARE",
    "PIANA CRIXIA",
    "PIETRA LIGURE",
    "PLODIO",
    "PONTINVREA",
    "QUILIANO",
    "RIALTO",
    "ROCCAVIGNALE",
    "SASSELLO",
    "SAVONA",
    "SPOTORNO",
    "STELLA",
    "STELLANELLO",
    "TESTICO",
    "TOIRANO",
    "TOVO SAN GIACOMO",
    "URBE",
    "VADO LIGURE",
    "VARAZZE",
    "VENDONE",
    "VEZZI PORTIO",
    "VILLANOVA D'ALBENGA",
    "ZUCCARELLO"
  ],
  "TE": [
    "ALBA ADRIATICA",
    "ANCARANO",
    "ARSITA",
    "ATRI",
    "BASCIANO",
    "BELLANTE",
    "BISENTI",
    "CAMPLI",
    "CANZANO",
    "CASTEL CASTAGNA",
    "CASTELLALTO",
    "CASTELLI",
    "CASTIGLIONE MESSER RAIMONDO",
    "CASTILENTI",
    "CELLINO ATTANASIO",
    "CERMIGNANO",
    "CIVITELLA DEL TRONTO",
    "COLLEDARA",
    "COLONNELLA",
    "CONTROGUERRA",
    "CORROPOLI",
    "CORTINO",
    "CROGNALETO",
    "FANO ADRIANO",
    "GIULIANOVA",
    "ISOLA DEL GRAN SASSO D'ITALIA",
    "MARTINSICURO",
    "MONTEFINO",
    "MONTORIO AL VOMANO",
    "MORRO D'ORO",
    "MOSCIANO SANT'ANGELO",
    "NERETO",
    "NOTARESCO",
    "PENNA SANT'ANDREA",
    "PIETRACAMELA",
    "PINETO",
    "ROCCA SANTA MARIA",
    "ROSETO DEGLI ABRUZZI",
    "SANT'EGIDIO ALLA VIBRATA",
    "SANT'OMERO",
    "SILVI",
    "TERAMO",
    "TORANO NUOVO",
    "TORRICELLA SICURA",
    "TORTORETO",
    "TOSSICIA",
    "VALLE CASTELLANA"
  ],
  "SO": [
    "ALBAREDO PER SAN MARCO",
    "ALBOSAGGIA",
    "ANDALO VALTELLINO",
    "APRICA",
    "ARDENNO",
    "BEMA",
    "BERBENNO DI VALTELLINA",
    "BIANZONE",
    "BORMIO",
    "BUGLIO IN MONTE",
    "CAIOLO",
    "CAMPODOLCINO",
    "CASPOGGIO",
    "CASTELLO DELL'ACQUA",
    "CASTIONE ANDEVENNO",
    "CEDRASCO",
    "CERCINO",
    "CHIAVENNA",
    "CHIESA IN VALMALENCO",
    "CHIURO",
    "CINO",
    "CIVO",
    "COLORINA",
    "COSIO VALTELLINO",
    "DAZIO",
    "DELEBIO",
    "DUBINO",
    "FAEDO VALTELLINO",
    "FORCOLA",
    "FUSINE",
    "GEROLA ALTA",
    "GORDONA",
    "GROSIO",
    "GROSOTTO",
    "LANZADA",
    "LIVIGNO",
    "LOVERO",
    "MADESIMO",
    "MANTELLO",
    "MAZZO DI VALTELLINA",
    "MELLO",
    "MENAROLA",
    "MESE",
    "MONTAGNA IN VALTELLINA",
    "MORBEGNO",
    "NOVATE MEZZOLA",
    "PEDESINA",
    "PIANTEDO",
    "PIATEDA",
    "PIURO",
    "POGGIRIDENTI",
    "PONTE IN VALTELLINA",
    "POSTALESIO",
    "PRATA CAMPORTACCIO",
    "RASURA",
    "ROGOLO",
    "SAMOLACO",
    "SAN GIACOMO FILIPPO",
    "SERNIO",
    "SONDALO",
    "SONDRIO",
    "SPRIANA",
    "TALAMONA",
    "TARTANO",
    "TEGLIO",
    "TIRANO",
    "TORRE DI SANTA MARIA",
    "TOVO DI SANT'AGATA",
    "TRAONA",
    "TRESIVIO",
    "VAL MASINO",
    "VALDIDENTRO",
    "VALDISOTTO",
    "VALFURVA",
    "VERCEIA",
    "VERVIO",
    "VILLA DI CHIAVENNA",
    "VILLA DI TIRANO"
  ],
  "PR": [
    "ALBARETO",
    "BARDI",
    "BEDONIA",
    "BERCETO",
    "BORE",
    "BORGO VAL DI TARO",
    "BUSSETO",
    "CALESTANO",
    "COLLECCHIO",
    "COLORNO",
    "COMPIANO",
    "CORNIGLIO",
    "FELINO",
    "FIDENZA",
    "FONTANELLATO",
    "FONTEVIVO",
    "FORNOVO DI TARO",
    "LANGHIRANO",
    "LESIGNANO DE' BAGNI",
    "MEDESANO",
    "MEZZANI",
    "MONCHIO DELLE CORTI",
    "MONTECHIARUGOLO",
    "NEVIANO DEGLI ARDUINI",
    "NOCETO",
    "PALANZANO",
    "PARMA",
    "PELLEGRINO PARMENSE",
    "POLESINE PARMENSE",
    "POLESINE ZIBELLO",
    "ROCCABIANCA",
    "SALA BAGANZA",
    "SALSOMAGGIORE TERME",
    "SAN SECONDO PARMENSE",
    "SISSA",
    "SISSA TRECASALI",
    "SOLIGNANO",
    "SORAGNA",
    "SORBOLO",
    "SORBOLO MEZZANI",
    "TERENZO",
    "TIZZANO VAL PARMA",
    "TORNOLO",
    "TORRILE",
    "TRAVERSETOLO",
    "TRECASALI",
    "VALMOZZOLA",
    "VARANO DE' MELEGARI",
    "VARSI",
    "ZIBELLO"
  ],
  "CO": [
    "ALBAVILLA",
    "ALBESE CON CASSANO",
    "ALBIOLO",
    "ALSERIO",
    "ALTA VALLE INTELVI",
    "ALZATE BRIANZA",
    "ANZANO DEL PARCO",
    "APPIANO GENTILE",
    "ARGEGNO",
    "AROSIO",
    "ASSO",
    "BARNI",
    "BELLAGIO",
    "BENE LARIO",
    "BEREGAZZO CON FIGLIARO",
    "BINAGO",
    "BIZZARONE",
    "BLESSAGNO",
    "BLEVIO",
    "BREGNANO",
    "BRENNA",
    "BRIENNO",
    "BRUNATE",
    "BULGAROGRASSO",
    "CABIATE",
    "CADORAGO",
    "CAGLIO",
    "CAGNO",
    "CAMPIONE D'ITALIA",
    "CANTU'",
    "CANZO",
    "CAPIAGO INTIMIANO",
    "CARATE URIO",
    "CARBONATE",
    "CARIMATE",
    "CARLAZZO",
    "CARUGO",
    "CASASCO D'INTELVI",
    "CASLINO D'ERBA",
    "CASNATE CON BERNATE",
    "CASSINA RIZZARDI",
    "CASTELMARTE",
    "CASTELNUOVO BOZZENTE",
    "CASTIGLIONE D'INTELVI",
    "CAVALLASCA",
    "CAVARGNA",
    "CENTRO VALLE INTELVI",
    "CERANO D'INTELVI",
    "CERMENATE",
    "CERNOBBIO",
    "CIRIMIDO",
    "CIVENNA",
    "CLAINO CON OSTENO",
    "COLONNO",
    "COLVERDE",
    "COMO",
    "CONSIGLIO DI RUMO",
    "CORRIDO",
    "CREMIA",
    "CUCCIAGO",
    "CUSINO",
    "DIZZASCO",
    "DOMASO",
    "DONGO",
    "DOSSO DEL LIRO",
    "DREZZO",
    "ERBA",
    "EUPILIO",
    "FAGGETO LARIO",
    "FALOPPIO",
    "FENEGRO'",
    "FIGINO SERENZA",
    "FINO MORNASCO",
    "GARZENO",
    "GERA LARIO",
    "GERMASINO",
    "GIRONICO",
    "GRANDATE",
    "GRANDOLA ED UNITI",
    "GRAVEDONA",
    "GRAVEDONA ED UNITI",
    "GRIANTE",
    "GUANZATE",
    "INVERIGO",
    "LAGLIO",
    "LAINO",
    "LAMBRUGO",
    "LANZO D'INTELVI",
    "LASNIGO",
    "LENNO",
    "LEZZENO",
    "LIMIDO COMASCO",
    "LIPOMO",
    "LIVO",
    "LOCATE VARESINO",
    "LOMAZZO",
    "LONGONE AL SEGRINO",
    "LUISAGO",
    "LURAGO D'ERBA",
    "LURAGO MARINONE",
    "LURATE CACCIVIO",
    "MAGREGLIO",
    "MARIANO COMENSE",
    "MASLIANICO",
    "MENAGGIO",
    "MERONE",
    "MEZZEGRA",
    "MOLTRASIO",
    "MONGUZZO",
    "MONTANO LUCINO",
    "MONTEMEZZO",
    "MONTORFANO",
    "MOZZATE",
    "MUSSO",
    "NESSO",
    "NOVEDRATE",
    "OLGIATE COMASCO",
    "OLTRONA DI SAN MAMETTE",
    "ORSENIGO",
    "OSSUCCIO",
    "PARE'",
    "PEGLIO",
    "PELLIO INTELVI",
    "PIANELLO DEL LARIO",
    "PIGRA",
    "PLESIO",
    "POGNANA LARIO",
    "PONNA",
    "PONTE LAMBRO",
    "PORLEZZA",
    "PROSERPIO",
    "PUSIANO",
    "RAMPONIO VERNA",
    "REZZAGO",
    "RODERO",
    "RONAGO",
    "ROVELLASCA",
    "ROVELLO PORRO",
    "SALA COMACINA",
    "SAN BARTOLOMEO VAL CAVARGNA",
    "SAN FEDELE INTELVI",
    "SAN FERMO DELLA BATTAGLIA",
    "SAN NAZZARO VAL CAVARGNA",
    "SAN SIRO",
    "SCHIGNANO",
    "SENNA COMASCO",
    "SOLBIATE",
    "SOLBIATE CON CAGNO",
    "SORICO",
    "SORMANO",
    "STAZZONA",
    "TAVERNERIO",
    "TORNO",
    "TREMEZZINA",
    "TREMEZZO",
    "TREZZONE",
    "TURATE",
    "UGGIATE-TREVANO",
    "VAL REZZO",
    "VALBRONA",
    "VALMOREA",
    "VALSOLDA",
    "VELESO",
    "VENIANO",
    "VERCANA",
    "VERTEMATE CON MINOPRIO",
    "VILLA GUARDIA",
    "ZELBIO"
  ],
  "CZ": [
    "ALBI",
    "AMARONI",
    "AMATO",
    "ANDALI",
    "ARGUSTO",
    "BADOLATO",
    "BELCASTRO",
    "BORGIA",
    "BOTRICELLO",
    "CARAFFA DI CATANZARO",
    "CARDINALE",
    "CARLOPOLI",
    "CATANZARO",
    "CENADI",
    "CENTRACHE",
    "CERVA",
    "CHIARAVALLE CENTRALE",
    "CICALA",
    "CONFLENTI",
    "CORTALE",
    "CROPANI",
    "CURINGA",
    "DAVOLI",
    "DECOLLATURA",
    "FALERNA",
    "FEROLETO ANTICO",
    "FOSSATO SERRALTA",
    "GAGLIATO",
    "GASPERINA",
    "GIMIGLIANO",
    "GIRIFALCO",
    "GIZZERIA",
    "GUARDAVALLE",
    "ISCA SULLO IONIO",
    "JACURSO",
    "LAMEZIA TERME",
    "MAGISANO",
    "MAIDA",
    "MARCEDUSA",
    "MARCELLINARA",
    "MARTIRANO",
    "MARTIRANO LOMBARDO",
    "MIGLIERINA",
    "MONTAURO",
    "MONTEPAONE",
    "MOTTA SANTA LUCIA",
    "NOCERA TERINESE",
    "OLIVADI",
    "PALERMITI",
    "PENTONE",
    "PETRIZZI",
    "PETRONA'",
    "PIANOPOLI",
    "PLATANIA",
    "SAN FLORO",
    "SAN MANGO D'AQUINO",
    "SAN PIETRO A MAIDA",
    "SAN PIETRO APOSTOLO",
    "SAN SOSTENE",
    "SAN VITO SULLO IONIO",
    "SANTA CATERINA DELLO IONIO",
    "SANT'ANDREA APOSTOLO DELLO IONIO",
    "SATRIANO",
    "SELLIA",
    "SELLIA MARINA",
    "SERRASTRETTA",
    "SERSALE",
    "SETTINGIANO",
    "SIMERI CRICHI",
    "SORBO SAN BASILE",
    "SOVERATO",
    "SOVERIA MANNELLI",
    "SOVERIA SIMERI",
    "SQUILLACE",
    "STALETTI'",
    "TAVERNA",
    "TIRIOLO",
    "TORRE DI RUGGIERO",
    "VALLEFIORITA",
    "ZAGARISE"
  ],
  "RE": [
    "ALBINEA",
    "BAGNOLO IN PIANO",
    "BAISO",
    "BIBBIANO",
    "BORETTO",
    "BRESCELLO",
    "BUSANA",
    "CADELBOSCO DI SOPRA",
    "CAMPAGNOLA EMILIA",
    "CAMPEGINE",
    "CANOSSA",
    "CARPINETI",
    "CASALGRANDE",
    "CASINA",
    "CASTELLARANO",
    "CASTELNOVO DI SOTTO",
    "CASTELNOVO NE' MONTI",
    "CAVRIAGO",
    "COLLAGNA",
    "CORREGGIO",
    "FABBRICO",
    "GATTATICO",
    "GUALTIERI",
    "GUASTALLA",
    "LIGONCHIO",
    "LUZZARA",
    "MONTECCHIO EMILIA",
    "NOVELLARA",
    "POVIGLIO",
    "QUATTRO CASTELLA",
    "RAMISETO",
    "REGGIO NELL'EMILIA",
    "REGGIOLO",
    "RIO SALICETO",
    "ROLO",
    "RUBIERA",
    "SAN MARTINO IN RIO",
    "SAN POLO D'ENZA",
    "SANT'ILARIO D'ENZA",
    "SCANDIANO",
    "TOANO",
    "VENTASSO",
    "VETTO",
    "VEZZANO SUL CROSTOLO",
    "VIANO",
    "VILLA MINOZZO"
  ],
  "TP": [
    "ALCAMO",
    "BUSETO PALIZZOLO",
    "CALATAFIMI SEGESTA",
    "CAMPOBELLO DI MAZARA",
    "CASTELLAMMARE DEL GOLFO",
    "CASTELVETRANO",
    "CUSTONACI",
    "ERICE",
    "FAVIGNANA",
    "GIBELLINA",
    "MARSALA",
    "MAZARA DEL VALLO",
    "PACECO",
    "PANTELLERIA",
    "PARTANNA",
    "PETROSINO",
    "POGGIOREALE",
    "SALAPARUTA",
    "SALEMI",
    "SAN VITO LO CAPO",
    "SANTA NINFA",
    "TRAPANI",
    "VALDERICE",
    "VITA"
  ],
  "BZ": [
    "ALDINO",
    "ANDRIANO",
    "ANTERIVO",
    "APPIANO SULLA STRADA DEL VINO",
    "AVELENGO",
    "BADIA",
    "BARBIANO",
    "BOLZANO",
    "BRAIES",
    "BRENNERO",
    "BRESSANONE",
    "BRONZOLO",
    "BRUNICO",
    "CAINES",
    "CALDARO SULLA STRADA DEL VINO",
    "CAMPO DI TRENS",
    "CAMPO TURES",
    "CASTELBELLO CIARDES",
    "CASTELROTTO",
    "CERMES",
    "CHIENES",
    "CHIUSA",
    "CORNEDO ALL'ISARCO",
    "CORTACCIA SULLA STRADA DEL VINO",
    "CORTINA SULLA STRADA DEL VINO",
    "CORVARA IN BADIA",
    "CURON VENOSTA",
    "DOBBIACO",
    "EGNA",
    "FALZES",
    "FIE' ALLO SCILIAR",
    "FORTEZZA",
    "FUNES",
    "GAIS",
    "GARGAZZONE",
    "GLORENZA",
    "LA VALLE",
    "LACES",
    "LAGUNDO",
    "LAION",
    "LAIVES",
    "LANA",
    "LASA",
    "LAUREGNO",
    "LUSON",
    "MAGRE' SULLA STRADA DEL VINO",
    "MALLES VENOSTA",
    "MAREBBE",
    "MARLENGO",
    "MARTELLO",
    "MELTINA",
    "MERANO",
    "MONGUELFO-TESIDO",
    "MONTAGNA",
    "MOSO IN PASSIRIA",
    "NALLES",
    "NATURNO",
    "NAZ SCIAVES",
    "NOVA LEVANTE",
    "NOVA PONENTE",
    "ORA",
    "ORTISEI",
    "PARCINES",
    "PERCA",
    "PLAUS",
    "PONTE GARDENA",
    "POSTAL",
    "PRATO ALLO STELVIO",
    "PREDOI",
    "PROVES",
    "RACINES",
    "RASUN ANTERSELVA",
    "RENON",
    "RIFIANO",
    "RIO DI PUSTERIA",
    "RODENGO",
    "SALORNO",
    "SAN CANDIDO",
    "SAN GENESIO ATESINO",
    "SAN LEONARDO IN PASSIRIA",
    "SAN LORENZO DI SEBATO",
    "SAN MARTINO IN BADIA",
    "SAN MARTINO IN PASSIRIA",
    "SAN PANCRAZIO",
    "SANTA CRISTINA VALGARDENA",
    "SARENTINO",
    "SCENA",
    "SELVA DEI MOLINI",
    "SELVA DI VAL GARDENA",
    "SENALES",
    "SENALE-SAN FELICE",
    "SESTO",
    "SILANDRO",
    "SLUDERNO",
    "STELVIO",
    "TERENTO",
    "TERLANO",
    "TERMENO SULLA STRADA DEL VINO",
    "TESIMO",
    "TIRES",
    "TIROLO",
    "TRODENA NEL PARCO NATURALE",
    "TUBRE",
    "ULTIMO",
    "VADENA",
    "VAL DI VIZZE",
    "VALDAORA",
    "VALLE AURINA",
    "VALLE DI CASIES",
    "VANDOIES",
    "VARNA",
    "VELTURNO",
    "VERANO",
    "VILLABASSA",
    "VILLANDRO",
    "VIPITENO"
  ],
  "RA": [
    "ALFONSINE",
    "BAGNACAVALLO",
    "BAGNARA DI ROMAGNA",
    "BRISIGHELLA",
    "CASOLA VALSENIO",
    "CASTEL BOLOGNESE",
    "CERVIA",
    "CONSELICE",
    "COTIGNOLA",
    "FAENZA",
    "FUSIGNANO",
    "LUGO",
    "MASSA LOMBARDA",
    "RAVENNA",
    "RIOLO TERME",
    "RUSSI",
    "SANT'AGATA SUL SANTERNO",
    "SOLAROLO"
  ],
  "PA": [
    "ALIA",
    "ALIMENA",
    "ALIMINUSA",
    "ALTAVILLA MILICIA",
    "ALTOFONTE",
    "BAGHERIA",
    "BALESTRATE",
    "BAUCINA",
    "BELMONTE MEZZAGNO",
    "BISACQUINO",
    "BLUFI",
    "BOLOGNETTA",
    "BOMPIETRO",
    "BORGETTO",
    "CACCAMO",
    "CALTAVUTURO",
    "CAMPOFELICE DI FITALIA",
    "CAMPOFELICE DI ROCCELLA",
    "CAMPOFIORITO",
    "CAMPOREALE",
    "CAPACI",
    "CARINI",
    "CASTELBUONO",
    "CASTELDACCIA",
    "CASTELLANA SICULA",
    "CASTRONOVO DI SICILIA",
    "CEFALA' DIANA",
    "CEFALU'",
    "CERDA",
    "CHIUSA SCLAFANI",
    "CIMINNA",
    "CINISI",
    "COLLESANO",
    "CONTESSA ENTELLINA",
    "CORLEONE",
    "FICARAZZI",
    "GANGI",
    "GERACI SICULO",
    "GIARDINELLO",
    "GIULIANA",
    "GODRANO",
    "GRATTERI",
    "ISNELLO",
    "ISOLA DELLE FEMMINE",
    "LASCARI",
    "LERCARA FRIDDI",
    "MARINEO",
    "MEZZOJUSO",
    "MISILMERI",
    "MONREALE",
    "MONTELEPRE",
    "MONTEMAGGIORE BELSITO",
    "PALAZZO ADRIANO",
    "PALERMO",
    "PARTINICO",
    "PETRALIA SOPRANA",
    "PETRALIA SOTTANA",
    "PIANA DEGLI ALBANESI",
    "POLIZZI GENEROSA",
    "POLLINA",
    "PRIZZI",
    "ROCCAMENA",
    "ROCCAPALUMBA",
    "SAN CIPIRELLO",
    "SAN GIUSEPPE JATO",
    "SAN MAURO CASTELVERDE",
    "SANTA CRISTINA GELA",
    "SANTA FLAVIA",
    "SCIARA",
    "SCILLATO",
    "SCLAFANI BAGNI",
    "TERMINI IMERESE",
    "TERRASINI",
    "TORRETTA",
    "TRABIA",
    "TRAPPETO",
    "USTICA",
    "VALLEDOLMO",
    "VENTIMIGLIA DI SICILIA",
    "VICARI",
    "VILLABATE",
    "VILLAFRATI"
  ],
  "AO": [
    "ALLEIN",
    "ANTEY-SAINT-ANDRE'",
    "AOSTA",
    "ARNAD",
    "ARVIER",
    "AVISE",
    "AYAS",
    "AYMAVILLES",
    "BARD",
    "BIONAZ",
    "BRISSOGNE",
    "BRUSSON",
    "CHALLAND-SAINT-ANSELME",
    "CHALLAND-SAINT-VICTOR",
    "CHAMBAVE",
    "CHAMOIS",
    "CHAMPDEPRAZ",
    "CHAMPORCHER",
    "CHARVENSOD",
    "CHATILLON",
    "COGNE",
    "COURMAYEUR",
    "DONNAS",
    "DOUES",
    "EMARESE",
    "ETROUBLES",
    "FENIS",
    "FONTAINEMORE",
    "GABY",
    "GIGNOD",
    "GRESSAN",
    "GRESSONEY-LA-TRINITE'",
    "GRESSONEY-SAINT-JEAN",
    "HONE",
    "INTROD",
    "ISSIME",
    "ISSOGNE",
    "JOVENCAN",
    "LA MAGDELEINE",
    "LA SALLE",
    "LA THUILE",
    "LILLIANES",
    "MONTJOVET",
    "MORGEX",
    "NUS",
    "OLLOMONT",
    "OYACE",
    "PERLOZ",
    "POLLEIN",
    "PONTBOSET",
    "PONTEY",
    "PONT-SAINT-MARTIN",
    "PRE'-SAINT-DIDIER",
    "QUART",
    "RHEMES-NOTRE-DAME",
    "RHEMES-SAINT-GEORGES",
    "ROISAN",
    "SAINT-CHRISTOPHE",
    "SAINT-DENIS",
    "SAINT-MARCEL",
    "SAINT-NICOLAS",
    "SAINT-OYEN",
    "SAINT-PIERRE",
    "SAINT-RHEMY-EN-BOSSES",
    "SAINT-VINCENT",
    "SARRE",
    "TORGNON",
    "VALGRISENCHE",
    "VALPELLINE",
    "VALSAVARENCHE",
    "VALTOURNENCHE",
    "VERRAYES",
    "VERRES",
    "VILLENEUVE"
  ],
  "FM": [
    "ALTIDONA",
    "AMANDOLA",
    "BELMONTE PICENO",
    "CAMPOFILONE",
    "FALERONE",
    "FERMO",
    "FRANCAVILLA D'ETE",
    "GROTTAZZOLINA",
    "LAPEDONA",
    "MAGLIANO DI TENNA",
    "MASSA FERMANA",
    "MONSAMPIETRO MORICO",
    "MONTAPPONE",
    "MONTE GIBERTO",
    "MONTE RINALDO",
    "MONTE SAN PIETRANGELI",
    "MONTE URANO",
    "MONTE VIDON COMBATTE",
    "MONTE VIDON CORRADO",
    "MONTEFALCONE APPENNINO",
    "MONTEFORTINO",
    "MONTEGIORGIO",
    "MONTEGRANARO",
    "MONTELEONE DI FERMO",
    "MONTELPARO",
    "MONTERUBBIANO",
    "MONTOTTONE",
    "MORESCO",
    "ORTEZZANO",
    "PEDASO",
    "PETRITOLI",
    "PONZANO DI FERMO",
    "PORTO SAN GIORGIO",
    "PORTO SANT'ELPIDIO",
    "RAPAGNANO",
    "SANTA VITTORIA IN MATENANO",
    "SANT'ELPIDIO A MARE",
    "SERVIGLIANO",
    "SMERILLO",
    "TORRE SAN PATRIZIO"
  ],
  "CH": [
    "ALTINO",
    "ARCHI",
    "ARI",
    "ARIELLI",
    "ATESSA",
    "BOMBA",
    "BORRELLO",
    "BUCCHIANICO",
    "CANOSA SANNITA",
    "CARPINETO SINELLO",
    "CARUNCHIO",
    "CASACANDITELLA",
    "CASALANGUIDA",
    "CASALBORDINO",
    "CASALINCONTRADA",
    "CASOLI",
    "CASTEL FRENTANO",
    "CASTELGUIDONE",
    "CASTIGLIONE MESSER MARINO",
    "CELENZA SUL TRIGNO",
    "CHIETI",
    "CIVITALUPARELLA",
    "CIVITELLA MESSER RAIMONDO",
    "COLLEDIMACINE",
    "COLLEDIMEZZO",
    "CRECCHIO",
    "CUPELLO",
    "DOGLIOLA",
    "FALLO",
    "FARA FILIORUM PETRI",
    "FARA SAN MARTINO",
    "FILETTO",
    "FOSSACESIA",
    "FRAINE",
    "FRANCAVILLA AL MARE",
    "FRESAGRANDINARIA",
    "FRISA",
    "FURCI",
    "GAMBERALE",
    "GESSOPALENA",
    "GISSI",
    "GIULIANO TEATINO",
    "GUARDIAGRELE",
    "GUILMI",
    "LAMA DEI PELIGNI",
    "LANCIANO",
    "LENTELLA",
    "LETTOPALENA",
    "LISCIA",
    "MIGLIANICO",
    "MONTAZZOLI",
    "MONTEBELLO SUL SANGRO",
    "MONTEFERRANTE",
    "MONTELAPIANO",
    "MONTENERODOMO",
    "MONTEODORISIO",
    "MOZZAGROGNA",
    "ORSOGNA",
    "ORTONA",
    "PAGLIETA",
    "PALENA",
    "PALMOLI",
    "PALOMBARO",
    "PENNADOMO",
    "PENNAPIEDIMONTE",
    "PERANO",
    "PIETRAFERRAZZANA",
    "PIZZOFERRATO",
    "POGGIOFIORITO",
    "POLLUTRI",
    "PRETORO",
    "QUADRI",
    "RAPINO",
    "RIPA TEATINA",
    "ROCCA SAN GIOVANNI",
    "ROCCAMONTEPIANO",
    "ROCCASCALEGNA",
    "ROCCASPINALVETI",
    "ROIO DEL SANGRO",
    "ROSELLO",
    "SAN BUONO",
    "SAN GIOVANNI LIPIONI",
    "SAN GIOVANNI TEATINO",
    "SAN MARTINO SULLA MARRUCINA",
    "SAN SALVO",
    "SAN VITO CHIETINO",
    "SANTA MARIA IMBARO",
    "SANT'EUSANIO DEL SANGRO",
    "SCERNI",
    "SCHIAVI DI ABRUZZO",
    "TARANTA PELIGNA",
    "TOLLO",
    "TORINO DI SANGRO",
    "TORNARECCIO",
    "TORREBRUNA",
    "TORREVECCHIA TEATINA",
    "TORRICELLA PELIGNA",
    "TREGLIO",
    "TUFILLO",
    "VACRI",
    "VASTO",
    "VILLA SANTA MARIA",
    "VILLALFONSINA",
    "VILLAMAGNA"
  ],
  "TV": [
    "ALTIVOLE",
    "ARCADE",
    "ASOLO",
    "BORSO DEL GRAPPA",
    "BREDA DI PIAVE",
    "CAERANO DI SAN MARCO",
    "CAPPELLA MAGGIORE",
    "CARBONERA",
    "CASALE SUL SILE",
    "CASIER",
    "CASTELCUCCO",
    "CASTELFRANCO VENETO",
    "CASTELLO DI GODEGO",
    "CAVASO DEL TOMBA",
    "CESSALTO",
    "CHIARANO",
    "CIMADOLMO",
    "CISON DI VALMARINO",
    "CODOGNE'",
    "COLLE UMBERTO",
    "CONEGLIANO",
    "CORDIGNANO",
    "CORNUDA",
    "CRESPANO DEL GRAPPA",
    "CROCETTA DEL MONTELLO",
    "FARRA DI SOLIGO",
    "FOLLINA",
    "FONTANELLE",
    "FONTE",
    "FREGONA",
    "GAIARINE",
    "GIAVERA DEL MONTELLO",
    "GODEGA DI SANT'URBANO",
    "GORGO AL MONTICANO",
    "ISTRANA",
    "LORIA",
    "MANSUE'",
    "MARENO DI PIAVE",
    "MASER",
    "MASERADA SUL PIAVE",
    "MEDUNA DI LIVENZA",
    "MIANE",
    "MOGLIANO VENETO",
    "MONASTIER DI TREVISO",
    "MONFUMO",
    "MONTEBELLUNA",
    "MORGANO",
    "MORIAGO DELLA BATTAGLIA",
    "MOTTA DI LIVENZA",
    "NERVESA DELLA BATTAGLIA",
    "ODERZO",
    "ORMELLE",
    "ORSAGO",
    "PADERNO DEL GRAPPA",
    "PAESE",
    "PEDEROBBA",
    "PIEVE DEL GRAPPA",
    "PIEVE DI SOLIGO",
    "PONTE DI PIAVE",
    "PONZANO VENETO",
    "PORTOBUFFOLE'",
    "POSSAGNO",
    "POVEGLIANO",
    "PREGANZIOL",
    "QUINTO DI TREVISO",
    "REFRONTOLO",
    "RESANA",
    "REVINE LAGO",
    "RIESE PIO X",
    "RONCADE",
    "SALGAREDA",
    "SAN BIAGIO DI CALLALTA",
    "SAN FIOR",
    "SAN PIETRO DI FELETTO",
    "SAN POLO DI PIAVE",
    "SAN VENDEMIANO",
    "SAN ZENONE DEGLI EZZELINI",
    "SANTA LUCIA DI PIAVE",
    "SARMEDE",
    "SEGUSINO",
    "SERNAGLIA DELLA BATTAGLIA",
    "SILEA",
    "SPRESIANO",
    "SUSEGANA",
    "TARZO",
    "TREVIGNANO",
    "TREVISO",
    "VALDOBBIADENE",
    "VAZZOLA",
    "VEDELAGO",
    "VIDOR",
    "VILLORBA",
    "VITTORIO VENETO",
    "VOLPAGO DEL MONTELLO",
    "ZENSON DI PIAVE",
    "ZERO BRANCO"
  ],
  "BO": [
    "ALTO RENO TERME",
    "ANZOLA DELL'EMILIA",
    "ARGELATO",
    "BARICELLA",
    "BAZZANO",
    "BENTIVOGLIO",
    "BOLOGNA",
    "BORGO TOSSIGNANO",
    "BUDRIO",
    "CALDERARA DI RENO",
    "CAMUGNANO",
    "CASALECCHIO DI RENO",
    "CASALFIUMANESE",
    "CASTEL D'AIANO",
    "CASTEL DEL RIO",
    "CASTEL DI CASIO",
    "CASTEL GUELFO DI BOLOGNA",
    "CASTEL MAGGIORE",
    "CASTEL SAN PIETRO TERME",
    "CASTELLO D'ARGILE",
    "CASTELLO DI SERRAVALLE",
    "CASTENASO",
    "CASTIGLIONE DEI PEPOLI",
    "CRESPELLANO",
    "CREVALCORE",
    "DOZZA",
    "FONTANELICE",
    "GAGGIO MONTANO",
    "GALLIERA",
    "GRANAGLIONE",
    "GRANAROLO DELL'EMILIA",
    "GRIZZANA MORANDI",
    "IMOLA",
    "LIZZANO IN BELVEDERE",
    "LOIANO",
    "MALALBERGO",
    "MARZABOTTO",
    "MEDICINA",
    "MINERBIO",
    "MOLINELLA",
    "MONGHIDORO",
    "MONTE SAN PIETRO",
    "MONTERENZIO",
    "MONTEVEGLIO",
    "MONZUNO",
    "MORDANO",
    "OZZANO DELL'EMILIA",
    "PIANORO",
    "PIEVE DI CENTO",
    "PORRETTA TERME",
    "SALA BOLOGNESE",
    "SAN BENEDETTO VAL DI SAMBRO",
    "SAN GIORGIO DI PIANO",
    "SAN GIOVANNI IN PERSICETO",
    "SAN LAZZARO DI SAVENA",
    "SAN PIETRO IN CASALE",
    "SANT'AGATA BOLOGNESE",
    "SASSO MARCONI",
    "SAVIGNO",
    "VALSAMOGGIA",
    "VERGATO",
    "ZOLA PREDOSA"
  ],
  "LU": [
    "ALTOPASCIO",
    "BAGNI DI LUCCA",
    "BARGA",
    "BORGO A MOZZANO",
    "CAMAIORE",
    "CAMPORGIANO",
    "CAPANNORI",
    "CAREGGINE",
    "CASTELNUOVO DI GARFAGNANA",
    "CASTIGLIONE DI GARFAGNANA",
    "COREGLIA ANTELMINELLI",
    "FABBRICHE DI VALLICO",
    "FABBRICHE DI VERGEMOLI",
    "FORTE DEI MARMI",
    "FOSCIANDORA",
    "GALLICANO",
    "GIUNCUGNANO",
    "LUCCA",
    "MASSAROSA",
    "MINUCCIANO",
    "MOLAZZANA",
    "MONTECARLO",
    "PESCAGLIA",
    "PIAZZA AL SERCHIO",
    "PIETRASANTA",
    "PIEVE FOSCIANA",
    "PORCARI",
    "SAN ROMANO IN GARFAGNANA",
    "SERAVEZZA",
    "SILLANO",
    "SILLANO GIUNCUGNANO",
    "STAZZEMA",
    "VAGLI SOTTO",
    "VERGEMOLI",
    "VIAREGGIO",
    "VILLA BASILICA",
    "VILLA COLLEMANDINA"
  ],
  "SP": [
    "AMEGLIA",
    "ARCOLA",
    "BEVERINO",
    "BOLANO",
    "BONASSOLA",
    "BORGHETTO DI VARA",
    "BRUGNATO",
    "CALICE AL CORNOVIGLIO",
    "CARRO",
    "CARRODANO",
    "CASTELNUOVO MAGRA",
    "DEIVA MARINA",
    "FOLLO",
    "FRAMURA",
    "LA SPEZIA",
    "LERICI",
    "LEVANTO",
    "MAISSANA",
    "MONTEROSSO AL MARE",
    "ORTONOVO",
    "PIGNONE",
    "PORTOVENERE",
    "RICCO' DEL GOLFO DI SPEZIA",
    "RIOMAGGIORE",
    "ROCCHETTA DI VARA",
    "SANTO STEFANO DI MAGRA",
    "SARZANA",
    "SESTA GODANO",
    "VARESE LIGURE",
    "VERNAZZA",
    "VEZZANO LIGURE",
    "ZIGNAGO"
  ],
  "PN": [
    "ANDREIS",
    "ARBA",
    "ARZENE",
    "AVIANO",
    "AZZANO DECIMO",
    "BARCIS",
    "BRUGNERA",
    "BUDOIA",
    "CANEVA",
    "CASARSA DELLA DELIZIA",
    "CASTELNOVO DEL FRIULI",
    "CAVASSO NUOVO",
    "CHIONS",
    "CIMOLAIS",
    "CLAUT",
    "CLAUZETTO",
    "CORDENONS",
    "CORDOVADO",
    "ERTO E CASSO",
    "FANNA",
    "FIUME VENETO",
    "FONTANAFREDDA",
    "FRISANCO",
    "MANIAGO",
    "MEDUNO",
    "MONTEREALE VALCELLINA",
    "MORSANO AL TAGLIAMENTO",
    "PASIANO DI PORDENONE",
    "PINZANO AL TAGLIAMENTO",
    "POLCENIGO",
    "PORCIA",
    "PORDENONE",
    "PRATA DI PORDENONE",
    "PRAVISDOMINI",
    "ROVEREDO IN PIANO",
    "SACILE",
    "SAN GIORGIO DELLA RICHINVELDA",
    "SAN MARTINO AL TAGLIAMENTO",
    "SAN QUIRINO",
    "SAN VITO AL TAGLIAMENTO",
    "SEQUALS",
    "SESTO AL REGHENA",
    "SPILIMBERGO",
    "TRAMONTI DI SOPRA",
    "TRAMONTI DI SOTTO",
    "TRAVESIO",
    "VAJONT",
    "VALVASONE",
    "VALVASONE ARZENE",
    "VITO D'ASIO",
    "VIVARO",
    "ZOPPOLA"
  ],
  "BT": [
    "ANDRIA",
    "BARLETTA",
    "BISCEGLIE",
    "CANOSA DI PUGLIA",
    "MARGHERITA DI SAVOIA",
    "MINERVINO MURGE",
    "SAN FERDINANDO DI PUGLIA",
    "SPINAZZOLA",
    "TRANI",
    "TRINITAPOLI"
  ],
  "AR": [
    "ANGHIARI",
    "AREZZO",
    "BADIA TEDALDA",
    "BIBBIENA",
    "BUCINE",
    "CAPOLONA",
    "CAPRESE MICHELANGELO",
    "CASTEL FOCOGNANO",
    "CASTEL SAN NICCOLO'",
    "CASTELFRANCO DI SOPRA",
    "CASTELFRANCO PIANDISCO'",
    "CASTIGLION FIBOCCHI",
    "CASTIGLION FIORENTINO",
    "CAVRIGLIA",
    "CHITIGNANO",
    "CHIUSI DELLA VERNA",
    "CIVITELLA IN VAL DI CHIANA",
    "CORTONA",
    "FOIANO DELLA CHIANA",
    "LATERINA",
    "LATERINA PERGINE VALDARNO",
    "LORO CIUFFENNA",
    "LUCIGNANO",
    "MARCIANO DELLA CHIANA",
    "MONTE SAN SAVINO",
    "MONTEMIGNAIO",
    "MONTERCHI",
    "MONTEVARCHI",
    "ORTIGNANO RAGGIOLO",
    "PERGINE VALDARNO",
    "PIAN DI SCO'",
    "PIEVE SANTO STEFANO",
    "POPPI",
    "PRATOVECCHIO",
    "PRATOVECCHIO STIA",
    "SAN GIOVANNI VALDARNO",
    "SANSEPOLCRO",
    "SESTINO",
    "STIA",
    "SUBBIANO",
    "TALLA",
    "TERRANUOVA BRACCIOLINI"
  ],
  "VE": [
    "ANNONE VENETO",
    "CAMPAGNA LUPIA",
    "CAMPOLONGO MAGGIORE",
    "CAMPONOGARA",
    "CAORLE",
    "CAVALLINO-TREPORTI",
    "CAVARZERE",
    "CEGGIA",
    "CHIOGGIA",
    "CINTO CAOMAGGIORE",
    "CONA",
    "CONCORDIA SAGITTARIA",
    "DOLO",
    "ERACLEA",
    "FIESSO D'ARTICO",
    "FOSSALTA DI PIAVE",
    "FOSSALTA DI PORTOGRUARO",
    "FOSSO'",
    "GRUARO",
    "JESOLO",
    "MARCON",
    "MARTELLAGO",
    "MEOLO",
    "MIRA",
    "MIRANO",
    "MUSILE DI PIAVE",
    "NOALE",
    "NOVENTA DI PIAVE",
    "PIANIGA",
    "PORTOGRUARO",
    "PRAMAGGIORE",
    "QUARTO D'ALTINO",
    "SALZANO",
    "SAN DONA' DI PIAVE",
    "SAN MICHELE AL TAGLIAMENTO",
    "SAN STINO DI LIVENZA",
    "SANTA MARIA DI SALA",
    "SCORZE'",
    "SPINEA",
    "STRA",
    "TEGLIO VENETO",
    "TORRE DI MOSTO",
    "VENEZIA",
    "VIGONOVO"
  ],
  "VB": [
    "ANTRONA SCHIERANCO",
    "ANZOLA D'OSSOLA",
    "ARIZZANO",
    "AROLA",
    "AURANO",
    "BACENO",
    "BANNIO ANZINO",
    "BAVENO",
    "BEE",
    "BELGIRATE",
    "BEURA-CARDEZZA",
    "BOGNANCO",
    "BORGOMEZZAVALLE",
    "BROVELLO-CARPUGNINO",
    "CALASCA-CASTIGLIONE",
    "CAMBIASCA",
    "CANNERO RIVIERA",
    "CANNOBIO",
    "CAPREZZO",
    "CASALE CORTE CERRO",
    "CAVAGLIO-SPOCCIA",
    "CEPPO MORELLI",
    "CESARA",
    "COSSOGNO",
    "CRAVEGGIA",
    "CREVOLADOSSOLA",
    "CRODO",
    "CURSOLO-ORASSO",
    "DOMODOSSOLA",
    "DRUOGNO",
    "FALMENTA",
    "FORMAZZA",
    "GERMAGNO",
    "GHIFFA",
    "GIGNESE",
    "GRAVELLONA TOCE",
    "GURRO",
    "INTRAGNA",
    "LOREGLIA",
    "MACUGNAGA",
    "MADONNA DEL SASSO",
    "MALESCO",
    "MASERA",
    "MASSIOLA",
    "MERGOZZO",
    "MIAZZINA",
    "MONTECRESTESE",
    "MONTESCHENO",
    "NONIO",
    "OGGEBBIO",
    "OMEGNA",
    "ORNAVASSO",
    "PALLANZENO",
    "PIEDIMULERA",
    "PIEVE VERGONTE",
    "PREMENO",
    "PREMIA",
    "PREMOSELLO-CHIOVENDA",
    "QUARNA SOPRA",
    "QUARNA SOTTO",
    "RE",
    "SAN BERNARDINO VERBANO",
    "SANTA MARIA MAGGIORE",
    "SEPPIANA",
    "STRESA",
    "TOCENO",
    "TRAREGO VIGGIONA",
    "TRASQUERA",
    "TRONTANO",
    "VALLE CANNOBINA",
    "VALSTRONA",
    "VANZONE CON SAN CARLO",
    "VARZO",
    "VERBANIA",
    "VIGANELLA",
    "VIGNONE",
    "VILLADOSSOLA",
    "VILLETTE",
    "VOGOGNA"
  ],
  "LT": [
    "APRILIA",
    "BASSIANO",
    "CAMPODIMELE",
    "CASTELFORTE",
    "CISTERNA DI LATINA",
    "CORI",
    "FONDI",
    "FORMIA",
    "GAETA",
    "ITRI",
    "LATINA",
    "LENOLA",
    "MAENZA",
    "MINTURNO",
    "MONTE SAN BIAGIO",
    "NORMA",
    "PONTINIA",
    "PONZA",
    "PRIVERNO",
    "PROSSEDI",
    "ROCCA MASSIMA",
    "ROCCAGORGA",
    "ROCCASECCA DEI VOLSCI",
    "SABAUDIA",
    "SAN FELICE CIRCEO",
    "SANTI COSMA E DAMIANO",
    "SERMONETA",
    "SEZZE",
    "SONNINO",
    "SPERLONGA",
    "SPIGNO SATURNIA",
    "TERRACINA",
    "VENTOTENE"
  ],
  "SU": [
    "ARBUS",
    "ARMUNGIA",
    "BALLAO",
    "BARRALI",
    "BARUMINI",
    "BUGGERRU",
    "BURCEI",
    "CALASETTA",
    "CARBONIA",
    "CARLOFORTE",
    "CASTIADAS",
    "COLLINAS",
    "DECIMOPUTZU",
    "DOLIANOVA",
    "DOMUS DE MARIA",
    "DOMUSNOVAS",
    "DONORI",
    "ESCALAPLANO",
    "ESCOLCA",
    "ESTERZILI",
    "FLUMINIMAGGIORE",
    "FURTEI",
    "GENONI",
    "GENURI",
    "GERGEI",
    "GESICO",
    "GESTURI",
    "GIBA",
    "GONI",
    "GONNESA",
    "GONNOSFANADIGA",
    "GUAMAGGIORE",
    "GUASILA",
    "GUSPINI",
    "IGLESIAS",
    "ISILI",
    "LAS PLASSAS",
    "LUNAMATRONA",
    "MANDAS",
    "MASAINAS",
    "MONASTIR",
    "MURAVERA",
    "MUSEI",
    "NARCAO",
    "NURAGUS",
    "NURALLAO",
    "NURAMINIS",
    "NURRI",
    "NUXIS",
    "ORROLI",
    "ORTACESUS",
    "PABILLONIS",
    "PAULI ARBAREI",
    "PERDAXIUS",
    "PIMENTEL",
    "PISCINAS",
    "PORTOSCUSO",
    "SADALI",
    "SAMASSI",
    "SAMATZAI",
    "SAN BASILIO",
    "SAN GAVINO MONREALE",
    "SAN GIOVANNI SUERGIU",
    "SAN NICOLO' GERREI",
    "SAN SPERATE",
    "SAN VITO",
    "SANLURI",
    "SANTADI",
    "SANT'ANDREA FRIUS",
    "SANT'ANNA ARRESI",
    "SANT'ANTIOCO",
    "SARDARA",
    "SEGARIU",
    "SELEGAS",
    "SENORBI'",
    "SERDIANA",
    "SERRAMANNA",
    "SERRENTI",
    "SERRI",
    "SETZU",
    "SEUI",
    "SEULO",
    "SIDDI",
    "SILIQUA",
    "SILIUS",
    "SIURGUS DONIGALA",
    "SOLEMINIS",
    "SUELLI",
    "TEULADA",
    "TRATALIAS",
    "TUILI",
    "TURRI",
    "USSANA",
    "USSARAMANNA",
    "VALLERMOSA",
    "VILLACIDRO",
    "VILLAMAR",
    "VILLAMASSARGIA",
    "VILLANOVA TULO",
    "VILLANOVAFORRU",
    "VILLANOVAFRANCA",
    "VILLAPERUCCIO",
    "VILLAPUTZU",
    "VILLASALTO",
    "VILLASIMIUS",
    "VILLASOR",
    "VILLASPECIOSA"
  ],
  "GR": [
    "ARCIDOSSO",
    "CAMPAGNATICO",
    "CAPALBIO",
    "CASTEL DEL PIANO",
    "CASTELL'AZZARA",
    "CASTIGLIONE DELLA PESCAIA",
    "CINIGIANO",
    "CIVITELLA PAGANICO",
    "FOLLONICA",
    "GAVORRANO",
    "GROSSETO",
    "ISOLA DEL GIGLIO",
    "MAGLIANO IN TOSCANA",
    "MANCIANO",
    "MASSA MARITTIMA",
    "MONTE ARGENTARIO",
    "MONTEROTONDO MARITTIMO",
    "MONTIERI",
    "ORBETELLO",
    "PITIGLIANO",
    "ROCCALBEGNA",
    "ROCCASTRADA",
    "SANTA FIORA",
    "SCANSANO",
    "SCARLINO",
    "SEGGIANO",
    "SEMPRONIANO",
    "SORANO"
  ],
  "GE": [
    "ARENZANO",
    "AVEGNO",
    "BARGAGLI",
    "BOGLIASCO",
    "BORZONASCA",
    "BUSALLA",
    "CAMOGLI",
    "CAMPO LIGURE",
    "CAMPOMORONE",
    "CARASCO",
    "CASARZA LIGURE",
    "CASELLA",
    "CASTIGLIONE CHIAVARESE",
    "CERANESI",
    "CHIAVARI",
    "CICAGNA",
    "COGOLETO",
    "COGORNO",
    "COREGLIA LIGURE",
    "CROCEFIESCHI",
    "DAVAGNA",
    "FASCIA",
    "FAVALE DI MALVARO",
    "FONTANIGORDA",
    "GENOVA",
    "GORRETO",
    "ISOLA DEL CANTONE",
    "LAVAGNA",
    "LEIVI",
    "LORSICA",
    "LUMARZO",
    "MASONE",
    "MELE",
    "MEZZANEGO",
    "MIGNANEGO",
    "MOCONESI",
    "MONEGLIA",
    "MONTEBRUNO",
    "MONTOGGIO",
    "NE",
    "NEIRONE",
    "ORERO",
    "PIEVE LIGURE",
    "PORTOFINO",
    "PROPATA",
    "RAPALLO",
    "RECCO",
    "REZZOAGLIO",
    "RONCO SCRIVIA",
    "RONDANINA",
    "ROSSIGLIONE",
    "ROVEGNO",
    "SAN COLOMBANO CERTENOLI",
    "SANTA MARGHERITA LIGURE",
    "SANTO STEFANO D'AVETO",
    "SANT'OLCESE",
    "SAVIGNONE",
    "SERRA RICCO'",
    "SESTRI LEVANTE",
    "SORI",
    "TIGLIETO",
    "TORRIGLIA",
    "TRIBOGNA",
    "USCIO",
    "VALBREVENNA",
    "VOBBIA",
    "ZOAGLI"
  ],
  "FE": [
    "ARGENTA",
    "BERRA",
    "BONDENO",
    "CENTO",
    "CODIGORO",
    "COMACCHIO",
    "COPPARO",
    "FERRARA",
    "FISCAGLIA",
    "FORMIGNANA",
    "GORO",
    "JOLANDA DI SAVOIA",
    "LAGOSANTO",
    "MASI TORELLO",
    "MASSA FISCAGLIA",
    "MESOLA",
    "MIGLIARINO",
    "MIGLIARO",
    "MIRABELLO",
    "OSTELLATO",
    "POGGIO RENATICO",
    "PORTOMAGGIORE",
    "RIVA DEL PO",
    "RO",
    "SANT'AGOSTINO",
    "TERRE DEL RENO",
    "TRESIGALLO",
    "TRESIGNANA",
    "VIGARANO MAINARDA",
    "VOGHIERA"
  ],
  "NU": [
    "ARITZO",
    "ARZANA",
    "ATZARA",
    "AUSTIS",
    "BARI SARDO",
    "BAUNEI",
    "BELVI'",
    "BIRORI",
    "BITTI",
    "BOLOTANA",
    "BORORE",
    "BORTIGALI",
    "CARDEDU",
    "DESULO",
    "DORGALI",
    "DUALCHI",
    "ELINI",
    "FONNI",
    "GADONI",
    "GAIRO",
    "GALTELLI'",
    "GAVOI",
    "GIRASOLE",
    "ILBONO",
    "IRGOLI",
    "JERZU",
    "LANUSEI",
    "LEI",
    "LOCERI",
    "LOCULI",
    "LODE'",
    "LODINE",
    "LOTZORAI",
    "LULA",
    "MACOMER",
    "MAMOIADA",
    "MEANA SARDO",
    "NORAGUGUME",
    "NUORO",
    "OLIENA",
    "OLLOLAI",
    "OLZAI",
    "ONANI'",
    "ONIFAI",
    "ONIFERI",
    "ORANI",
    "ORGOSOLO",
    "OROSEI",
    "OROTELLI",
    "ORTUERI",
    "ORUNE",
    "OSIDDA",
    "OSINI",
    "OTTANA",
    "OVODDA",
    "PERDASDEFOGU",
    "POSADA",
    "SARULE",
    "SILANUS",
    "SINDIA",
    "SINISCOLA",
    "SORGONO",
    "TALANA",
    "TERTENIA",
    "TETI",
    "TIANA",
    "TONARA",
    "TORPE'",
    "TORTOLI'",
    "TRIEI",
    "ULASSAI",
    "URZULEI",
    "USSASSAI",
    "VILLAGRANDE STRISAILI"
  ],
  "CA": [
    "ASSEMINI",
    "CAGLIARI",
    "CAPOTERRA",
    "DECIMOMANNU",
    "ELMAS",
    "MARACALAGONIS",
    "MONSERRATO",
    "PULA",
    "QUARTU SANT'ELENA",
    "QUARTUCCIU",
    "SARROCH",
    "SELARGIUS",
    "SESTU",
    "SETTIMO SAN PIETRO",
    "SINNAI",
    "UTA",
    "VILLA SAN PIETRO"
  ],
  "PG": [
    "ASSISI",
    "BASTIA UMBRA",
    "BETTONA",
    "BEVAGNA",
    "CAMPELLO SUL CLITUNNO",
    "CANNARA",
    "CASCIA",
    "CASTEL RITALDI",
    "CASTIGLIONE DEL LAGO",
    "CERRETO DI SPOLETO",
    "CITERNA",
    "CITTA' DELLA PIEVE",
    "CITTA' DI CASTELLO",
    "COLLAZZONE",
    "CORCIANO",
    "COSTACCIARO",
    "DERUTA",
    "FOLIGNO",
    "FOSSATO DI VICO",
    "FRATTA TODINA",
    "GIANO DELL'UMBRIA",
    "GUALDO CATTANEO",
    "GUALDO TADINO",
    "GUBBIO",
    "LISCIANO NICCONE",
    "MAGIONE",
    "MARSCIANO",
    "MASSA MARTANA",
    "MONTE CASTELLO DI VIBIO",
    "MONTE SANTA MARIA TIBERINA",
    "MONTEFALCO",
    "MONTELEONE DI SPOLETO",
    "MONTONE",
    "NOCERA UMBRA",
    "NORCIA",
    "PACIANO",
    "PANICALE",
    "PASSIGNANO SUL TRASIMENO",
    "PERUGIA",
    "PIEGARO",
    "PIETRALUNGA",
    "POGGIODOMO",
    "PRECI",
    "SAN GIUSTINO",
    "SANT'ANATOLIA DI NARCO",
    "SCHEGGIA E PASCELUPO",
    "SCHEGGINO",
    "SELLANO",
    "SIGILLO",
    "SPELLO",
    "SPOLETO",
    "TODI",
    "TORGIANO",
    "TREVI",
    "TUORO SUL TRASIMENO",
    "UMBERTIDE",
    "VALFABBRICA",
    "VALLO DI NERA",
    "VALTOPINA"
  ],
  "SR": [
    "AUGUSTA",
    "AVOLA",
    "BUCCHERI",
    "BUSCEMI",
    "CANICATTINI BAGNI",
    "CARLENTINI",
    "CASSARO",
    "FERLA",
    "FLORIDIA",
    "FRANCOFONTE",
    "LENTINI",
    "MELILLI",
    "NOTO",
    "PACHINO",
    "PALAZZOLO ACREIDE",
    "PORTOPALO DI CAPO PASSERO",
    "PRIOLO GARGALLO",
    "ROSOLINI",
    "SIRACUSA",
    "SOLARINO",
    "SORTINO"
  ],
  "MS": [
    "AULLA",
    "BAGNONE",
    "CARRARA",
    "CASOLA IN LUNIGIANA",
    "COMANO",
    "FILATTIERA",
    "FIVIZZANO",
    "FOSDINOVO",
    "LICCIANA NARDI",
    "MASSA",
    "MONTIGNOSO",
    "MULAZZO",
    "PODENZANA",
    "PONTREMOLI",
    "TRESANA",
    "VILLAFRANCA IN LUNIGIANA",
    "ZERI"
  ],
  "TA": [
    "AVETRANA",
    "CAROSINO",
    "CASTELLANETA",
    "CRISPIANO",
    "FAGGIANO",
    "FRAGAGNANO",
    "GINOSA",
    "GROTTAGLIE",
    "LATERZA",
    "LEPORANO",
    "LIZZANO",
    "MANDURIA",
    "MARTINA FRANCA",
    "MARUGGIO",
    "MASSAFRA",
    "MONTEIASI",
    "MONTEMESOLA",
    "MONTEPARANO",
    "MOTTOLA",
    "PALAGIANELLO",
    "PALAGIANO",
    "PULSANO",
    "ROCCAFORZATA",
    "SAN GIORGIO IONICO",
    "SAN MARZANO DI SAN GIUSEPPE",
    "SAVA",
    "STATTE",
    "TARANTO",
    "TORRICELLA"
  ],
  "FI": [
    "BAGNO A RIPOLI",
    "BARBERINO DI MUGELLO",
    "BARBERINO TAVARNELLE",
    "BARBERINO VAL D'ELSA",
    "BORGO SAN LORENZO",
    "CALENZANO",
    "CAMPI BISENZIO",
    "CAPRAIA E LIMITE",
    "CASTELFIORENTINO",
    "CERRETO GUIDI",
    "CERTALDO",
    "DICOMANO",
    "EMPOLI",
    "FIESOLE",
    "FIGLINE E INCISA VALDARNO",
    "FIGLINE VALDARNO",
    "FIRENZE",
    "FIRENZUOLA",
    "FUCECCHIO",
    "GAMBASSI TERME",
    "GREVE IN CHIANTI",
    "IMPRUNETA",
    "INCISA IN VAL D'ARNO",
    "LASTRA A SIGNA",
    "LONDA",
    "MARRADI",
    "MONTAIONE",
    "MONTELUPO FIORENTINO",
    "MONTESPERTOLI",
    "PALAZZUOLO SUL SENIO",
    "PELAGO",
    "PONTASSIEVE",
    "REGGELLO",
    "RIGNANO SULL'ARNO",
    "RUFINA",
    "SAN CASCIANO IN VAL DI PESA",
    "SAN GODENZO",
    "SAN PIERO A SIEVE",
    "SCANDICCI",
    "SCARPERIA",
    "SCARPERIA E SAN PIERO",
    "SESTO FIORENTINO",
    "SIGNA",
    "TAVARNELLE VAL DI PESA",
    "VAGLIA",
    "VICCHIO",
    "VINCI"
  ],
  "FC": [
    "BAGNO DI ROMAGNA",
    "BERTINORO",
    "BORGHI",
    "CASTROCARO TERME E TERRA DEL SOLE",
    "CESENA",
    "CESENATICO",
    "CIVITELLA DI ROMAGNA",
    "DOVADOLA",
    "FORLI'",
    "FORLIMPOPOLI",
    "GALEATA",
    "GAMBETTOLA",
    "GATTEO",
    "LONGIANO",
    "MELDOLA",
    "MERCATO SARACENO",
    "MODIGLIANA",
    "MONTIANO",
    "PORTICO E SAN BENEDETTO",
    "PREDAPPIO",
    "PREMILCUORE",
    "ROCCA SAN CASCIANO",
    "RONCOFREDDO",
    "SAN MAURO PASCOLI",
    "SANTA SOFIA",
    "SARSINA",
    "SAVIGNANO SUL RUBICONE",
    "SOGLIANO AL RUBICONE",
    "TREDOZIO",
    "VERGHERETO"
  ],
  "MO": [
    "BASTIGLIA",
    "BOMPORTO",
    "CAMPOGALLIANO",
    "CAMPOSANTO",
    "CARPI",
    "CASTELFRANCO EMILIA",
    "CASTELNUOVO RANGONE",
    "CASTELVETRO DI MODENA",
    "CAVEZZO",
    "CONCORDIA SULLA SECCHIA",
    "FANANO",
    "FINALE EMILIA",
    "FIORANO MODENESE",
    "FIUMALBO",
    "FORMIGINE",
    "FRASSINORO",
    "GUIGLIA",
    "LAMA MOCOGNO",
    "MARANELLO",
    "MARANO SUL PANARO",
    "MEDOLLA",
    "MIRANDOLA",
    "MODENA",
    "MONTECRETO",
    "MONTEFIORINO",
    "MONTESE",
    "NONANTOLA",
    "NOVI DI MODENA",
    "PALAGANO",
    "PAVULLO NEL FRIGNANO",
    "PIEVEPELAGO",
    "POLINAGO",
    "PRIGNANO SULLA SECCHIA",
    "RAVARINO",
    "RIOLUNATO",
    "SAN CESARIO SUL PANARO",
    "SAN FELICE SUL PANARO",
    "SAN POSSIDONIO",
    "SAN PROSPERO",
    "SASSUOLO",
    "SAVIGNANO SUL PANARO",
    "SERRAMAZZONI",
    "SESTOLA",
    "SOLIERA",
    "SPILAMBERTO",
    "VIGNOLA",
    "ZOCCA"
  ],
  "RN": [
    "BELLARIA-IGEA MARINA",
    "CASTELDELCI",
    "CATTOLICA",
    "CORIANO",
    "GEMMANO",
    "MAIOLO",
    "MISANO ADRIATICO",
    "MONDAINO",
    "MONTE COLOMBO",
    "MONTEFIORE CONCA",
    "MONTEGRIDOLFO",
    "MONTESCUDO",
    "MONTESCUDO-MONTE COLOMBO",
    "MORCIANO DI ROMAGNA",
    "NOVAFELTRIA",
    "PENNABILLI",
    "POGGIO BERNI",
    "POGGIO TORRIANA",
    "RICCIONE",
    "RIMINI",
    "SALUDECIO",
    "SAN CLEMENTE",
    "SAN GIOVANNI IN MARIGNANO",
    "SAN LEO",
    "SANT'AGATA FELTRIA",
    "SANTARCANGELO DI ROMAGNA",
    "TALAMELLO",
    "TORRIANA",
    "VERUCCHIO"
  ],
  "KR": [
    "BELVEDERE DI SPINELLO",
    "CACCURI",
    "CARFIZZI",
    "CASABONA",
    "CASTELSILANO",
    "CERENZIA",
    "CIRO'",
    "CIRO' MARINA",
    "COTRONEI",
    "CROTONE",
    "CRUCOLI",
    "CUTRO",
    "ISOLA DI CAPO RIZZUTO",
    "MELISSA",
    "MESORACA",
    "PALLAGORIO",
    "PETILIA POLICASTRO",
    "ROCCA DI NETO",
    "ROCCABERNARDA",
    "SAN MAURO MARCHESATO",
    "SAN NICOLA DELL'ALTO",
    "SANTA SEVERINA",
    "SAVELLI",
    "SCANDALE",
    "STRONGOLI",
    "UMBRIATICO",
    "VERZINO"
  ],
  "LI": [
    "BIBBONA",
    "CAMPIGLIA MARITTIMA",
    "CAMPO NELL'ELBA",
    "CAPOLIVERI",
    "CAPRAIA ISOLA",
    "CASTAGNETO CARDUCCI",
    "CECINA",
    "COLLESALVETTI",
    "LIVORNO",
    "MARCIANA",
    "MARCIANA MARINA",
    "PIOMBINO",
    "PORTO AZZURRO",
    "PORTOFERRAIO",
    "RIO",
    "RIO MARINA",
    "ROSIGNANO MARITTIMO",
    "SAN VINCENZO",
    "SASSETTA",
    "SUVERETO"
  ],
  "PI": [
    "BIENTINA",
    "BUTI",
    "CALCI",
    "CALCINAIA",
    "CAPANNOLI",
    "CASALE MARITTIMO",
    "CASCIANA TERME",
    "CASCIANA TERME LARI",
    "CASCINA",
    "CASTELFRANCO DI SOTTO",
    "CASTELLINA MARITTIMA",
    "CASTELNUOVO VAL DI CECINA",
    "CHIANNI",
    "CRESPINA",
    "CRESPINA LORENZANA",
    "FAUGLIA",
    "GUARDISTALLO",
    "LAJATICO",
    "LARI",
    "LORENZANA",
    "MONTECATINI VAL DI CECINA",
    "MONTESCUDAIO",
    "MONTEVERDI MARITTIMO",
    "MONTOPOLI IN VAL D'ARNO",
    "ORCIANO PISANO",
    "PALAIA",
    "PECCIOLI",
    "PISA",
    "POMARANCE",
    "PONSACCO",
    "PONTEDERA",
    "RIPARBELLA",
    "SAN GIULIANO TERME",
    "SAN MINIATO",
    "SANTA CROCE SULL'ARNO",
    "SANTA LUCE",
    "SANTA MARIA A MONTE",
    "TERRICCIOLA",
    "VECCHIANO",
    "VICOPISANO",
    "VOLTERRA"
  ],
  "BR": [
    "BRINDISI",
    "CAROVIGNO",
    "CEGLIE MESSAPICA",
    "CELLINO SAN MARCO",
    "CISTERNINO",
    "ERCHIE",
    "FASANO",
    "FRANCAVILLA FONTANA",
    "LATIANO",
    "MESAGNE",
    "ORIA",
    "OSTUNI",
    "SAN DONACI",
    "SAN MICHELE SALENTINO",
    "SAN PANCRAZIO SALENTINO",
    "SAN PIETRO VERNOTICO",
    "SAN VITO DEI NORMANNI",
    "TORCHIAROLO",
    "TORRE SANTA SUSANNA",
    "VILLA CASTELLI"
  ],
  "PO": [
    "CANTAGALLO",
    "CARMIGNANO",
    "MONTEMURLO",
    "POGGIO A CAIANO",
    "PRATO",
    "VAIANO",
    "VERNIO"
  ],
  "GO": [
    "CAPRIVA DEL FRIULI",
    "CORMONS",
    "DOBERDO' DEL LAGO",
    "DOLEGNA DEL COLLIO",
    "FARRA D'ISONZO",
    "FOGLIANO REDIPUGLIA",
    "GORIZIA",
    "GRADISCA D'ISONZO",
    "GRADO",
    "MARIANO DEL FRIULI",
    "MEDEA",
    "MONFALCONE",
    "MORARO",
    "MOSSA",
    "ROMANS D'ISONZO",
    "RONCHI DEI LEGIONARI",
    "SAGRADO",
    "SAN CANZIAN D'ISONZO",
    "SAN FLORIANO DEL COLLIO",
    "SAN LORENZO ISONTINO",
    "SAN PIER D'ISONZO",
    "SAVOGNA D'ISONZO",
    "STARANZANO",
    "TURRIACO",
    "VILLESSE"
  ],
  "TS": [
    "DUINO-AURISINA",
    "MONRUPINO",
    "MUGGIA",
    "SAN DORLIGO DELLA VALLE",
    "SGONICO",
    "TRIESTE"
  ]
}
